import React, { useEffect, useMemo, useState, useRef } from "react";
import { getChatPrRecords, openChatPr } from "../../../components/Chatbot/prNavigation";
import { useSelector } from "react-redux";
import HeaderTitle from "../../../components/common/HeaderTitle/HeaderTitle";
import InfoLabel from "../../../components/common/InfoLabel/InfoLabel";
import classes from "./PRTab.module.css";
import Dbutton from "../../../components/Dashboard/DashboardButtons/Dbutton";
import SuccessPopupDashboard from "../../../components/Popups/PopupFrame/SuccessPopupDashboard";
import {
  useInitialDataLoad,
  masterDataRepository,
  prRepository,
  offlineQueue,
  shouldMakeAPICall,
} from "../../../offline";

import {
  Autocomplete,
  Box,
  Button,
  Chip,
  Fade,
  FormControl,
  FormControlLabel,
  InputAdornment,
  InputLabel,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  IconButton,
  TableSortLabel,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import { Tooltip } from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CancelIcon from "@mui/icons-material/Cancel";
import CircularProgress from "@mui/material/CircularProgress";

import successPopupImg from "../../../assets/images/png/Group 2 2@2x.png";

import axios from "axios";
import { API_ENDPOINT } from "../../../services/api/resources";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import PRSampleItemsList from "../../../assets/files/PRSampleItemsList.xlsx";
import { EditNote } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import SearchBar from "../../../components/common/SearchBar/SearchBar";
import { useLocation } from "react-router-dom";
import PaginantionComponent from "../../../components/common/Pagination/PaginationComponent";

const BUDGET_UPLOAD_ACCEPT = ".csv,.xls,.xlsx";
const BUDGET_UPLOAD_ALLOWED_EXTENSIONS = ["csv", "xls", "xlsx"];
const PR_PART_NUMBER_MAX_LEN = 10;
const prPartNumberInvalidCharsRegex = /[^a-zA-Z0-9/_-]+/g;

const sanitizePrPartNumber = (value = "") => {
  return String(value || "")
    .replace(prPartNumberInvalidCharsRegex, "")
    .slice(0, PR_PART_NUMBER_MAX_LEN);
};

export const PurchaseRequisitionTab = () => {
  const [expandedRow, setExpandedRow] = React.useState(null);
  const MANUAL_REQUIRED_ERROR_MSG = "Please fill the required item details.";
  const departmentFieldRef = useRef(null);
  const renderRequiredLabel = (label) => (
    <>
      {label} <span className={classes.requiredMark}>*</span>
    </>
  );

  const getPrItemsFromRow = (row) => {
    const items = row?.items;
    return Array.isArray(items) ? items : [];
  };

  const buildPrItemsTooltipTitle = (items) => {
    const previewItems = items.slice(0, 6);
    return (
      <Box sx={{ p: 1, fontFamily: "gilroyMedium" }}>
        {previewItems.map((item, idx) => (
          <Typography
            key={String(item?.item_token ?? item?.item_mapped_token ?? idx)}
            variant="body2"
            sx={{ fontSize: "13px", fontFamily: "gilroyMedium" }}
          >
            {idx + 1}. {item?.item_name || "—"}{" "}
            {item?.item_code ? `(${item.item_code})` : ""}{" "}
            {item?.quantity ? `- Quantity: ${item.quantity}` : ""}
          </Typography>
        ))}
        {items.length > previewItems.length && (
          <Typography
            variant="body2"
            sx={{ fontSize: "13px", fontFamily: "gilroyMedium", mt: 0.5 }}
          >
            +{items.length - previewItems.length} more
          </Typography>
        )}
      </Box>
    );
  };

  const renderPrMultipleItemsCell = (row, field) => {
    const items = getPrItemsFromRow(row);
    const hasMultiple = items.length > 1;

    if (!hasMultiple) {
      const first = items[0] || {};
      return (
        <span>
          {field === "item_name"
            ? first?.item_name || "—"
            : field === "item_code"
              ? first?.item_code || "—"
              : first?.quantity || "—"}
        </span>
      );
    }

    const tooltipTitle = buildPrItemsTooltipTitle(items);

    return (
      <Tooltip
        arrow
        placement="right-start"
        title={tooltipTitle}
        componentsProps={{
          tooltip: {
            sx: {
              fontSize: "13px",
              backgroundColor: "#333",
              color: "#fff",
              borderRadius: "6px",
              p: "8px 12px",
              boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
              maxWidth: 420,
            },
          },
        }}
      >
        <span
          style={{
            cursor: "pointer",
            textDecoration: "underline",
            fontSize: "14px",
            fontFamily: "gilroyMedium",
          }}
        >
          Multiple Items
        </span>
      </Tooltip>
    );
  };

  const handleToggle = (index) => {
    setExpandedRow(expandedRow === index ? null : index);
  };
  const loginData = useSelector((state) => state.loginData.value);

  const [user_access_type] = useState(loginData?.access_type);
  const [auth_token] = useState(loginData?.auth_token);
  const [user_token] = useState(loginData?.user?.token);
  const [org_id] = useState(loginData?.user?.org_id);
  const [org_token] = useState(
    loginData?.organization_token || loginData?.org_token || loginData?.user?.organization_token || loginData?.user?.token,
  );

  const [user_details] = useState({
    shipping_address1: loginData?.user?.address_line || "",
    city: loginData?.user?.city || "",
    country: loginData?.user?.country || "",
    state: loginData?.user?.state || "",
    postal_code: loginData?.user?.postal_code || "",
    phone_number: loginData?.user?.phone_number || "",
  });

  const [proceedRFQ, setProceedRFQ] = useState(false);
  const [viewpr, setViewPR] = useState(false);

  const [glcode, setGLCode] = useState([]);
  const [constcenter, setCostCenter] = useState([]);
  const [projectcode, setProjectCode] = useState([]);
  const [selectedPRCode, setSelectedPRCode] = useState("");

  const [budgetRows, setBudgetRows] = useState([
    { costCentre: null, projectCode: null, glCode: null },
  ]);
  const createEmptyBudgetRow = () => ({
    costCentre: null,
    projectCode: null,
    glCode: null,
  });

  const [getItemMaster, setItemMaster] = useState([]);
  const [reasontext, setReasonText] = useState("");
  const [getpurchaserequestdata, setPurchaseRequestData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
	  const [purchaseRequestTotalCount, setPurchaseRequestTotalCount] = useState(0);
	  const [purchaseRequestPageCount, setPurchaseRequestPageCount] = useState(0);
	  const prListFetchAbortRef = useRef(null);
	  const recentApprovalsRef = useRef(new Map());
	  const itemSearchTimerRef = useRef(null);
  const prViewSequenceRef = useRef(0);

  // Track when we just did an optimistic update to prevent useEffect from overwriting
  const justUpdatedOptimistically = useRef(false);

  // Search and Filter states
  const [searchTerm, setSearchTerm] = useState("");
  const [chatPrSearchResult, setChatPrSearchResult] = useState(null);
  const prSearchSequence = useRef(0);
  const pendingChatPrSearch = useRef(null);
  const [statusFilter, setStatusFilter] = useState("all");
  const [chatRefreshTick, setChatRefreshTick] = useState(0);
  const [prSortConfig, setPrSortConfig] = useState({
    key: "created_on",
    direction: "desc",
  });
  const [departmentError, setDepartmentError] = useState("");
  const [manualItemErrors, setManualItemErrors] = useState({});
  const [editingUnitPrice, setEditingUnitPrice] = useState({});

	  const shouldUseServerPagination =
	    shouldMakeAPICall(auth_token, user_token) &&
	    auth_token &&
	    user_token &&
	    org_id;

	  const wasServerPaginationEnabled = useRef(false);

	  useEffect(() => {
	    if (!shouldUseServerPagination) {
	      wasServerPaginationEnabled.current = false;
	      return;
	    }

	    // When switching into server-pagination, lock rowsPerPage to 10 and start from page 0.
	    if (rowsPerPage !== 10) setRowsPerPage(10);
	    if (!wasServerPaginationEnabled.current && page !== 0) setPage(0);
	    wasServerPaginationEnabled.current = true;
	  }, [shouldUseServerPagination, rowsPerPage, page]);

  const [getpurchasecode, setPurchaseCode] = useState([]);
  const [getuserlist, setUserList] = useState([]);
  const [loadingPR, setLoadingPR] = useState(false);

  const [items, setItems] = useState([
    {
      itemToken: "",
      itemName: "",
      itemNameInput: "",
      itemCode: "",
      itemCodeInput: "",
      category: "",
      expenseType: "",
      subCategory: "",
      itemType: "",
      quantity: "",
      unit: "",
      hsnCode: "",
      unspscCode: "",
      brand: "",
      manufacturerPartNo: "",
      specifications: "",
      aliases: "",
      gstList: [],
      description: "",
      unitPrice: "",
      totalPrice: "",
    },
  ]);

  const [vendorsList, setVendorsList] = useState({
    values: {
      tokens: [],
      visibleOption: [],
    },
  });
  const [buyerUserDetails, setBuyerUserDetails] = useState({});
  const [selectedApprovers, setSelectedApprovers] = useState([]);
  const [hasMappedPRs, setHasMappedPRs] = useState(false);
  const [inputMethod, setInputMethod] = useState("xls");
  const [fileUpload, setFileUpload] = useState(null);
  const [dragging, setDragging] = useState(false);
  const [budgetInputMethod, setBudgetInputMethod] = useState("manual");
  const [budgetUploadFile, setBudgetUploadFile] = useState(null);
  const [budgetUploadError, setBudgetUploadError] = useState("");
  const [budgetDragging, setBudgetDragging] = useState(false);
  const itemFileInputRef = useRef(null);
  const budgetFileInputRef = useRef(null);
  const [viewraisedpr, setViewRaisedPR] = useState(false);
  const [getuserpopupherotext, setUserPopupHeroText] = useState("");
  const [getuserpopupdescription, setUserPopupdescription] = useState("");
  const [successpopup, setSuccessPopUp] = useState(false);
  const [editpr, setEditPR] = useState(false);
  const [getprtoken, setPRToken] = useState({ pr_token: "" });
  const [loadingPRs, setLoadingPRs] = useState(true);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [departmentList, setDepartmentList] = useState([]);
  const [departmentLoading, setDepartmentLoading] = useState(false);
  const departmentRequestRef = useRef(null);
  const [budgetConfig, setBudgetConfig] = useState(null);
  const [budgetConfigLoading, setBudgetConfigLoading] = useState(false);
  const [budgetLimitError, setBudgetLimitError] = useState("");
  const [prCode, setPRCode] = useState("");
  const [fileuploadError, setFileuploadError] = useState("");
  const [prDate, setPRDate] = useState(null);

  const location = useLocation();

  useEffect(() => {
    const statusFromDashboard = location?.state?.status;
    if (!statusFromDashboard) return;

    const normalizedStatus = String(statusFromDashboard).trim().toLowerCase();
    const dashboardStatusMap = {
      approved: "1",
      pending: "2",
      rejected: "3",
      cancelled: "3",
    };
    setStatusFilter(dashboardStatusMap[normalizedStatus] || "all");
    setPage(0);
  }, [location?.state?.status]);

  const queueChatPrRefresh = () => {
    setSearchTerm("");
    setStatusFilter("all");
    setPage(0);
    setProceedRFQ(false);
    setViewPR(false);
    setViewRaisedPR(false);
    setEditPR(false);
    setPRToken({ pr_token: "" });
    setChatRefreshTick((prev) => prev + 1);
  };

  const unitsOptions = [
    "Assemblies",
    "Dozen",
    "Each",
    "Feet",
    "Gallons",
    "Kilo",
    "Liters",
    "Metric Tons",
    "Meters",
    "Pieces",
    "Pounds",
    "Sets",
    "Tons",
    "Yards",
  ];

  const currentYear = new Date().getFullYear();
  const nextYear = currentYear + 1;
  const financialYear = `${currentYear}-${nextYear}`;
  const budgetFinancialYear = `${currentYear}-${String(nextYear).slice(-2)}`;
  const currentMonth = new Date()
    .toLocaleString("en-US", { month: "short" })
    .toUpperCase();
  const isBudgetBulkUpload = budgetInputMethod === "bulk";

  const getPRResponsePageCount = (payload = {}) => {
    const pageCount = Number(
      payload?.page_count ?? payload?.pagination?.page_count ?? 0,
    );
    return Number.isFinite(pageCount) && pageCount > 0 ? pageCount : 0;
  };

  const getPRResponseTotalCount = (payload = {}, fallbackLength = 0) => {
    const explicitTotal = Number(
      payload?.count ??
        payload?.total_records ??
        payload?.total ??
        payload?.total_count ??
        payload?.pagination?.total_records ??
        payload?.pagination?.total_count ??
        0,
    );

    if (Number.isFinite(explicitTotal) && explicitTotal > 0) {
      return explicitTotal;
    }

    const pageCount = getPRResponsePageCount(payload);
    const currentPage = Number(
      payload?.current_page ?? payload?.pagination?.current_page ?? 0,
    );
    const itemsPerPage = Number(
      payload?.items_per_page ??
        payload?.current_page_count ??
        payload?.pagination?.items_per_page ??
        payload?.pagination?.current_page_count ??
        0,
    );
    const currentPageCount = Number(
      payload?.current_page_count ??
        payload?.pagination?.current_page_count ??
        fallbackLength ??
        0,
    );

    if (
      Number.isFinite(pageCount) &&
      pageCount > 0 &&
      Number.isFinite(currentPage) &&
      currentPage > 0 &&
      currentPage === pageCount &&
      Number.isFinite(itemsPerPage) &&
      itemsPerPage > 0 &&
      Number.isFinite(currentPageCount) &&
      currentPageCount >= 0
    ) {
      return (pageCount - 1) * itemsPerPage + currentPageCount;
    }

    if (
      Number.isFinite(pageCount) &&
      pageCount > 0 &&
      Number.isFinite(itemsPerPage) &&
      itemsPerPage > 0
    ) {
      return pageCount * itemsPerPage;
    }

    return Number.isFinite(fallbackLength) ? fallbackLength : 0;
  };

  const getPRCreatedDate = (pr) =>
    pr?.created_on ||
    pr?.created_date ||
    pr?.request_date ||
    pr?.date ||
    pr?.date_of_request ||
    "";

  const sortPRsByCreatedDateDesc = (prs = []) => {
    const toTime = (value) => {
      const parsed = new Date(value || 0);
      const time = parsed.getTime();
      return Number.isNaN(time) ? 0 : time;
    };
    return [...prs].sort(
      (a, b) => toTime(getPRCreatedDate(b)) - toTime(getPRCreatedDate(a)),
    );
  };

  const getItemFieldValue = (option, primaryField) => {
    if (primaryField === "item_name") {
      return String(option?.item_name ?? option?.itemName ?? "").trim().toLowerCase();
    }

    if (primaryField === "item_code") {
      return String(option?.item_code ?? option?.itemCode ?? "").trim().toLowerCase();
    }

    return String(option?.[primaryField] || "").trim().toLowerCase();
  };

  const getFilteredItemOptions = (primaryField, queryValue, sourceOptions = getItemMaster) => {
    const query = String(queryValue || "")
      .trim()
      .toLowerCase();

    const normalizedSource = Array.isArray(sourceOptions) ? sourceOptions : [];

    if (!query) return normalizedSource;

    const seen = new Set();
    return normalizedSource
      .filter((opt) => {
        const text = getItemFieldValue(opt, primaryField);
        return text.startsWith(query);
      })
      .sort((a, b) => {
        const aText = getItemFieldValue(a, primaryField);
        const bText = getItemFieldValue(b, primaryField);
        const aStarts = aText.startsWith(query);
        const bStarts = bText.startsWith(query);
        if (aStarts !== bStarts) return aStarts ? -1 : 1;
        return aText.localeCompare(bText);
      })
      .filter((opt) => {
        const key = `${String(opt?.token || opt?.item_token || "")}-${String(opt?.[primaryField] || "")}`;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
  };

	  // Filter the data based on search term and status filter
	  const filteredPRs = useMemo(() => {
	    if (
	      !Array.isArray(getpurchaserequestdata) ||
	      getpurchaserequestdata.length === 0
	    ) {
	      return [];
	    }

	    // In server-pagination mode, backend is the source of truth for filtering (including `search`).
	    if (shouldUseServerPagination) {
	      return getpurchaserequestdata;
	    }
	
	    const filtered = getpurchaserequestdata.filter((pr) => {
	      // Search filter
	      const query = String(searchTerm || "").toLowerCase();
      const items = Array.isArray(pr.items) ? pr.items : [];
      const matchesItems =
        query === "" ||
        items.some((it) => {
          const itemName = String(it?.item_name || "").toLowerCase();
          const itemCode = String(it?.item_code || "").toLowerCase();
          return itemName.includes(query) || itemCode.includes(query);
        });

      const matchesSearch =
        query === "" ||
        pr.pr_code?.toLowerCase().includes(query) ||
        matchesItems ||
        pr.buyer_name?.toLowerCase().includes(query);

      // Status filter
      let matchesStatus = true;
      if (statusFilter !== "all") {
        if (statusFilter === "1") {
          matchesStatus = pr.pr_approval_status === "Approved";
        } else if (statusFilter === "2") {
          matchesStatus = pr.pr_approval_status === "Pending";
        } else if (statusFilter === "3") {
          matchesStatus =
            pr.pr_approval_status === "Rejected" ||
            pr.pr_approval_status === "Cancelled";
        }
      }

      return matchesSearch && matchesStatus;
    });

    // Debug logging
    const newPRs = filtered.filter((pr) => pr._pendingSync || pr._tempToken);
    if (newPRs.length > 0) {
      console.log(
        "🔍 Filtered PRs - New PRs found:",
        newPRs.map((pr) => ({
          pr_code: pr.pr_code,
          pr_token: pr.pr_token,
          matches_search:
            searchTerm === "" ||
            pr.pr_code?.toLowerCase().includes(searchTerm.toLowerCase()),
          matches_status:
            statusFilter === "all" ||
            pr.pr_approval_status ===
              (statusFilter === "2"
                ? "Pending"
                : statusFilter === "1"
                  ? "Approved"
                  : ""),
          approval_status: pr.pr_approval_status,
        })),
      );
    }

    console.log("🔍 Filtered PRs:", {
      total: getpurchaserequestdata.length,
      filtered: filtered.length,
      searchTerm,
      statusFilter,
      newPRs_count: newPRs.length,
    });
	
	    return filtered;
	  }, [getpurchaserequestdata, searchTerm, statusFilter, shouldUseServerPagination]);

  const sortedFilteredPRs = useMemo(() => {
    if (!Array.isArray(filteredPRs) || filteredPRs.length === 0) return [];
    // In server-pagination mode, backend controls the order. Don't re-sort the page client-side.
    if (shouldUseServerPagination) return filteredPRs;

    const { key, direction } = prSortConfig || {};
    const dir = direction === "asc" ? 1 : -1;

    const getValue = (pr) => {
      switch (key) {
        case "pr_code":
          return String(pr?.pr_code || "").toLowerCase();
        case "item_name":
          return String(pr?.items?.[0]?.item_name || "").toLowerCase();
        case "item_code":
          return String(pr?.items?.[0]?.item_code || "").toLowerCase();
        case "quantity":
          return Number.parseFloat(pr?.items?.[0]?.quantity) || 0;
        case "buyer_name":
          return String(pr?.buyer_name || "").toLowerCase();
        case "created_on": {
          const t = Date.parse(pr?.created_on);
          return Number.isFinite(t) ? t : 0;
        }
        case "status":
          return String(pr?.pr_approval_status || "").toLowerCase();
        default:
          return "";
      }
    };

    const indexed = filteredPRs.map((pr, idx) => ({ pr, idx }));
    indexed.sort((a, b) => {
      const va = getValue(a.pr);
      const vb = getValue(b.pr);

      if (va < vb) return -1 * dir;
      if (va > vb) return 1 * dir;
      return a.idx - b.idx;
    });

    return indexed.map((x) => x.pr);
  }, [filteredPRs, prSortConfig, shouldUseServerPagination]);

  const handlePRSortRequest = (key) => {
    setPrSortConfig((prev) => {
      if (!prev || prev.key !== key) return { key, direction: "asc" };
      return { key, direction: prev.direction === "asc" ? "desc" : "asc" };
    });
  };

  // Paginate the filtered results
  const paginatedPurchaseRequests = useMemo(() => {
    if (sortedFilteredPRs.length === 0) {
      console.log("🔍 No filtered PRs to paginate");
      return [];
    }

    if (shouldUseServerPagination) {
      return sortedFilteredPRs;
    }

    if (!rowsPerPage || rowsPerPage < 0) {
      return sortedFilteredPRs;
    }

    const start = page * rowsPerPage;
    const paginated = sortedFilteredPRs.slice(start, start + rowsPerPage);

    // Debug: Check if new PR is in paginated results
    const newPRsInPage = paginated.filter(
      (pr) => pr._pendingSync || pr._tempToken,
    );
    if (newPRsInPage.length > 0) {
      console.log(
        "✅ New PR found in paginated results:",
        newPRsInPage.map((pr) => pr.pr_code),
      );
    } else {
      const newPRsInFiltered = sortedFilteredPRs.filter(
        (pr) => pr._pendingSync || pr._tempToken,
      );
      if (newPRsInFiltered.length > 0) {
        console.log(
          "⚠️ New PR is in filteredPRs but not in current page. Page:",
          page,
          "Total filtered:",
          sortedFilteredPRs.length,
        );
      }
    }

    return paginated;
  }, [sortedFilteredPRs, page, rowsPerPage, shouldUseServerPagination]);

  // Reset page when filters change
  useEffect(() => {
    setPage(0);
  }, [searchTerm, statusFilter, prSortConfig?.key, prSortConfig?.direction]);

  // When searching (client-side) ensure we have a fresh full dataset online.
  useEffect(() => {
    if (proceedRFQ) return;
    if (shouldUseServerPagination) return; // server-pagination handles its own fetch
    if (!String(searchTerm || "").trim()) return;
    getAllPurchaseRequest(0);
  }, [searchTerm, proceedRFQ, shouldUseServerPagination, auth_token, user_token]);

  // When status filter changes (client-side mode), fetch filtered data from backend.
  useEffect(() => {
    if (proceedRFQ) return;
    if (shouldUseServerPagination) return; // server-pagination handles its own fetch
    if (statusFilter === "all") return;
    if (!shouldMakeAPICall(auth_token, user_token)) return;

    getAllPurchaseRequest(0);
  }, [statusFilter, proceedRFQ, shouldUseServerPagination, auth_token, user_token]);

  // Debug: Log when getpurchaserequestdata changes
  useEffect(() => {
    const newPRs = getpurchaserequestdata.filter(
      (pr) => pr._pendingSync || pr._tempToken,
    );
    if (newPRs.length > 0) {
      console.log("🔍 State changed - New PRs in getpurchaserequestdata:", {
        total_prs: getpurchaserequestdata.length,
        new_prs_count: newPRs.length,
        new_prs: newPRs.map((pr) => ({
          pr_code: pr.pr_code,
          pr_token: pr.pr_token,
          approval_status: pr.pr_approval_status,
          buyer_name: pr.buyer_name,
          has_items: pr.items?.length > 0,
        })),
      });
    }
  }, [getpurchaserequestdata]);

  // Debug: Log when filteredPRs changes
  useEffect(() => {
    const newPRsInFiltered = filteredPRs.filter(
      (pr) => pr._pendingSync || pr._tempToken,
    );
    if (newPRsInFiltered.length > 0) {
      console.log("✅ New PR found in filteredPRs:", {
        filtered_total: filteredPRs.length,
        new_prs: newPRsInFiltered.map((pr) => pr.pr_code),
      });
    } else {
      const newPRsInState = getpurchaserequestdata.filter(
        (pr) => pr._pendingSync || pr._tempToken,
      );
      if (newPRsInState.length > 0) {
        console.warn("⚠️ New PR is in state but NOT in filteredPRs!", {
          state_total: getpurchaserequestdata.length,
          filtered_total: filteredPRs.length,
          new_prs_in_state: newPRsInState.map((pr) => ({
            pr_code: pr.pr_code,
            approval_status: pr.pr_approval_status,
            statusFilter,
            searchTerm,
          })),
        });
      }
    }
  }, [filteredPRs, getpurchaserequestdata, statusFilter, searchTerm]);

  const generatePRCode = (sourceCodes = null) => {
    const codesSource =
      Array.isArray(sourceCodes) && sourceCodes.length > 0
        ? sourceCodes
        : Array.isArray(getpurchasecode) && getpurchasecode.length > 0
          ? getpurchasecode
          : getpurchaserequestdata;

    const pr_code =
      codesSource
        ?.map((rfq) => {
          const codeValue = rfq?.pr_code || "";
          const match = codeValue.match(
            /PR-(\d+)\/([^\/]+)\/([\d-]+)\/([A-Z]+)/,
          );
          if (match) {
            return {
              number: parseInt(match[1], 10),
            };
          }
          return null;
        })
        .filter((item) => item !== null) || [];

    const nextPRCode =
      pr_code.length > 0
        ? Math.max(...pr_code.map((item) => item.number)) + 1
        : 1;

    const padded = String(nextPRCode).padStart(3, "0");
    return `PR-${padded}/${loginData.user.company_name}/${financialYear}/${currentMonth}`;
  };

  const departmentDropDown = () => {
    const isDisabled = viewpr && !editpr;
    return (
      <div ref={departmentFieldRef}>
        <Autocomplete
          disablePortal
          options={departmentList}
	          loading={departmentLoading}
	          getOptionLabel={(option) => option?.name || ""}
	          value={selectedDepartment}
	          onChange={(e, newVal) => {
	            const prevDept = selectedDepartment;
	            setSelectedDepartment(newVal);
	            setBudgetConfig(null);
	            setBudgetLimitError("");
	            if (newVal) setDepartmentError("");

	          const isSameDepartment = (a, b) => {
	            if (!a && !b) return true;
	            if (!a || !b) return false;
	            if (a?.id && b?.id) return a.id === b.id;
	            return String(a?.name || "") === String(b?.name || "");
	          };

	          // Department drives budget selection; changing department must clear budget.
	          if (!isDisabled && !isSameDepartment(prevDept, newVal)) {
	            setBudgetRows([
	              { costCentre: null, projectCode: null, glCode: null },
	            ]);
	            setBudgetUploadFile(null);
	            setBudgetUploadError("");
	            setBudgetDragging(false);
	            resetBudgetUploadInput();
	          }

	            if (newVal && !isDisabled) fetchBudgetConfig(newVal.name);
	          }}
	          isOptionEqualToValue={(option, value) => {
	          // Compare by id if available, otherwise by name
	          if (option?.id && value?.id) {
	            return option.id === value.id;
          }
          return option?.name === value?.name;
        }}
          sx={{ width: "100%", minWidth: 220, m: 0 }}
          disabled={isDisabled}
          renderInput={(params) => (
            <TextField
              {...params}
              required
              placeholder="Select department"
              error={!isDisabled && Boolean(departmentError)}
              helperText={!isDisabled ? departmentError : ""}
              sx={{
                "& .MuiInputBase-root": {
                  fontFamily: "gilroyMedium",
                  fontSize: "14px",
                  color: "#1B2A41",
                  borderRadius: "8px",
                },
                "& .MuiAutocomplete-popupIndicator": {
                  color: "#2563EB",
                },
                "& .MuiAutocomplete-option": {
                  fontFamily: "gilroyMedium",
                  fontSize: "14px",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#2563EB",
                  borderWidth: "1.5px",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#1D4ED8",
                },
                "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#1D4ED8",
                  borderWidth: "2px",
                },
                "& .MuiFormHelperText-root": {
                  fontSize: "14px",
                  fontFamily: "gilroyMedium",
                  marginLeft: 0,
                },
              }}
            />
          )}
        />
      </div>
    );
  };

  const fetchBudgetConfig = async (departmentName) => {
    if (!departmentName) return;
    try {
      setBudgetConfigLoading(true);
      const response = await axios.post(
        API_ENDPOINT.get_budget_config,
        {
          department_name: departmentName,
          financial_year: budgetFinancialYear,
        },
        { headers: { Authorization: `Bearer ${auth_token}` } },
      );
      setBudgetConfig(response?.data?.results?.[0] || null);
    } catch (error) {
      setBudgetConfig(null);
    } finally {
      setBudgetConfigLoading(false);
    }
  };

  const formatBudgetAmount = (amount) => {
    if (amount === null || amount === undefined || amount === "") return "-";
    const currencySymbol = { INR: "₹", USD: "$", EUR: "€", GBP: "£" }[
      budgetConfig?.currency
    ] || `${budgetConfig?.currency || ""} `;
    const numericAmount = Number(amount);
    return Number.isFinite(numericAmount)
      ? `${currencySymbol}${numericAmount.toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`
      : `${currencySymbol}${amount}`;
  };

  const infoLabelDetails = [
    {
      label: "Requisition Code",
      value: viewpr ? selectedPRCode : prCode,
    },
    {
      label: "Date of Request",
      value:
        (viewpr || editpr) && prDate
          ? (() => {
              try {
                // If prDate is already in "DD MMMM YYYY" format, return as-is
                if (
                  typeof prDate === "string" &&
                  /^\d{1,2}\s+\w+\s+\d{4}$/i.test(prDate.trim())
                ) {
                  return prDate;
                }

                // Otherwise, try to parse as Date
                const date = new Date(prDate);
                if (!isNaN(date.getTime())) {
                  return date.toLocaleDateString("en-GB", {
                    day: "numeric",
                    month: "long",
                    year: "numeric",
                  });
                }

                // Fallback to current date if parsing fails
                return new Date().toLocaleDateString("en-GB", {
                  day: "numeric",
                  month: "long",
                  year: "numeric",
                });
              } catch (error) {
                console.error("Error parsing date:", error);
                return new Date().toLocaleDateString("en-GB", {
                  day: "numeric",
                  month: "long",
                  year: "numeric",
                });
              }
            })()
          : new Date().toLocaleDateString("en-GB", {
              day: "numeric",
              month: "long",
              year: "numeric",
            }),
      size: "100%",
    },
    {
      label: "Requested By",
      value: viewpr
        ? buyerUserDetails?.first_name || ""
        : loginData?.user?.first_name,
      size: "100%",
    },
    {
      label: "Email",
      value: viewpr ? buyerUserDetails?.email || "" : loginData?.user?.email,
      size: "100%",
    },
    {
      label: "Contact Number",
      value: viewpr
        ? buyerUserDetails?.phone_number || ""
        : loginData?.user?.phone_number,
      size: "100%",
    },
    {
      label: "Address",
      value: user_details.shipping_address1 || "-",
      size: "100%",
    },
    {
      label: "City",
      value: user_details.city || "-",
      size: "100%",
    },
    {
      label: "State",
      value: user_details.state || "-",
      size: "100%",
    },
    {
      label: "Country",
      value: user_details.country || "-",
      size: "100%",
    },
    {
      label: "Postal Code",
      value: user_details.postal_code || "-",
      size: "100%",
    },
  ];

  const budgetSummaryDetails = [
    {
      label: renderRequiredLabel("Department"),
      value: departmentDropDown(),
      size: "100%",
    },
    ...(selectedDepartment
      ? [
          {
            label: "Budget Category",
            value: budgetConfigLoading
              ? "Loading..."
              : budgetConfig?.purchase_type || "-",
            size: "100%",
          },
          {
            label: "Total Budget",
            value: formatBudgetAmount(budgetConfig?.allocated_amount),
            size: "100%",
            className: classes.budgetAmountCard,
          },
          {
            label: "Budget Spent",
            value: formatBudgetAmount(budgetConfig?.balance_amount),
            size: "100%",
            className: classes.budgetAmountCard,
          },
        ]
      : []),
  ];

  const costcentreRequest = async () => {
    try {
      const response = await axios({
        url: `${API_ENDPOINT.cost_center_list}`,
        method: "POST",
        data: {
          buyer_token: user_token,
        },
        headers: {
          Authorization: `Bearer ${auth_token}`,
        },
      });

      const data = response?.data?.data || [];
      setCostCenter(data);
      return data;
    } catch (error) {
      console.error("Error fetching RFQs:", error);
      setCostCenter([]);
      return [];
    }
  };

  const glcodeRequest = async () => {
    try {
      const response = await axios({
        url: `${API_ENDPOINT.gl_code_list}`,
        method: "POST",
        data: {
          buyer_token: user_token,
        },
        headers: {
          Authorization: `Bearer ${auth_token}`,
        },
      });

      const data = Array.isArray(response?.data?.data)
        ? response.data.data
        : Array.isArray(response?.data?.results)
          ? response.data.results
          : [];
      setGLCode(data);
      return data;
    } catch (error) {
      console.error("Error fetching RFQs:", error);
      setGLCode([]);
      return [];
    }
  };

  const projectCodeRequest = async () => {
    try {
      const response = await axios({
        url: `${API_ENDPOINT.projects_list}`,
        method: "POST",
        data: {
          buyer_token: user_token,
        },
        headers: {
          Authorization: `Bearer ${auth_token}`,
        },
      });

      const data = Array.isArray(response?.data?.data)
        ? response.data.data
        : Array.isArray(response?.data?.results)
          ? response.data.results
          : [];
      setProjectCode(data);
      return data;
    } catch (error) {
      console.error("Error fetching RFQs:", error);
      setProjectCode([]);
      return [];
    }
  };

  const getAllItems = async (searchValue = "") => {
    try {
      const normalizedSearch = String(searchValue || "").trim();
      const orgToken = loginData?.user?.token || user_token || "";
      const requestBody = { org_token: orgToken };

      if (normalizedSearch) {
        requestBody.search = normalizedSearch;
      }

      const response = await axios.post(
        `${API_ENDPOINT.view_all_item}`,
        requestBody,
        { headers: { Authorization: `Bearer ${auth_token}` } },
      );

      if (Array.isArray(response.data?.response)) {
        setItemMaster(response.data.response);
        return response.data.response;
      } else {
        console.error("API response is not an array:", response.data);
        setItemMaster([]);
        return [];
      }
    } catch (error) {
      console.error("Error fetching items:", error);
      setItemMaster([]);
      return [];
    }
  };

  const scheduleItemSearch = (searchValue = "") => {
    if (itemSearchTimerRef.current) {
      clearTimeout(itemSearchTimerRef.current);
    }

    itemSearchTimerRef.current = setTimeout(() => {
      void getAllItems(searchValue);
    }, 300);
  };

  const getAllPurchaseRequest = async (pageIndex0Based = 0) => {
    const sequence = ++prSearchSequence.current;
    const query = String(searchTerm || "").trim();
    const records = await fetchPurchaseRequestPage(pageIndex0Based);
    if (sequence === prSearchSequence.current) {
      setChatPrSearchResult({ sequence, query, status: statusFilter, page: pageIndex0Based, records: records || [] });
    }
    return records;
  };

  const fetchPurchaseRequestPage = async (pageIndex0Based = 0) => {
    try {
      setLoadingPRs(true);

      // OFFLINE MODE: Load from cache first
      if (!shouldMakeAPICall(auth_token, user_token)) {
        console.log("📴 Offline mode - loading PRs from cache");
        const cachedPRs = await prRepository.getAllFromCache();
        setPurchaseRequestData(sortPRsByCreatedDateDesc(cachedPRs));
        setPurchaseRequestTotalCount(
          Array.isArray(cachedPRs) ? cachedPRs.length : 0,
        );
        setPurchaseRequestPageCount(
          Math.max(
            1,
            Math.ceil((Array.isArray(cachedPRs) ? cachedPRs.length : 0) / 10),
          ),
        );
        setLoadingPRs(false);
        return cachedPRs;
      }

      const statusPayload = (() => {
        const v = String(statusFilter || "").trim();
        if (v === "1") return { status: "approved" };
        if (v === "2") return { status: "pending" };
        if (v === "3") return { status: "rejected" };
        return {};
      })();

      const requestData =
        loginData?.access_type === "Buyer"
          ? { org_id, ...statusPayload }
          : { user_token, ...statusPayload };

      // NOTE: Backend sorts before pagination for global ordering.
      // Keep these keys in sync with backend implementation.
	      const backendSortKeyMap = {
	        pr_code: "pr_code",
	        item_name: "item_name",
	        item_code: "item_code",
	        quantity: "quantity",
	        buyer_name: "buyer_name",
	        created_on: "created_date",
	        status: "pr_approval_status",
	      };
	      const sort_key = backendSortKeyMap[prSortConfig?.key] || "created_date";
      const sort_order = prSortConfig?.direction === "asc" ? "asc" : "desc";

	      // SERVER PAGINATION MODE: Fetch only the selected page
	      if (shouldUseServerPagination) {
        if (prListFetchAbortRef.current) {
          try {
            prListFetchAbortRef.current.abort();
          } catch (_) {
            // ignore
          }
        }
        const controller = new AbortController();
        prListFetchAbortRef.current = controller;

	        const buildCombinedPayload = (base) => ({
	          ...base,
	          page: Number(pageIndex0Based) + 1,
	          ...(String(searchTerm || "").trim()
	            ? { search: String(searchTerm || "").trim() }
	            : {}),
	          sort_key,
	          sort_order,
	        });

	        const combinedResponse = await axios({
	          url: `${API_ENDPOINT.combined_saved_pr_with_items_view}`,
	          method: "POST",
	          data: buildCombinedPayload(requestData),
	          headers: { Authorization: `Bearer ${auth_token}` },
	          signal: controller.signal,
	        });
	        const purchaseRequests = getChatPrRecords(combinedResponse?.data);

	        const transformedPRs = prRepository.transformCombinedPRData(purchaseRequests);
	        const resolvedPageCount = getPRResponsePageCount(combinedResponse?.data);
	        const count = getPRResponseTotalCount(
	          combinedResponse?.data,
	          transformedPRs.length,
	        );
	        // Don't re-sort on client in server-pagination mode; backend order is the source of truth.
	        setPurchaseRequestData(applyRecentApprovalOverrides(transformedPRs));
	        setPurchaseRequestTotalCount(count || transformedPRs.length || 0);
	        setPurchaseRequestPageCount(
	          resolvedPageCount ||
	            Math.max(
	              1,
	              Math.ceil(
	                (count || transformedPRs.length || 0) / Math.max(rowsPerPage || 10, 1),
	              ),
	            ),
	        );

        // Keep cache in sync even in server-pagination mode (merge page into cache)
        prRepository
          .getAllFromCache()
          .then((existing) => {
            const cacheMap = new Map(
              (Array.isArray(existing) ? existing : []).map((pr) => [
                pr.pr_token,
                pr,
              ]),
            );

            transformedPRs.forEach((pr) => {
              const existingPR = cacheMap.get(pr.pr_token);
              if (!existingPR?._pendingSync) {
                cacheMap.set(pr.pr_token, pr);
              }
            });

            return prRepository.saveToCache(Array.from(cacheMap.values()));
          })
          .catch(() => {
            // ignore cache sync errors
          });

        return transformedPRs;
      }

      // Try combined API first (has all items and full details)
      try {
        const combinedResponse = await axios({
          url: `${API_ENDPOINT.combined_saved_pr_with_items_view}`,
          method: "POST",
          data: requestData,
          headers: {
            Authorization: `Bearer ${auth_token}`,
          },
        });

        // Transform data to add missing fields
        const purchaseRequests =
          getChatPrRecords(combinedResponse?.data);
        const transformedPRs =
          prRepository.transformCombinedPRData(purchaseRequests);
        const count = getPRResponseTotalCount(
          combinedResponse?.data,
          transformedPRs.length,
        );
        const resolvedPageCount = getPRResponsePageCount(combinedResponse?.data);

        // Preserve optimistic updates: merge with existing cache to keep pending sync PRs
        const existingCache = await prRepository.getAllFromCache();
        const cacheMap = new Map(existingCache.map((pr) => [pr.pr_token, pr]));

        // Update cache map with API data, but preserve PRs with pending sync
        transformedPRs.forEach((pr) => {
          const existingPR = cacheMap.get(pr.pr_token);
          // Only overwrite if PR doesn't have pending sync
          if (!existingPR?._pendingSync) {
            cacheMap.set(pr.pr_token, pr);
          } else {
            console.log(
              `📱 Preserving optimistic update for PR: ${pr.pr_code}`,
            );
          }
        });

        const mergedPRs = Array.from(cacheMap.values());
        const sortedPRs = sortPRsByCreatedDateDesc(mergedPRs);
        setPurchaseRequestData(sortedPRs);
        setPurchaseRequestTotalCount(count || sortedPRs.length);
        setPurchaseRequestPageCount(
          resolvedPageCount ||
            Math.max(
              1,
              Math.ceil((count || sortedPRs.length || 0) / Math.max(rowsPerPage || 10, 1)),
            ),
        );

        const isUserInApprovers = mergedPRs.some((pr) =>
          pr.approvers?.some(
            (approver) => approver.name === loginData?.user?.first_name,
          ),
        );
        setHasMappedPRs(isUserInApprovers);

        // Cache the merged data (preserving optimistic updates) - don't block UI on IndexedDB writes
        prRepository.saveToCache(sortedPRs);

        return sortedPRs;
      } catch (combinedError) {
        console.warn(
          "Combined API failed, falling back to cache or regular API:",
          combinedError,
        );

        // If network error, use cache
        if (
          combinedError.code === "ERR_NETWORK" ||
          combinedError.code === "ERR_CONNECTION_REFUSED"
        ) {
          console.log("📴 Network error - loading from cache");
          const cachedPRs = await prRepository.getAllFromCache();
          setPurchaseRequestData(sortPRsByCreatedDateDesc(cachedPRs));
          setPurchaseRequestTotalCount(
            Array.isArray(cachedPRs) ? cachedPRs.length : 0,
          );
          setLoadingPRs(false);
          return cachedPRs;
        }

        // Fallback to regular API
        try {
          const response = await axios({
            url: `${API_ENDPOINT.get_saved_prs}`,
            method: "POST",
            data: requestData,
            headers: {
              Authorization: `Bearer ${auth_token}`,
            },
          });

          const data = response?.data || [];

          // Preserve optimistic updates when using fallback API
          const existingCache = await prRepository.getAllFromCache();
          const cacheMap = new Map(
            existingCache.map((pr) => [pr.pr_token, pr]),
          );

          data.forEach((pr) => {
            const existingPR = cacheMap.get(pr.pr_token);
            if (!existingPR?._pendingSync) {
              cacheMap.set(pr.pr_token, pr);
            }
          });

          const mergedPRs = Array.from(cacheMap.values());
          const sortedPRs = sortPRsByCreatedDateDesc(mergedPRs);
          setPurchaseRequestData(sortedPRs);
          setPurchaseRequestTotalCount(sortedPRs.length);

          const isUserInApprovers = mergedPRs.some((pr) =>
            pr.approvers?.some(
              (approver) => approver.name === loginData?.user?.first_name,
            ),
          );
          setHasMappedPRs(isUserInApprovers);

          // Cache fallback data to keep offline dashboard in sync (don't block UI)
          prRepository.saveToCache(sortedPRs);

          return sortedPRs;
        } catch (fallbackError) {
          console.error(
            "Fallback API also failed, using cache:",
            fallbackError,
          );
          const cachedPRs = await prRepository.getAllFromCache();
          setPurchaseRequestData(sortPRsByCreatedDateDesc(cachedPRs));
          setPurchaseRequestTotalCount(
            Array.isArray(cachedPRs) ? cachedPRs.length : 0,
          );
          return cachedPRs;
        }
      }
    } catch (error) {
      console.error("Error fetching PRs:", error);
      return [];
    } finally {
      setLoadingPRs(false);
    }
  };

  const normalizeName = (value) =>
    String(value ?? "")
      .trim()
      .replace(/\s+/g, " ")
      .toLowerCase();

  const selectedDepartmentNameNormalized = useMemo(
    () => normalizeName(selectedDepartment?.name),
    [selectedDepartment],
  );

  const filteredCostCenters = useMemo(() => {
    if (!selectedDepartmentNameNormalized) return [];
    return (constcenter || []).filter((cc) => {
      const dept = normalizeName(cc?.department || cc?.dept_name || cc?.department_name);
      return dept && dept === selectedDepartmentNameNormalized;
    });
  }, [constcenter, selectedDepartmentNameNormalized]);

  const filteredGLCodes = useMemo(() => {
    if (!selectedDepartmentNameNormalized) return [];
    return (glcode || []).filter((gl) => {
      const dept = normalizeName(gl?.department || gl?.dept_name || gl?.department_name);
      return dept && dept === selectedDepartmentNameNormalized;
    });
  }, [glcode, selectedDepartmentNameNormalized]);

  const filteredProjectCodes = useMemo(() => {
    if (!selectedDepartmentNameNormalized) return [];
    return (projectcode || []).filter((p) => {
      const dept = normalizeName(p?.department || p?.dept_name || p?.department_name);
      return dept && dept === selectedDepartmentNameNormalized;
    });
  }, [projectcode, selectedDepartmentNameNormalized]);

  const resetBudgetUploadInput = () => {
    if (budgetFileInputRef.current) {
      budgetFileInputRef.current.value = "";
    }
  };

  const resetItemUploadInput = () => {
    if (itemFileInputRef.current) {
      itemFileInputRef.current.value = "";
    }
  };

  const getFileExtension = (file) =>
    String(file?.name || "")
      .split(".")
      .pop()
      .toLowerCase();

  const normalizeBudgetUploadKey = (value) =>
    String(value ?? "")
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]/g, "");

  const normalizeBudgetUploadValue = (value) => String(value ?? "").trim();

  const getBudgetUploadFieldName = (key) => {
    const normalizedKey = normalizeBudgetUploadKey(key);

    if (
      [
        "department",
        "dept",
        "deptname",
        "dept_name",
        "departmentname",
        "department_name",
      ].includes(normalizedKey)
    ) {
      return "department";
    }

    if (
      [
        "costcentercode",
        "costcenter",
        "costcentrecode",
        "costcentre",
        "cccode",
      ].includes(normalizedKey)
    ) {
      return "costCenterCode";
    }

    if (["glcode", "gl"].includes(normalizedKey)) {
      return "glCode";
    }

    if (["projectcode", "project"].includes(normalizedKey)) {
      return "projectCode";
    }

    return "";
  };

  const mapBudgetUploadRows = (rows) =>
    (rows || [])
      .map((row) => {
        const mappedRow = {
          department: "",
          costCenterCode: "",
          glCode: "",
          projectCode: "",
        };

        Object.entries(row || {}).forEach(([key, value]) => {
          const fieldName = getBudgetUploadFieldName(key);
          if (!fieldName || mappedRow[fieldName]) return;
          mappedRow[fieldName] = normalizeBudgetUploadValue(value);
        });

        return mappedRow;
      })
      .filter(
        (row) =>
          row.costCenterCode.trim() ||
          row.glCode.trim() ||
          row.projectCode.trim(),
      );

  const readBudgetUploadFile = (file) =>
    new Promise((resolve, reject) => {
      const extension = getFileExtension(file);
      const reader = new FileReader();

      reader.onload = (event) => {
        try {
          const workbook = XLSX.read(event.target.result, {
            type: extension === "csv" ? "string" : "array",
          });
          const firstSheetName = workbook.SheetNames?.[0];
          const firstSheet = workbook.Sheets?.[firstSheetName];

          if (!firstSheet) {
            resolve([]);
            return;
          }

          const rows = XLSX.utils.sheet_to_json(firstSheet, { defval: "" });
          resolve(mapBudgetUploadRows(rows));
        } catch (error) {
          reject(error);
        }
      };

      reader.onerror = () =>
        reject(new Error("Unable to read the selected file."));

      if (extension === "csv") {
        reader.readAsText(file);
      } else {
        reader.readAsArrayBuffer(file);
      }
    });

  const findBudgetOptionByCode = (options, code, codeKey) => {
    const normalizedCode = normalizeName(code);
    if (!normalizedCode) return null;

    const candidateKeys = (() => {
      if (codeKey === "costcenter_code") {
        return ["costcenter_code", "cost_center_code", "cc_code", "code"];
      }
      if (codeKey === "gl_code") {
        return ["gl_code", "glCode", "gl_code_value", "glcode", "code"];
      }
      if (codeKey === "project_code") {
        return [
          "project_code",
          "projectCode",
          "project_code_value",
          "projectcode",
          "code",
        ];
      }
      return [codeKey];
    })();

    return (
      (options || []).find(
        (option) =>
          candidateKeys.some(
            (k) => normalizeName(option?.[k]) === normalizedCode,
          ),
      ) || null
    );
  };

  const normalizeBudgetCodeValue = (value) => {
    const rawValue = (() => {
      if (!value) return "";
      if (typeof value !== "object") return value;
      // Handle cases where API returns nested objects for budget fields
      return (
        value?.costcenter_code ??
        value?.cost_center_code ??
        value?.gl_code ??
        value?.project_code ??
        value?.code ??
        value?.name ??
        value?.value ??
        ""
      );
    })();
    const normalizedCode = normalizeBudgetUploadValue(rawValue);
    const normalizedLower = normalizedCode.toLowerCase();
    if (
      normalizedLower === "nan" ||
      normalizedLower === "null" ||
      normalizedLower === "undefined"
    ) {
      return "";
    }
    return normalizedCode;
  };

  const getBudgetFieldValue = (source, keys) => {
    for (const key of keys) {
      const value = normalizeBudgetCodeValue(source?.[key]);
      if (value) return value;
    }
    return "";
  };

  const hasBudgetRowData = (row = {}) =>
    [
      row?.costCentre?.costcenter_code,
      row?.costCentre?.cost_center_code,
      row?.costCentre?.cc_code,
      row?.costCentre?.code,
      row?.costCentre,
      row?.glCode?.gl_code,
      row?.glCode?.gl_code_value,
      row?.glCode?.glCode,
      row?.glCode?.code,
      row?.glCode,
      row?.projectCode?.project_code,
      row?.projectCode?.project_code_value,
      row?.projectCode?.projectCode,
      row?.projectCode?.code,
      row?.projectCode,
    ].some((value) => String(value ?? "").trim());

  const createBudgetOptionFromCode = (
    code,
    codeKey,
    departmentName = selectedDepartment?.name || "",
  ) => {
    const normalizedCode = normalizeBudgetCodeValue(code);
    if (!normalizedCode) return null;

    const base = { department: departmentName };
    if (codeKey === "costcenter_code") {
      return { ...base, costcenter_code: normalizedCode, cost_center_code: normalizedCode };
    }
    if (codeKey === "gl_code") {
      return { ...base, gl_code: normalizedCode, gl_code_value: normalizedCode };
    }
    if (codeKey === "project_code") {
      return { ...base, project_code: normalizedCode, project_code_value: normalizedCode };
    }
    return { ...base, [codeKey]: normalizedCode };
  };

  const buildBudgetOptionFromCode = (
    options,
    code,
    codeKey,
    departmentName,
  ) =>
    findBudgetOptionByCode(options, code, codeKey) ||
    createBudgetOptionFromCode(code, codeKey, departmentName);

  const buildBudgetRowsFromUpload = (rows) =>
    rows.map((row) => {
      const departmentName =
        normalizeBudgetUploadValue(row?.department) ||
        selectedDepartment?.name ||
        "";

      return {
        department: departmentName,
        costCentre: buildBudgetOptionFromCode(
          constcenter,
          row.costCenterCode,
          "costcenter_code",
          departmentName,
        ),
        glCode: buildBudgetOptionFromCode(
          glcode,
          row.glCode,
          "gl_code",
          departmentName,
        ),
        projectCode: buildBudgetOptionFromCode(
          projectcode,
          row.projectCode,
          "project_code",
          departmentName,
        ),
      };
    });

  const handleBudgetUploadFile = async (file) => {
    setBudgetUploadError("");

    if (!file) return;

    const extension = getFileExtension(file);
    if (!BUDGET_UPLOAD_ALLOWED_EXTENSIONS.includes(extension)) {
      setBudgetUploadFile(null);
      resetBudgetUploadInput();
      setBudgetUploadError("Only .csv, .xls and .xlsx files are allowed.");
      return;
    }

    try {
      const uploadedRows = await readBudgetUploadFile(file);

      if (uploadedRows.length === 0) {
        setBudgetUploadFile(null);
        resetBudgetUploadInput();
        setBudgetUploadError(
          "No budget rows found. Use Cost Center Code, GL Code and Project Code columns.",
        );
        return;
      }

      setBudgetRows(buildBudgetRowsFromUpload(uploadedRows));
      setBudgetUploadFile(file);
      setBudgetUploadError("");
    } catch (error) {
      console.error("Error reading budget upload file:", error);
      setBudgetUploadFile(null);
      resetBudgetUploadInput();
      setBudgetUploadError("Unable to read the selected budget file.");
    }
  };

  const handleBudgetFileChange = (event) => {
    handleBudgetUploadFile(event.target.files?.[0]);
  };

  const handleBudgetDragOver = (event) => {
    event.preventDefault();
    setBudgetDragging(true);
  };

  const handleBudgetDragLeave = (event) => {
    event.preventDefault();
    setBudgetDragging(false);
  };

  const handleBudgetDrop = (event) => {
    event.preventDefault();
    setBudgetDragging(false);
    handleBudgetUploadFile(event.dataTransfer.files?.[0]);
  };

  const clearBudgetUploadFile = () => {
    setBudgetUploadFile(null);
    setBudgetUploadError("");
    resetBudgetUploadInput();
  };

  const isBudgetApiError = (error) => {
    const data = error?.response?.data || {};
    const message = String(data?.response || error?.message || "").toLowerCase();
    return (
      message.includes("budget") ||
      Boolean(data?.budget_validation_summary) ||
      Boolean(data?.budget_upload_summary)
    );
  };

  const handleDownloadBudgetSample = () => {
    const worksheet = XLSX.utils.aoa_to_sheet([
      ["sno", "project_code", "gl_code", "costcenter_code", "Department"],
    ]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Budget");
    const workbookOutput = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([workbookOutput], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, "Sample Budget Upload.xlsx");
  };

  useEffect(() => {
    if (isBudgetBulkUpload) return;
    if (viewpr && !editpr) return;
    if (editpr) return;

    // Keep budget selections consistent with department filter and hide unmapped ("") departments
    setBudgetRows((prevRows) => {
      if (!Array.isArray(prevRows) || prevRows.length === 0) return prevRows;

      const shouldClear = (value) => {
        if (!value || typeof value !== "object") return false;
        const dept = normalizeName(value?.department);
        if (!dept) return true; // hide empty department-mapped values
        if (!selectedDepartmentNameNormalized) return true;
        return dept !== selectedDepartmentNameNormalized;
      };

      let changed = false;
      const next = prevRows.map((row) => {
        const nextCost = shouldClear(row?.costCentre) ? null : row?.costCentre;
        const nextGl = shouldClear(row?.glCode) ? null : row?.glCode;
        const nextProj = shouldClear(row?.projectCode)
          ? null
          : row?.projectCode;

        if (
          nextCost !== row?.costCentre ||
          nextGl !== row?.glCode ||
          nextProj !== row?.projectCode
        ) {
          changed = true;
        }

        return {
          ...row,
          costCentre: nextCost,
          glCode: nextGl,
          projectCode: nextProj,
        };
      });

      return changed ? next : prevRows;
    });
  }, [editpr, isBudgetBulkUpload, selectedDepartmentNameNormalized, viewpr]);

  useEffect(() => {
    const handleChatPrCreated = () => {
      queueChatPrRefresh();
    };

    window.addEventListener("chat-pr-created", handleChatPrCreated);

    return () => {
      window.removeEventListener("chat-pr-created", handleChatPrCreated);
    };
  }, []);

	  useEffect(() => {
	    if (proceedRFQ) return;
	    if (!shouldUseServerPagination) return;
	    getAllPurchaseRequest(page);
	  }, [
	    shouldUseServerPagination,
	    page,
	    proceedRFQ,
	    prSortConfig?.key,
	    prSortConfig?.direction,
	    searchTerm,
	    statusFilter,
	  ]);

  useEffect(() => {
    if (!chatRefreshTick) return;

    getAllPurchaseRequest(0);
    getPRforCode();
  }, [chatRefreshTick]);

  const getAllDepartment = async () => {
    if (departmentList.length > 0) return departmentList;
    if (departmentRequestRef.current) return departmentRequestRef.current;

    departmentRequestRef.current = (async () => {
      setDepartmentLoading(true);
      try {
        const cachedDepartments =
          await masterDataRepository.getDepartmentsFromCache();
        if (cachedDepartments.length > 0) {
          setDepartmentList(cachedDepartments);
          return cachedDepartments;
        }

        const response = await axios.post(
          `${API_ENDPOINT.get_Department}`,
          { user_token: user_token },
          { headers: { Authorization: `Bearer ${auth_token}` } },
        );
        const departments = response.data?.data || [];
        setDepartmentList(departments);
        return departments;
      } catch (error) {
        console.error("Error fetching departments:", error);
        return [];
      } finally {
        setDepartmentLoading(false);
        departmentRequestRef.current = null;
      }
    })();

    return departmentRequestRef.current;
  };

  const get_user_mapped_prs = async () => {
    try {
      setLoadingPRs(true);
      const response = await axios({
        url: `${API_ENDPOINT.get_user_mapped_prs}`,
        method: "POST",
        data: { user_token },
        headers: {
          Authorization: `Bearer ${auth_token}`,
        },
      });

      const orderedData = response?.data.sort((a, b) => {
        const aCode = parseInt(a.pr_code.replace(/\D/g, ""), 10);
        const bCode = parseInt(b.pr_code.replace(/\D/g, ""), 10);
        return bCode - aCode;
      });

      setPurchaseRequestData(orderedData);
    } catch (error) {
      console.error("Error fetching mapped PRs:", error);
    } finally {
      setLoadingPRs(false);
    }
  };
  console.log(getpurchaserequestdata);
  const getPRforCode = async () => {
    try {
      const response = await axios({
        url: `${API_ENDPOINT.get_all_saved_prs_code}`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${auth_token}`,
        },
      });

      const data = response?.data || [];
      setPurchaseCode(data);
      return data;
    } catch (error) {
      console.error("Error fetching RFQs:", error);
      return [];
    }
  };

  const get_all_vendors = async () => {
    await axios({
      method: "POST",
      url: `${API_ENDPOINT.get_all_vendor}`,
      data: {
        org_token: user_token,
      },
      headers: {
        Authorization: `Bearer ${auth_token}`,
      },
    }).then((res) => {
      setVendorsList({
        values: {
          tokens: Array.isArray(res?.data?.users)
            ? res.data.users.map((vendor) => vendor.token)
            : [],
          visibleOption: Array.isArray(res?.data?.users)
            ? res.data.users.map(
                (vendor) =>
                  `${vendor.company_name} (${vendor.company_official_email})`,
              )
            : [],
        },
        fullDetails: Array.isArray(res?.data?.users)
          ? res.data.users.reduce((acc, vendor) => {
              acc[vendor.token] = {
                token: vendor.token,
                companyName: vendor.company_name,
                email: vendor.company_official_email,
                role: vendor.role,
              };
              return acc;
            }, {})
          : {},
      });
    });
  };

  const getAllUserList = async () => {
    try {
      const response = await axios.post(
        `${API_ENDPOINT.all_user_list}`,
        { buyer_token: user_token },
        { headers: { Authorization: `Bearer ${auth_token}` } },
      );

      const filteredUsers = response?.data.filter(
        (user) => user.role === "User" && user.token !== user_token,
      );

      setUserList(filteredUsers);
    } catch (error) {
      console.error("Error fetching user list:", error);
    }
  };

  // useEffect(() => {
  //   const chatActionRaw = sessionStorage.getItem("CHAT_ACTION");
  //   if (!chatActionRaw) return;

  //   const { action, pr_code } = JSON.parse(chatActionRaw);

  //   sessionStorage.removeItem("CHAT_ACTION");

  //   if (action === "create_new_pr" || action === "raise") {
  //     handleRaisePR();
  //   }

  //   if (action === "open_pending_prs") {
  //     setStatusFilter("2");
  //   }

  //   if (action === "edit_my_pr" && pr_code && getpurchaserequestdata.length) {
  //     const pr = getpurchaserequestdata.find((p) => p.pr_code === pr_code);
  //     if (pr) handleEditPR(pr);
  //   }
  // }, [getpurchaserequestdata]);

  const chatPrMounted = useRef(false);
  useEffect(() => {
    chatPrMounted.current = true;
    return () => { chatPrMounted.current = false; };
  }, []);

  useEffect(() => {
    const raw = sessionStorage.getItem("CHAT_ACTION");
    if (!raw) return;
    let pending;
    try {
      pending = JSON.parse(raw);
    } catch {
      sessionStorage.removeItem("CHAT_ACTION");
      return;
    }
    const { action } = pending;
    const edit = ["edit_my_pr", "pr_edit_mine"].includes(action);
    const view = ["open_specific_pr", "pr_open_specific"].includes(action);
    const search = ["search_pr", "search_pr_details"].includes(action);
    if (edit || view || search) {
      const code = String(pending.pr_code || pending.search_text || "").trim();
      if (!code) {
        sessionStorage.removeItem("CHAT_ACTION");
        window.alert("Please include the purchase request number.");
        return;
      }
      if (!pendingChatPrSearch.current || pendingChatPrSearch.current.raw !== raw) {
        pendingChatPrSearch.current = { raw, after: prSearchSequence.current };
        setStatusFilter("all");
        setPage(0);
        setSearchTerm(code);
        // If already searching this code, explicitly refresh the same search.
        if (searchTerm === code && statusFilter === "all" && page === 0) {
          void getAllPurchaseRequest(0);
        }
        if (search) {
          sessionStorage.removeItem("CHAT_ACTION");
          pendingChatPrSearch.current = null;
        }
        return;
      }
      const result = chatPrSearchResult;
      if (!result || result.sequence <= pendingChatPrSearch.current.after ||
          result.query !== code || result.status !== "all" || result.page !== 0) return;

      // Consume only the completed search's rows, never the old visible page.
      sessionStorage.removeItem("CHAT_ACTION");
      pendingChatPrSearch.current = null;
      void openChatPr({
        code,
        edit,
        load: async () => result.records,
        onView: (pr) => { if (chatPrMounted.current) handleViewPR(pr); },
        onEdit: (pr) => { if (chatPrMounted.current) handleEditPR(pr); },
      }).catch((error) => {
        if (chatPrMounted.current) window.alert(error.message || "Unable to open the purchase request.");
      });
      return;
    }
    if (action === "refresh_pr_list") {
      sessionStorage.removeItem("CHAT_ACTION");
      queueChatPrRefresh();
    } else if (action === "create_new_pr") {
      sessionStorage.removeItem("CHAT_ACTION");
      handleRaisePR();
    } else if (
      action === "open_pending_prs" ||
      action === "approve_pr" ||
      action === "reject_pr"
    ) {
      sessionStorage.removeItem("CHAT_ACTION");
      setStatusFilter(
        action === "open_pending_prs"
          ? "2"
          : action === "reject_pr"
            ? "3"
            : "1",
      );
    }
  }, [chatPrSearchResult, user_token]);
  // Offline-first data loading
  const {
    prs: offlinePRs,
    costCenters: offlineCostCenters,
    glCodes: offlineGLCodes,
    projectCodes: offlineProjectCodes,
    items: offlineItems,
    departments: offlineDepartments,
    vendors: offlineVendors,
    users: offlineUsers,
    prCodes: offlinePRCodes,
    loading: offlineLoading,
  } = useInitialDataLoad(auth_token, user_token, org_id, {
    // Avoid duplicate combined PR list fetches: UI drives list (including pagination/search).
    skipApiSync: true,
  });

	  // Sync offline data to component state
	  useEffect(() => {
    // Skip if we just did an optimistic update (prevent overwriting)
    if (justUpdatedOptimistically.current) {
      console.log(
        "⏭️ Skipping useEffect merge - optimistic update just happened",
      );
      return;
    }

    if (!offlineLoading) {
      const isOnlineNow =
        shouldMakeAPICall(auth_token, user_token) &&
        auth_token &&
        user_token &&
        org_id;

      // When online and the user is searching/filtering (non server-pagination mode),
      // prefer the live API-driven list over potentially-stale offline hook state.
      // This prevents "No matching PR records found" right after creating a PR, before reload.
      const shouldSkipPRListSyncFromOffline =
        isOnlineNow &&
        !shouldUseServerPagination &&
        String(searchTerm || "").trim() !== "" &&
        Array.isArray(getpurchaserequestdata) &&
        getpurchaserequestdata.length > 0;

	      // Update PRs - but preserve optimistic updates
	      if (offlinePRs.length > 0 && !shouldSkipPRListSyncFromOffline) {
	        if (shouldUseServerPagination) {
	          // In server-pagination mode, prefer API-driven page data when online.
	          // Use offline slice only as a fallback when offline.
	          if (!isOnlineNow) {
	            const sorted = sortPRsByCreatedDateDesc(offlinePRs);
	            const start = page * rowsPerPage;
	            setPurchaseRequestData(sorted.slice(start, start + rowsPerPage));
	            setPurchaseRequestTotalCount((prev) =>
	              Math.max(
	                prev || 0,
	                Array.isArray(offlinePRs) ? offlinePRs.length : 0,
	              ),
	            );
		          } else {
		            // Keep a non-zero count for pagination controls while online sync settles,
		            // but don't overwrite the current API page in state.
		            setPurchaseRequestTotalCount((prev) => {
		              if (prev && prev > 0) return prev;
		              return Array.isArray(offlinePRs) ? offlinePRs.length : 0;
		            });
		          }
		        } else {
	          // Merge with existing state to preserve optimistic updates
	          setPurchaseRequestData((prevPRs) => {
            // If we have existing PRs with pending sync, preserve them
            const pendingPRs = prevPRs.filter(
              (pr) => pr._pendingSync || pr._lastUpdated,
            );

            if (pendingPRs.length > 0) {
              // Merge: use offlinePRs but keep pending ones from state
              const prMap = new Map(offlinePRs.map((pr) => [pr.pr_token, pr]));
              pendingPRs.forEach((pr) => {
                // Only preserve if it's not in offlinePRs or if it's newer
                const existingInOffline = prMap.get(pr.pr_token);
                if (
                  !existingInOffline ||
                  (pr._lastUpdated &&
                    pr._lastUpdated > (existingInOffline._lastUpdated || 0))
                ) {
                  prMap.set(pr.pr_token, pr); // Preserve optimistic update
                  console.log(
                    `📱 Preserving optimistic update for PR: ${pr.pr_code || pr.pr_token}`,
                  );
                }
              });
              const merged = Array.from(prMap.values());
              console.log(
                "📱 Merged PRs, preserving",
                pendingPRs.length,
                "optimistic updates, total:",
                merged.length,
              );
              return merged;
            }

            // No pending updates, use offlinePRs as-is
            console.log(
              "📱 No pending updates, using offlinePRs as-is, count:",
              offlinePRs.length,
            );
            return [...offlinePRs]; // Force new array reference
          });
          setPurchaseRequestTotalCount((prev) =>
            Math.max(
              prev || 0,
              Array.isArray(offlinePRs) ? offlinePRs.length : 0,
            ),
          );
        }

        const isUserInApprovers = offlinePRs.some((pr) =>
          pr.approvers?.some(
            (approver) => approver.name === loginData?.user?.first_name,
          ),
        );
        setHasMappedPRs(isUserInApprovers);
      }

      // Update master data
      if (offlineCostCenters.length > 0) setCostCenter(offlineCostCenters);
      if (offlineGLCodes.length > 0) setGLCode(offlineGLCodes);
      if (offlineProjectCodes.length > 0) setProjectCode(offlineProjectCodes);
      if (offlineItems.length > 0) setItemMaster(offlineItems);
      if (offlineDepartments.length > 0) setDepartmentList(offlineDepartments);
      if (offlineVendors.length > 0) {
        setVendorsList({
          values: {
            tokens: offlineVendors.map((vendor) => vendor.token),
            visibleOption: offlineVendors.map(
              (vendor) =>
                `${vendor.company_name} (${vendor.company_official_email})`,
            ),
          },
          fullDetails: offlineVendors.reduce((acc, vendor) => {
            acc[vendor.token] = {
              token: vendor.token,
              companyName: vendor.company_name,
              email: vendor.company_official_email,
              role: vendor.role,
            };
            return acc;
          }, {}),
        });
      }
      if (offlineUsers.length > 0) {
        const filteredUsers = offlineUsers.filter(
          (user) => user.role === "User" && user.token !== user_token,
        );
        setUserList(filteredUsers);
      }
      if (offlinePRCodes.length > 0) setPurchaseCode(offlinePRCodes);
    }
  }, [
    offlinePRs,
    offlineCostCenters,
    offlineGLCodes,
    offlineProjectCodes,
    offlineItems,
    offlineDepartments,
    offlineVendors,
    offlineUsers,
    offlinePRCodes,
    offlineLoading,
    user_token,
    loginData?.user?.first_name,
    shouldUseServerPagination,
    page,
    rowsPerPage,
  ]);

	  // Legacy API calls - kept for backward compatibility and manual refresh
  useEffect(() => {
    // Only call APIs if we have auth tokens and want to force refresh
    // The offline system handles initial load automatically
    if (auth_token && user_token && org_id) {
      // Optional: Force sync on mount (offline system already does this)
      // Uncomment if you want explicit API calls in addition to offline sync
      // getAllPurchaseRequest();
      // costcentreRequest();
      void glcodeRequest();
      void projectCodeRequest();
      void getAllItems();
      // getAllDepartment();
      // get_all_vendors();
      // getAllUserList();
      // getPRforCode();
    }

    // Avoid calling legacy `get_user_mapped_prs` (no pagination/count).
    // `getAllPurchaseRequest` + offline sync handle list fetching for both raiser and approver flows.
  }, []);

  useEffect(() => {
    return () => {
      if (itemSearchTimerRef.current) {
        clearTimeout(itemSearchTimerRef.current);
      }
    };
  }, []);

  const userList = () => {
    return (
      <div style={{ flex: "1" }}>
        <Autocomplete
          multiple
          disablePortal
          options={getuserlist}
          sx={{ width: 300 }}
          getOptionLabel={(option) =>
            viewpr ? `${option.first_name}` : `${option.first_name}`
          }
          value={selectedApprovers}
          onChange={(event, newValue) => setSelectedApprovers(newValue)}
          isOptionEqualToValue={(option, value) => {
            if (option?.token && value?.token) {
              return option.token === value.token;
            }
            if (option?.id && value?.id) {
              return option.id === value.id;
            }
            return option?.email === value?.email;
          }}
          disabled={viewpr && !editpr}
          renderInput={(params) => (
            <TextField
              {...params}
              sx={{
                "& .MuiInputBase-root": {
                  fontSize: "14px",
                },
                "& .MuiInputLabel-root": {
                  fontSize: "14px",
                },
                "& .MuiAutocomplete-tag": {
                  fontSize: "12px",
                },
              }}
            />
          )}
        />
      </div>
    );
  };

  const approvalsectionlabels = [
    {
      label: "Approver Name",
      value: userList(),
      size: "30rem",
    },
    {
      label: "Designation",
      value: loginData?.user?.designation,
      size: "30rem",
    },
    {
      label: "Signature",
      value: loginData?.user?.first_name,
      size: "30rem",
    },
    {
      label: "Date",
      value: new Date().toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
      }),
      size: "30rem",
    },
  ];

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRows = parseInt(event.target.value, 10);
    setRowsPerPage(Number.isNaN(newRows) ? rowsPerPage : newRows);
    setPage(0);
  };

  useEffect(() => {
    const totalItems = shouldUseServerPagination
      ? purchaseRequestPageCount
      : Array.isArray(filteredPRs)
        ? filteredPRs.length
        : 0;

    if (!rowsPerPage || rowsPerPage < 0) {
      return;
    }

    const maxPage = shouldUseServerPagination
      ? Math.max(0, totalItems - 1)
      : Math.max(0, Math.ceil(totalItems / rowsPerPage) - 1);
    if (page > maxPage) {
      setPage(maxPage);
    }
  }, [
    filteredPRs,
    rowsPerPage,
    page,
    shouldUseServerPagination,
    purchaseRequestPageCount,
    purchaseRequestTotalCount,
  ]);

  const handleAddItem = () => {
    setItems([
      ...items,
      {
        itemToken: "",
        itemCode: "",
        itemCodeInput: "",
        itemName: "",
        itemNameInput: "",
        category: "",
        expenseType: "",
        subCategory: "",
        itemType: "",
        quantity: "",
        unit: "",
        hsnCode: "",
        unspscCode: "",
        brand: "",
        manufacturerPartNo: "",
        specifications: "",
        aliases: "",
        gstList: [],
        description: "",
        unitPrice: "",
        totalPrice: "",
      },
    ]);
    setBudgetRows((prevRows) => [...prevRows, createEmptyBudgetRow()]);
  };

	  const getManualItemKey = (item = {}) => {
	    const key = item?.itemToken || item?.itemCode || "";
	    return String(key ?? "").trim().toLowerCase();
	  };

	  const DUPLICATE_ITEM_MSG = "Item already added";

	  const hasManualItemKeyConflict = (list = [], index) => {
	    const current = list?.[index];
	    if (!current) return false;
	    const key = getManualItemKey(current);
	    if (!key) return false;
	    return (list || []).some((other, idx) => {
	      if (idx === index) return false;
	      return getManualItemKey(other) === key;
	    });
	  };

	  const clearDuplicateErrorAtIndex = (errors = {}, index) => {
	    const next = { ...(errors || {}) };
	    if (!next[index]) return next;
	    if (next[index].itemCode === DUPLICATE_ITEM_MSG) next[index].itemCode = "";
	    if (next[index].itemName === DUPLICATE_ITEM_MSG) next[index].itemName = "";
	    if (Object.values(next[index]).every((v) => !v)) delete next[index];
	    return next;
	  };

	  const applyDuplicateErrorsForIndexOnly = (list = [], prevErrors = {}, index) => {
	    let next = { ...(prevErrors || {}) };

	    // Clear resolved duplicate errors that no longer conflict
	    Object.keys(next).forEach((k) => {
	      const idx = Number(k);
	      if (Number.isNaN(idx)) return;
	      const entry = next[idx];
	      if (!entry) return;
	      const hasDupMsg =
	        entry.itemCode === DUPLICATE_ITEM_MSG ||
	        entry.itemName === DUPLICATE_ITEM_MSG;
	      if (!hasDupMsg) return;
	      if (!hasManualItemKeyConflict(list, idx)) {
	        next = clearDuplicateErrorAtIndex(next, idx);
	      }
	    });

	    // Only mark the row the user just changed
	    if (hasManualItemKeyConflict(list, index)) {
	      const key = getManualItemKey(list?.[index]);
	      if (key) {
	        Object.keys(next).forEach((k) => {
	          const idx = Number(k);
	          if (Number.isNaN(idx)) return;
	          if (idx === index) return;
	          if (getManualItemKey(list?.[idx]) !== key) return;
	          next = clearDuplicateErrorAtIndex(next, idx);
	        });
	      }
	      next[index] = {
	        ...(next[index] || {}),
	        itemCode: DUPLICATE_ITEM_MSG,
	        itemName: DUPLICATE_ITEM_MSG,
	      };
	    } else {
	      next = clearDuplicateErrorAtIndex(next, index);
	    }

	    return next;
	  };

	  const markLatestDuplicateErrorsForSubmit = (list = [], prevErrors = {}) => {
	    let next = { ...(prevErrors || {}) };
	    // Clear resolved duplicate errors first
	    Object.keys(next).forEach((k) => {
	      const idx = Number(k);
	      if (Number.isNaN(idx)) return;
	      const entry = next[idx];
	      if (!entry) return;
	      const hasDupMsg =
	        entry.itemCode === DUPLICATE_ITEM_MSG ||
	        entry.itemName === DUPLICATE_ITEM_MSG;
	      if (!hasDupMsg) return;
	      if (!hasManualItemKeyConflict(list, idx)) {
	        next = clearDuplicateErrorAtIndex(next, idx);
	      }
	    });

	    const indicesByKey = new Map();
	    (list || []).forEach((item, idx) => {
	      const key = getManualItemKey(item);
	      if (!key) return;
	      const existing = indicesByKey.get(key);
	      if (existing) existing.push(idx);
	      else indicesByKey.set(key, [idx]);
	    });

	    indicesByKey.forEach((indices) => {
	      if (indices.length <= 1) return;
	      const latestIdx = Math.max(...indices);
	      indices.forEach((i) => {
	        next = clearDuplicateErrorAtIndex(next, i);
	      });
	      next[latestIdx] = {
	        ...(next[latestIdx] || {}),
	        itemCode: DUPLICATE_ITEM_MSG,
	        itemName: DUPLICATE_ITEM_MSG,
	      };
	    });

	    return next;
	  };

	  const reindexErrorsAfterRemoval = (prevErrors = {}, removedIndex) => {
	    const next = {};
	    Object.keys(prevErrors || {}).forEach((k) => {
	      const idx = Number(k);
	      if (Number.isNaN(idx)) return;
	      if (idx === removedIndex) return;
	      const targetIdx = idx > removedIndex ? idx - 1 : idx;
	      next[targetIdx] = prevErrors[idx];
	    });
	    return next;
	  };

  const handleRemoveItem = (index) => {
    const filteredItems = items.filter((_, i) => i !== index);
    setItems(filteredItems);
    setBudgetRows((prevRows) => {
      const nextRows = Array.isArray(prevRows)
        ? prevRows.filter((_, i) => i !== index)
        : [];
      return nextRows.length > 0 ? nextRows : [createEmptyBudgetRow()];
    });
    setManualItemErrors((prev) =>
      markLatestDuplicateErrorsForSubmit(
        filteredItems,
        reindexErrorsAfterRemoval(prev || {}, index),
      ),
    );
  };

  const addBudgetRow = () => {
    setBudgetRows([
      ...budgetRows,
      { costCentre: null, projectCode: null, glCode: null },
    ]);
  };

  const removeBudgetRow = (index) => {
    setBudgetRows(budgetRows.filter((_, i) => i !== index));
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    setDragging(true);
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    setDragging(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setDragging(false);
    const file = event.dataTransfer.files[0];
    if (file) {
      setFileUpload(file);
      setFileuploadError("");
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setFileUpload(file);
    setFileuploadError("");
  };

  const clearItemUploadFile = () => {
    setFileUpload(null);
    setFileuploadError("");
    resetItemUploadInput();
  };

  const handleItemSelection = (index, selectedItem) => {
    const expenseType = selectedItem?.expense_type || "";
    const itemName = selectedItem?.item_name || "";
    const itemCode = selectedItem?.item_code || "";
    const itemToken = selectedItem?.token || selectedItem?.item_token || "";

    const updatedItems = [...items];
	    updatedItems[index] = {
	      ...updatedItems[index],
	      itemToken,
	      itemName,
      itemNameInput: itemName,
      itemCode,
      itemCodeInput: itemCode,
      expenseType,
      hsnCode: selectedItem?.hsn_code || "",
      unspscCode: selectedItem?.unspsc_code || "",
      category: selectedItem?.category || "",
      subCategory: selectedItem?.sub_category || "",
      itemType: selectedItem?.item_type || "",
      unit: selectedItem?.uom || "",
      brand: selectedItem?.brand || "",
      partnumber:
        selectedItem?.manufacturer_part_no ||
        selectedItem?.manufacturer_part_number ||
        selectedItem?.manufacturerPartNo ||
        "",
      manufacturerPartNo:
        selectedItem?.manufacturer_part_no ||
        selectedItem?.manufacturer_part_number ||
        selectedItem?.manufacturerPartNo ||
        "",
      specifications: selectedItem?.specifications || "",
      aliases: selectedItem?.aliases || "",
      gstList: Array.isArray(selectedItem?.GST_list)
        ? selectedItem.GST_list
        : [],
	      description: selectedItem?.item_description || itemName || "",
	    };
	    setItems(updatedItems);
	    setManualItemErrors((prev) =>
	      applyDuplicateErrorsForIndexOnly(updatedItems, prev, index),
	    );

	    if (fileuploadError === MANUAL_REQUIRED_ERROR_MSG) {
	      setFileuploadError("");
	    }

    if (
      manualItemErrors?.[index]?.itemName ||
      manualItemErrors?.[index]?.description
    ) {
      setManualItemErrors((prev) => {
        const next = { ...(prev || {}) };
        if (!next[index]) return prev;
        next[index] = { ...next[index], itemName: "", description: "" };
        if (
          !next[index].itemName &&
          !next[index].quantity &&
          !next[index].unit &&
          !next[index].description &&
          !next[index].unitPrice
        ) {
          delete next[index];
        }
        return next;
      });
    }
  };

  const preventNumberWheel = (event) => {
    // Avoid accidental value changes when scrolling over number inputs
    event.target.blur();
  };

  const updateTotalPrice = (index, field, value) => {
    const updatedItems = [...items];
    if (field === "quantity") {
      const sanitizedQuantity = String(value ?? "")
        .replace(/[^\d]/g, "")
        .replace(/^0+(?=\d)/, "")
        .slice(0, 10);
      updatedItems[index][field] = sanitizedQuantity;
    } else {
      updatedItems[index][field] = value;
    }

    const qty = parseInt(updatedItems[index].quantity, 10) || 0;
    const price = parseFloat(updatedItems[index].unitPrice) || 0;
    updatedItems[index].totalPrice = (qty * price).toFixed(2);

    setItems(updatedItems);

    if (
      fileuploadError === MANUAL_REQUIRED_ERROR_MSG &&
      (field === "quantity" || field === "description" || field === "unitPrice")
    ) {
      setFileuploadError("");
    }

    if (field === "quantity" && manualItemErrors?.[index]?.quantity) {
      setManualItemErrors((prev) => {
        const next = { ...(prev || {}) };
        if (!next[index]) return prev;
        next[index] = { ...next[index], quantity: "" };
        if (
          !next[index].itemName &&
          !next[index].quantity &&
          !next[index].unit &&
          !next[index].description &&
          !next[index].unitPrice
        ) {
          delete next[index];
        }
        return next;
      });
    }

    if (field === "description" && manualItemErrors?.[index]?.description) {
      setManualItemErrors((prev) => {
        const next = { ...(prev || {}) };
        if (!next[index]) return prev;
        next[index] = { ...next[index], description: "" };
        if (
          !next[index].itemName &&
          !next[index].quantity &&
          !next[index].unit &&
          !next[index].description &&
          !next[index].unitPrice
        ) {
          delete next[index];
        }
        return next;
      });
    }

    if (field === "unitPrice" && manualItemErrors?.[index]?.unitPrice) {
      setManualItemErrors((prev) => {
        const next = { ...(prev || {}) };
        if (!next[index]) return prev;
        next[index] = { ...next[index], unitPrice: "" };
        if (
          !next[index].itemName &&
          !next[index].quantity &&
          !next[index].unit &&
          !next[index].description &&
          !next[index].unitPrice
        ) {
          delete next[index];
        }
        return next;
      });
    }
  };

  const grandTotal = items.reduce(
    (acc, item) => acc + parseFloat(item.totalPrice || 0),
    0,
  );
  const budgetBalanceAmount = Number(
    String(budgetConfig?.balance_amount ?? "").replace(/,/g, ""),
  );
  const prAvailableValue = String(budgetConfig?.pr_available ?? "").trim();
  const prAvailableAmount = prAvailableValue
    ? Number(prAvailableValue.replace(/,/g, ""))
    : Number.NaN;
  const prSpendLimit = Number.isFinite(prAvailableAmount)
    ? Math.min(budgetBalanceAmount, prAvailableAmount)
    : budgetBalanceAmount;
  const isOverBudget =
    Boolean(budgetConfig) &&
    Number.isFinite(prSpendLimit) &&
    grandTotal > prSpendLimit;
  const liveBudgetLimitError = isOverBudget
    ? `PR total ${formatBudgetAmount(grandTotal)} exceeds the available PR balance ${formatBudgetAmount(prSpendLimit)}.`
    : budgetLimitError;

  const handleChange = (index, field, value) => {
    const updated = [...budgetRows];
    updated[index][field] = value;
    setBudgetRows(updated);
  };

  const handleSavePurchaseRequest = async () => {
    setLoadingPR(true);
    setFileuploadError("");
    setBudgetUploadError("");
    setBudgetLimitError("");
    setDepartmentError("");
    setManualItemErrors({});

    const prDepartmentName = selectedDepartment?.name || "";

    if (!prDepartmentName) {
      setDepartmentError("Please choose department");
      setTimeout(() => {
        try {
          departmentFieldRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          const input =
            departmentFieldRef.current?.querySelector("input") || null;
          input?.focus?.();
        } catch (_) {
          // ignore
        }
      }, 0);
      setLoadingPR(false);
      return;
    }

    if (
      budgetConfigLoading ||
      !budgetConfig ||
      !Number.isFinite(budgetBalanceAmount) ||
      budgetBalanceAmount < 0
    ) {
      setBudgetLimitError("Budget balance is unavailable for the selected department.");
      setLoadingPR(false);
      return;
    }

    if (grandTotal > prSpendLimit) {
      setBudgetLimitError(
        `PR total ${formatBudgetAmount(grandTotal)} exceeds the available PR balance ${formatBudgetAmount(prSpendLimit)}.`,
      );
      setLoadingPR(false);
      return;
    }

    if (isBudgetBulkUpload && !budgetUploadFile) {
      setBudgetUploadError("Please upload budget details file.");
      setLoadingPR(false);
      return;
    }

    if (inputMethod === "manual") {
      const nextErrors = {};

      (items || []).forEach((item, idx) => {
        const itemErrors = {};
        const itemName = String(item?.itemName || "").trim();
        const qty = parseFloat(item?.quantity);
        const unit = String(item?.unit || "").trim();
        const description = String(item?.description || "").trim();
        const unitPrice = parseFloat(item?.unitPrice);

        if (!itemName) itemErrors.itemName = "Item name is required";
        if (!item?.quantity || Number.isNaN(qty) || qty <= 0) {
          itemErrors.quantity = "Quantity is required";
        }
        if (!unit) itemErrors.unit = "Unit measure is required";
        if (!description)
          itemErrors.description = "Item description is required";
        if (!item?.unitPrice || Number.isNaN(unitPrice) || unitPrice <= 0) {
          itemErrors.unitPrice = "Unit price is required";
        }

        if (Object.keys(itemErrors).length > 0) {
          nextErrors[idx] = itemErrors;
        }
      });

      const duplicateErrors = markLatestDuplicateErrorsForSubmit(items || [], {});
      Object.keys(duplicateErrors).forEach((k) => {
        const idx = Number(k);
        if (Number.isNaN(idx)) return;
        nextErrors[idx] = {
          ...(nextErrors[idx] || {}),
          ...(duplicateErrors[idx] || {}),
        };
      });

	      if (Object.keys(nextErrors).length > 0) {
	        setManualItemErrors(nextErrors);
	        setFileuploadError(MANUAL_REQUIRED_ERROR_MSG);
	        setTimeout(() => {
	          try {
	            // Scroll to the first visible error field in manual RFQ section
            const firstErrorEl = document.querySelector(
              ".MuiFormHelperText-root.Mui-error",
            );
            firstErrorEl?.scrollIntoView?.({
              behavior: "smooth",
              block: "center",
            });
          } catch (_) {
            // ignore
          }
        }, 0);
        setLoadingPR(false);
        return;
      }
    }

    try {
      const now = new Date();
      const oneMonthLater = new Date();
      oneMonthLater.setMonth(now.getMonth() + 1);

      const bidEndTime = new Date(oneMonthLater);
      bidEndTime.setHours(23, 59, 59, 999);
      const formData = new FormData();

      formData.append("user_token", user_token);
      formData.append("org_id", org_id);
      formData.append("PR Code", selectedPRCode || generatePRCode());
      formData.append("Bid Type", 0);
      formData.append("Proposal Document", "");
      formData.append("purchase_request_number", "");
      formData.append(
        "shipping_address1",
        user_details.shipping_address1 || "",
      );
      formData.append(
        "shipping_address2",
        user_details.shipping_address2 || "",
      );
      formData.append("city", user_details.city || "");
      formData.append("state", user_details.state || "");
      formData.append("country", user_details.country || "");
      formData.append("mobile_number", user_details.phone_number || "");
      formData.append("pincode", user_details.postal_code || "");
      formData.append("user_address", user_details.shipping_address1 || "");
      formData.append("user_city", user_details.city || "");
      formData.append("user_state", user_details.state || "");
      formData.append("user_country", user_details.country || "");
      formData.append("user_postal_code", user_details.postal_code || "");
      formData.append("user_contact_number", user_details.phone_number || "");
      formData.append("purchase_reason", reasontext);
      formData.append("dept_name", prDepartmentName);

      formData.append("bid_from_date", now.toISOString());
      formData.append("bid_to_date", oneMonthLater.toISOString());
      formData.append("bid_time", bidEndTime.toISOString());

      // IMPORTANT: Only add pr_token for UPDATE actions, NOT for CREATE
      // For CREATE, the server will generate a new pr_token
      // Adding pr_token to CREATE will cause the API to fail
      if (editpr && getprtoken?.pr_token) {
        formData.append("pr_token", getprtoken.pr_token);
        console.log("📝 UPDATE action - added pr_token:", getprtoken.pr_token);
      } else if (!editpr) {
        console.log(
          "📝 CREATE action - NOT adding pr_token (server will generate new one)",
        );
        // Ensure pr_token is NOT in FormData for create
        // Don't add it even if getprtoken has a value from previous operations
      }

      if (inputMethod === "manual") {
        const invalidQuantityItem = items.find((item) => {
          const quantityText = String(item?.quantity ?? "").trim();
          return !/^\d+$/.test(quantityText) || Number(quantityText) <= 0;
        });

        if (invalidQuantityItem) {
          setFileuploadError("Quantity must be a positive whole number.");
          setLoadingPR(false);
          return;
        }

        const cleanedItems = items.map((item) => ({
          ...item,
          unitPrice: parseFloat(item.unitPrice) || 0,
          totalPrice: parseFloat(item.totalPrice) || 0,
          category: item?.category || "",
          expense_type: item?.expenseType || item?.expense_type || "",
        }));
        formData.append("items", JSON.stringify(cleanedItems));
      } else if (fileUpload) {
        formData.append("item_code_xlsx", fileUpload);
      } else if (editpr && !fileUpload) {
        const cleanedItems = items.map((item) => ({
          ...item,
          unitPrice: parseFloat(item.unitPrice) || 0,
          totalPrice: parseFloat(item.totalPrice) || 0,
          category: item?.category || "",
          expense_type: item?.expenseType || item?.expense_type || "",
        }));
        formData.append("items", JSON.stringify(cleanedItems));
      }

      const cleanedBudget = budgetRows.map((row) => ({
        cost_center: row.costCentre,
        projectCode: row.projectCode,
        glCode: row.glCode,
      }));

      const simplifiedBudget = cleanedBudget.map((row) => ({
        costCenterCode: row.cost_center?.costcenter_code || "",
        projectCode: row.projectCode?.project_code || "",
        glCode: row.glCode?.gl_code || "",
      }));

      // Don't send trailing completely empty budget lines (common when user clicks + and leaves blank)
      const isEmptyBudgetRow = (row) =>
        !String(row?.costCenterCode || "").trim() &&
        !String(row?.projectCode || "").trim() &&
        !String(row?.glCode || "").trim();

      while (
        simplifiedBudget.length > 0 &&
        isEmptyBudgetRow(simplifiedBudget[simplifiedBudget.length - 1])
      ) {
        simplifiedBudget.pop();
      }

      if (isBudgetBulkUpload && budgetUploadFile) {
        formData.append("budgetDetails_xlsx", budgetUploadFile);
      } else {
        formData.append("budgetDetails", JSON.stringify(simplifiedBudget));
      }

      const approversPayload = selectedApprovers.map((approver) => ({
        token: approver.token,
        name: `${approver.first_name}`,
        email: approver.email,
      }));

      formData.append("approvers", JSON.stringify(approversPayload));
      formData.append("vendorInfo", JSON.stringify([]));

      // NOTE: pr_token is already handled above (line 1144-1151)
      // No need to add it again here - it's already been added if editpr is true

      // Check if online
      const isOnline = shouldMakeAPICall(auth_token, user_token);

      if (!isOnline) {
        // OFFLINE MODE: Queue the action
        console.log("📴 Offline mode - queuing PR update");

        try {
          const actionType = editpr ? "update" : "create";
          await offlineQueue.enqueue(
            actionType,
            API_ENDPOINT.ins_purchase_request,
            formData,
          );

          // Optimistic update: Update local cache
          try {
            const cachedPRs = await prRepository.getAllFromCache();

            if (editpr && getprtoken?.pr_token) {
              // UPDATE EXISTING PR
              const prIndex = cachedPRs.findIndex(
                (pr) => pr.pr_token === getprtoken.pr_token,
              );

              if (prIndex !== -1) {
                const now = new Date();
                const oneMonthLater = new Date(now);
                oneMonthLater.setMonth(now.getMonth() + 1);
                const bidEndTime = new Date(oneMonthLater);
                bidEndTime.setHours(23, 59, 59, 999);

                // Get shipping address from buyerUserDetails or user_details
                const shippingData = buyerUserDetails || user_details || {};

                // Create updated PR object matching combined API structure
                const updatedPR = {
                  ...cachedPRs[prIndex],
                  request_reason: reasontext,
                  dept_name: prDepartmentName,
                  shipping_address:
                    shippingData.shipping_address1 ||
                    shippingData.address_line ||
                    "",
                  // Update buyer_user with shipping details
                  buyer_user: {
                    ...(cachedPRs[prIndex].buyer_user || {}),
                    ...buyerUserDetails,
                    address_line:
                      shippingData.shipping_address1 ||
                      shippingData.address_line ||
                      "",
                    city: shippingData.city || buyerUserDetails?.city || "",
                    state: shippingData.state || buyerUserDetails?.state || "",
                    country:
                      shippingData.country || buyerUserDetails?.country || "",
                    postal_code:
                      shippingData.postal_code ||
                      shippingData.pincode ||
                      buyerUserDetails?.postal_code ||
                      "",
                    phone_number:
                      shippingData.phone_number ||
                      shippingData.mobile_number ||
                      buyerUserDetails?.phone_number ||
                      "",
                  },
                  items: items.map((item, idx) => {
                    const budgetRow = budgetRows[idx] || {};
                    return {
                      item_token:
                        item.itemToken ||
                        cachedPRs[prIndex].items?.[idx]?.item_token ||
                        "",
                      item_name: item.itemName || "",
                      item_code: item.itemCode || "",
                      category: item.category || "",
                      expense_type: item.expenseType || item.expense_type || "",
                      hsn_code: item.hsnCode || "",
                      quantity: item.quantity || "",
                      unit: item.unit || "",
                      part_number: item.partnumber || "",
                      description: item.description || "",
                      unit_price: parseFloat(item.unitPrice || 0),
                      total_price: parseFloat(item.totalPrice || 0),
                      cost_center:
                        budgetRow.costCentre?.costcenter_code ||
                        budgetRow.costCentre ||
                        "",
                      gl_code:
                        budgetRow.glCode?.gl_code || budgetRow.glCode || "",
                      project_code:
                        budgetRow.projectCode?.project_code ||
                        budgetRow.projectCode ||
                        "",
                    };
                  }),
                  approvers: selectedApprovers.map((approver) => ({
                    id: approver.id,
                    first_name: approver.first_name,
                    last_name: approver.last_name,
                    email: approver.email,
                    designation: approver.designation,
                    phone_number: approver.phone_number,
                    status: approver.status || "Awaiting",
                  })),
                  // Mark as pending sync so it doesn't get overwritten
                  _pendingSync: true,
                  _lastUpdated: Date.now(),
                };

                // Transform and update cache
                const transformedPRs = prRepository.transformCombinedPRData([
                  updatedPR,
                ]);
                cachedPRs[prIndex] = transformedPRs[0];

                console.log("💾 Saving optimistic update to cache:", {
                  pr_token: getprtoken.pr_token,
                  pr_code: transformedPRs[0].pr_code,
                  request_reason: reasontext,
                  _pendingSync: transformedPRs[0]._pendingSync,
                  total_cached: cachedPRs.length,
                });

                // Save to cache FIRST
                await prRepository.saveToCache(cachedPRs);
                console.log("💾 Saved to cache, total PRs:", cachedPRs.length);

                // Update component state IMMEDIATELY with the saved data
                // Use the cachedPRs array we just saved (not loading from cache again)
                // Force a new array reference to trigger React re-render
                const updatedPRsArray = [...cachedPRs];

                // Mark that we just did an optimistic update
                justUpdatedOptimistically.current = true;

                setPurchaseRequestData(updatedPRsArray);

                // Reset the flag after a short delay to allow useEffect to run normally later
                setTimeout(() => {
                  justUpdatedOptimistically.current = false;
                }, 1000);

                console.log(
                  "✅ Optimistically updated PR in state and cache:",
                  {
                    pr_token: getprtoken.pr_token,
                    pr_code: transformedPRs[0].pr_code,
                    request_reason: reasontext,
                    items_count: items.length,
                    _pendingSync: transformedPRs[0]._pendingSync,
                    state_updated: true,
                    state_length: updatedPRsArray.length,
                    updated_pr_index: updatedPRsArray.findIndex(
                      (pr) => pr.pr_token === getprtoken.pr_token,
                    ),
                  },
                );

                // Verify it was saved (async, don't block)
                setTimeout(async () => {
                  const verifyCache = await prRepository.getAllFromCache();
                  const savedPR = verifyCache.find(
                    (pr) => pr.pr_token === getprtoken.pr_token,
                  );
                  if (savedPR && savedPR._pendingSync) {
                    console.log(
                      "✅ Verified: Optimistic update persisted in cache",
                    );
                  } else {
                    console.warn(
                      "⚠️ Warning: Optimistic update may not have persisted",
                    );
                  }
                }, 100);
              }
            } else {
              // CREATE NEW PR - Add optimistically to cache
              const tempPRToken = `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
              const prCode = selectedPRCode || generatePRCode();
              const now = new Date();

              // Create new PR object matching combined API structure
              const newPR = {
                pr_token: tempPRToken, // Temporary token, will be replaced when synced
                pr_code: prCode,
                request_reason: reasontext,
                dept_name: prDepartmentName,
                created_on: now.toISOString().split("T")[0], // Format: YYYY-MM-DD
                shipping_address: "",
                buyer_token: user_token,
                buyer_role: loginData?.access_type || "User",
                buyer_user: {
                  first_name: loginData?.user?.first_name || "",
                  last_name: loginData?.user?.last_name || "",
                  email: loginData?.user?.email || "",
                  phone_number: loginData?.user?.phone_number || "",
                  designation: loginData?.user?.designation || "",
                  department: loginData?.user?.department || "",
                  company_name: loginData?.user?.company_name || "",
                  city: loginData?.user?.city || "",
                  state: loginData?.user?.state || "",
                  country: loginData?.user?.country || "",
                  postal_code: loginData?.user?.postal_code || "",
                  address_line: loginData?.user?.address_line || "",
                },
                items: items.map((item, idx) => {
                  const budgetRow = budgetRows[idx] || {};
                  return {
                    item_token: item.itemToken || "",
                    item_name: item.itemName || "",
                    item_code: item.itemCode || "",
                    hsn_code: item.hsnCode || "",
                    quantity: item.quantity || "",
                    unit: item.unit || "",
                    part_number: item.partnumber || "",
                    description: item.description || "",
                    unit_price: parseFloat(item.unitPrice || 0),
                    total_price: parseFloat(item.totalPrice || 0),
                    cost_center:
                      budgetRow.costCentre?.costcenter_code ||
                      budgetRow.costCentre ||
                      "",
                    gl_code:
                      budgetRow.glCode?.gl_code || budgetRow.glCode || "",
                    project_code:
                      budgetRow.projectCode?.project_code ||
                      budgetRow.projectCode ||
                      "",
                    created_date: now.toISOString().split("T")[0],
                    updated_date: now.toISOString().split("T")[0],
                  };
                }),
                approvers: selectedApprovers.map((approver) => ({
                  id: approver.id,
                  first_name: approver.first_name,
                  last_name: approver.last_name,
                  email: approver.email,
                  designation: approver.designation,
                  phone_number: approver.phone_number,
                  status: approver.status || "Awaiting",
                })),
                // Mark as pending sync
                _pendingSync: true,
                _tempToken: tempPRToken,
              };

              // Transform and add to cache
              const transformedPRs = prRepository.transformCombinedPRData([
                newPR,
              ]);
              const updatedPRs = sortPRsByCreatedDateDesc([
                ...cachedPRs,
                transformedPRs[0],
              ]);

              // Save to cache FIRST
              await prRepository.saveToCache(updatedPRs);
              console.log(
                "💾 Saved new PR to cache, total PRs:",
                updatedPRs.length,
              );

              // Update component state IMMEDIATELY with the saved data
              // Force a new array reference to trigger React re-render
              const newPRsArray = [...updatedPRs];

              // Mark that we just did an optimistic update
              justUpdatedOptimistically.current = true;

              // Log before state update
              console.log("🔍 Before state update:", {
                current_state_length: getpurchaserequestdata.length,
                new_array_length: newPRsArray.length,
                new_pr_code: transformedPRs[0].pr_code,
                new_pr_token: transformedPRs[0].pr_token,
              });

              setPurchaseRequestData(newPRsArray);
              setPage(0);

              // Force a re-render by updating a dependency
              // The state update should trigger filteredPRs and paginatedPurchaseRequests to recalculate
              console.log(
                "🔄 State updated, React should re-render with new PR",
              );

              // Verify the new PR is in state
              console.log("🔍 Verifying new PR in state:", {
                state_length: newPRsArray.length,
                new_pr_index: newPRsArray.findIndex(
                  (pr) => pr.pr_token === transformedPRs[0].pr_token,
                ),
                new_pr_code: transformedPRs[0].pr_code,
                new_pr_approval_status: transformedPRs[0].pr_approval_status,
                has_buyer_name: !!transformedPRs[0].buyer_name,
                has_items: transformedPRs[0].items?.length > 0,
              });

              // Reset the flag after a short delay
              setTimeout(() => {
                justUpdatedOptimistically.current = false;
                // Verify it's still in state after delay
                console.log("🔍 After delay - checking state:", {
                  state_length: getpurchaserequestdata.length,
                  new_pr_still_exists: getpurchaserequestdata.some(
                    (pr) => pr.pr_token === transformedPRs[0].pr_token,
                  ),
                });
              }, 1000);

              console.log("✅ Optimistically created PR in state and cache:", {
                pr_token: transformedPRs[0].pr_token,
                pr_code: transformedPRs[0].pr_code,
                request_reason: reasontext,
                _pendingSync: transformedPRs[0]._pendingSync,
                state_updated: true,
                state_length: newPRsArray.length,
              });
            }
          } catch (cacheError) {
            console.error("Error updating cache optimistically:", cacheError);
            // Continue anyway - queue is still saved
          }
        } catch (queueError) {
          console.error("Error queuing action:", queueError);
          // Still show popup even if queue fails
        }

        // Show success message (optimistic) - ALWAYS show, even if queue/cache fails
        const popupMessage = editpr ? "PR update queued" : "PR creation queued";
        const popupDescription = editpr
          ? `${selectedPRCode || "PR"} will be updated when online`
          : `${selectedPRCode || "PR"} will be created when online`;

        console.log("📱 Showing offline popup:", {
          popupMessage,
          popupDescription,
          editpr,
        });

        // DON'T refresh from cache here - state was already updated above
        // The optimistic update already updated both cache and state
        // Refreshing here could cause race conditions with useEffect
        console.log(
          "✅ State already updated with optimistic changes, skipping refresh",
        );

        // Clear loading and show popup - ensure all state updates happen
        setLoadingPR(false);
        setSuccessPopUp(true);
        setUserPopupHeroText(popupMessage);
        setUserPopupdescription(popupDescription);

        // Close form and reset all states (same as online mode)
        setProceedRFQ(false);
        setViewPR(false);
        setViewRaisedPR(false);
        if (editpr) {
          setEditPR(false);
        }

        console.log("✅ Popup state updated - form closed, should show now");

        return; // Exit early - action is queued
      }

      // ONLINE MODE: Make API call directly
      try {
        const response = await axios.post(
          API_ENDPOINT.ins_purchase_request,
          formData,
          {
            headers: {
              Authorization: `Bearer ${auth_token}`,
              "Content-Type": "multipart/form-data",
            },
          },
        );

        if (response?.status === 200) {
          if (!editpr) {
            await getAllPurchaseRequest();
            setPage(0);
            // Temporarily disabled: Raise PR should not auto-create an RFQ.
            await handleSavePRtoRFQ(formData);
            setSuccessPopUp(true);
            setUserPopupHeroText("PR created successfully");
            setUserPopupdescription(`${selectedPRCode || generatePRCode()} created successfully`);
            setProceedRFQ(false);
            setViewPR(false);
            setViewRaisedPR(false);
          } else {
            // Update local cache/state immediately so View/Edit reflects new dept/budget without reload
            try {
              const prToken = getprtoken?.pr_token;
              if (prToken) {
                const cachedPRs = await prRepository.getAllFromCache();
                const prIndex = cachedPRs.findIndex((pr) => pr.pr_token === prToken);

                if (prIndex !== -1) {
                  const shippingData = buyerUserDetails || user_details || {};
                  const existingPR = cachedPRs[prIndex] || {};
                  const existingItems = Array.isArray(existingPR.items)
                    ? existingPR.items
                    : [];

                  const updatedPR = {
                    ...existingPR,
                    request_reason: reasontext,
                    dept_name: prDepartmentName,
                    // Keep budgetDetails if backend supports it (used to render multiple budget lines)
                    budgetDetails: simplifiedBudget,
                    shipping_address:
                      shippingData.shipping_address1 ||
                      shippingData.address_line ||
                      "",
                    buyer_user: {
                      ...(existingPR.buyer_user || {}),
                      ...buyerUserDetails,
                      address_line:
                        shippingData.shipping_address1 ||
                        shippingData.address_line ||
                        "",
                      city: shippingData.city || buyerUserDetails?.city || "",
                      state: shippingData.state || buyerUserDetails?.state || "",
                      country:
                        shippingData.country || buyerUserDetails?.country || "",
                      postal_code:
                        shippingData.postal_code ||
                        shippingData.pincode ||
                        buyerUserDetails?.postal_code ||
                        "",
                      phone_number:
                        shippingData.phone_number ||
                        shippingData.mobile_number ||
                        buyerUserDetails?.phone_number ||
                        "",
                    },
                    // Keep cache items aligned with the budget rows by index
                    items: items.map((item, idx) => {
                      const budgetRow = budgetRows[idx] || {};
                      const prev = existingItems[idx] || {};

                      return {
                        ...prev,
                        item_token: item.itemToken || prev.item_token || "",
                        item_name: item.itemName || "",
                        item_code: item.itemCode || "",
                        hsn_code: item.hsnCode || "",
                        quantity: item.quantity || "",
                        unit: item.unit || "",
                        part_number: item.partnumber || "",
                        description: item.description || "",
                        unit_price: parseFloat(item.unitPrice || 0),
                        total_price: parseFloat(item.totalPrice || 0),
                        cost_center:
                          budgetRow.costCentre?.costcenter_code ||
                          budgetRow.costCentre ||
                          prev.cost_center ||
                          "",
                        gl_code:
                          budgetRow.glCode?.gl_code ||
                          budgetRow.glCode ||
                          prev.gl_code ||
                          "",
                        project_code:
                          budgetRow.projectCode?.project_code ||
                          budgetRow.projectCode ||
                          prev.project_code ||
                          "",
                      };
                    }),
                    approvers: selectedApprovers.map((approver) => ({
                      id: approver.id,
                      first_name: approver.first_name,
                      last_name: approver.last_name,
                      email: approver.email,
                      designation: approver.designation,
                      phone_number: approver.phone_number,
                      status: approver.status || "Awaiting",
                    })),
                    // Do not mark as _pendingSync / _lastUpdated for online success
                    _pendingSync: false,
                    _lastUpdated: null,
                  };

                  const transformedPRs = prRepository.transformCombinedPRData([
                    updatedPR,
                  ]);
                  cachedPRs[prIndex] = transformedPRs[0];
                  await prRepository.saveToCache(cachedPRs);
                  setPurchaseRequestData([...cachedPRs]);
                }
              }
            } catch (cacheUpdateError) {
              console.warn("Unable to update PR cache after online update:", cacheUpdateError);
            }

            setSuccessPopUp(true);
            setUserPopupHeroText("PR updated successfully");
            setUserPopupdescription(`${selectedPRCode} updated successfully`);
            // Refresh list from API in background
            getAllPurchaseRequest();
            setProceedRFQ(false);
          }
        }
      } catch (apiError) {
        // Check if it's a network/server error (server unreachable)
        const isNetworkError =
          apiError?.code === "ERR_NETWORK" ||
          apiError?.code === "ERR_CONNECTION_REFUSED" ||
          apiError?.message?.includes("Network Error") ||
          apiError?.message?.includes("Connection refused");

        if (isNetworkError) {
          // Server unreachable - queue the action as offline
          console.log("📴 Server unreachable - queuing PR action as offline");

          try {
            const actionType = editpr ? "update" : "create";
            await offlineQueue.enqueue(
              actionType,
              API_ENDPOINT.ins_purchase_request,
              formData,
            );

            // Optimistic cache update
            try {
              const cachedPRs = await prRepository.getAllFromCache();

              if (editpr && getprtoken?.pr_token) {
                // UPDATE EXISTING PR
                const prIndex = cachedPRs.findIndex(
                  (pr) => pr.pr_token === getprtoken.pr_token,
                );

                if (prIndex !== -1) {
                  const updatedPR = {
                    ...cachedPRs[prIndex],
                    request_reason: reasontext,
                    dept_name: prDepartmentName,
                    items: items.map((item, idx) => {
                      const budgetRow = budgetRows[idx] || {};
                      return {
                        item_token:
                          item.itemToken ||
                          cachedPRs[prIndex].items?.[idx]?.item_token ||
                          "",
                        item_name: item.itemName || "",
                        item_code: item.itemCode || "",
                        hsn_code: item.hsnCode || "",
                        quantity: item.quantity || "",
                        unit: item.unit || "",
                        part_number: item.partnumber || "",
                        description: item.description || "",
                        unit_price: parseFloat(item.unitPrice || 0),
                        total_price: parseFloat(item.totalPrice || 0),
                        cost_center:
                          budgetRow.costCentre?.costcenter_code ||
                          budgetRow.costCentre ||
                          "",
                        gl_code:
                          budgetRow.glCode?.gl_code || budgetRow.glCode || "",
                        project_code:
                          budgetRow.projectCode?.project_code ||
                          budgetRow.projectCode ||
                          "",
                      };
                    }),
                    approvers: selectedApprovers.map((approver) => ({
                      id: approver.id,
                      first_name: approver.first_name,
                      last_name: approver.last_name,
                      email: approver.email,
                      designation: approver.designation,
                      phone_number: approver.phone_number,
                      status: approver.status || "Awaiting",
                    })),
                  };

                  const transformedPRs = prRepository.transformCombinedPRData([
                    updatedPR,
                  ]);
                  cachedPRs[prIndex] = transformedPRs[0];
                  await prRepository.saveToCache(cachedPRs);
                  setPurchaseRequestData(cachedPRs);
                }
              } else {
                // CREATE NEW PR
                const tempPRToken = `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
                const prCode = selectedPRCode || generatePRCode();
                const now = new Date();

                const newPR = {
                  pr_token: tempPRToken,
                  pr_code: prCode,
                  request_reason: reasontext,
                  dept_name: prDepartmentName,
                  created_on: now.toISOString().split("T")[0],
                  shipping_address: "",
                  buyer_token: user_token,
                  buyer_role: loginData?.access_type || "User",
                  buyer_user: {
                    first_name: loginData?.user?.first_name || "",
                    last_name: loginData?.user?.last_name || "",
                    email: loginData?.user?.email || "",
                    phone_number: loginData?.user?.phone_number || "",
                    designation: loginData?.user?.designation || "",
                    department: loginData?.user?.department || "",
                    company_name: loginData?.user?.company_name || "",
                    city: loginData?.user?.city || "",
                    state: loginData?.user?.state || "",
                    country: loginData?.user?.country || "",
                    postal_code: loginData?.user?.postal_code || "",
                    address_line: loginData?.user?.address_line || "",
                  },
                  items: items.map((item, idx) => {
                    const budgetRow = budgetRows[idx] || {};
                    return {
                      item_token: item.itemToken || "",
                      item_name: item.itemName || "",
                      item_code: item.itemCode || "",
                      hsn_code: item.hsnCode || "",
                      quantity: item.quantity || "",
                      unit: item.unit || "",
                      part_number: item.partnumber || "",
                      description: item.description || "",
                      unit_price: parseFloat(item.unitPrice || 0),
                      total_price: parseFloat(item.totalPrice || 0),
                      cost_center:
                        budgetRow.costCentre?.costcenter_code ||
                        budgetRow.costCentre ||
                        "",
                      gl_code:
                        budgetRow.glCode?.gl_code || budgetRow.glCode || "",
                      project_code:
                        budgetRow.projectCode?.project_code ||
                        budgetRow.projectCode ||
                        "",
                      created_date: now.toISOString().split("T")[0],
                      updated_date: now.toISOString().split("T")[0],
                    };
                  }),
                  approvers: selectedApprovers.map((approver) => ({
                    id: approver.id,
                    first_name: approver.first_name,
                    last_name: approver.last_name,
                    email: approver.email,
                    designation: approver.designation,
                    phone_number: approver.phone_number,
                    status: approver.status || "Awaiting",
                  })),
                  _pendingSync: true,
                  _tempToken: tempPRToken,
                };

                const transformedPRs = prRepository.transformCombinedPRData([
                  newPR,
                ]);
                const updatedPRs = sortPRsByCreatedDateDesc([
                  ...cachedPRs,
                  transformedPRs[0],
                ]);
                await prRepository.saveToCache(updatedPRs);
                setPurchaseRequestData(updatedPRs);
                setPage(0);
              }
            } catch (cacheError) {
              console.error("Error updating cache optimistically:", cacheError);
            }

            // Show success message
            const popupMessage = editpr
              ? "PR update queued"
              : "PR creation queued";
            const popupDescription = editpr
              ? `${selectedPRCode || "PR"} will be updated when server is available`
              : `${selectedPRCode || "PR"} will be created when server is available`;

            getAllPurchaseRequest();
            setLoadingPR(false);
            setSuccessPopUp(true);
            setUserPopupHeroText(popupMessage);
            setUserPopupdescription(popupDescription);
            setProceedRFQ(false);
            setViewPR(false);
            setViewRaisedPR(false);
            if (editpr) {
              setEditPR(false);
            }

            return; // Exit early - action is queued
          } catch (queueError) {
            console.error(
              "Error queuing action after network error:",
              queueError,
            );
            // Fall through to show error message
          }
        }

        // Other errors (not network) - show error message
        console.error(
          "Error saving PR:",
          apiError.response?.data || apiError.message,
        );
        const errorMessage =
          apiError.response?.data?.response ||
          apiError.message ||
          "Please attach the file";
        if (isBudgetApiError(apiError)) {
          setBudgetUploadError(errorMessage);
        } else {
          setFileuploadError(errorMessage);
        }
      }
    } catch (error) {
      console.error(
        "Error in handleSavePurchaseRequest:",
        error.response?.data || error.message,
      );
      const errorMessage =
        error.response?.data?.response || error.message || "An error occurred";
      if (isBudgetApiError(error)) {
        setBudgetUploadError(errorMessage);
      } else {
        setFileuploadError(errorMessage);
      }
    } finally {
      setLoadingPR(false);
    }
  };

	  const handleApprovePR = async (pr_token, bool) => {
	    try {
	      const response = await axios.post(
	        API_ENDPOINT.approve_pr,
        {
          user_token,
          pr_token,
          status: bool,
        },
	        { headers: { Authorization: `Bearer ${auth_token}` } },
	      );

	      if (response.status === 200) {
	        const nextCode = Number(bool);
	        const nextApproverStatus =
	          nextCode === 1 ? "Approved" : nextCode === 3 ? "Cancelled" : "Awaiting";

	        recentApprovalsRef.current.set(pr_token, {
	          ts: Date.now(),
	          code: nextCode,
	          statusText: nextApproverStatus,
	        });

	        // Optimistic UI update so the row changes immediately.
	        setPurchaseRequestData((prev) =>
	          (Array.isArray(prev) ? prev : []).map((pr) => {
	            if (pr?.pr_token !== pr_token) return pr;

		            const approvers = (Array.isArray(pr?.approvers) ? pr.approvers : []).map(
		              (a) =>
		                isCurrentUserApprover(a)
		                  ? {
		                      ...a,
		                      status: nextApproverStatus,
		                      approval_status_code: nextCode,
		                    }
		                  : a,
		            );

	            let pr_approval_status = pr?.pr_approval_status || "Awaiting";
	            if (approvers.length > 0) {
	              const allApproved = approvers.every((a) => a.status === "Approved");
	              const anyRejected = approvers.some(
	                (a) => a.status === "Rejected" || a.status === "Cancelled",
	              );
	              if (anyRejected) pr_approval_status = "Rejected";
	              else if (allApproved) pr_approval_status = "Approved";
	              else pr_approval_status = "Awaiting";
	            }

	            return { ...pr, approvers, pr_approval_status };
	          }),
	        );

	        // Best-effort cache sync so offline hook doesn't overwrite the optimistic status.
	        prRepository
	          .getAllFromCache()
	          .then((cached) => {
	            const next = (Array.isArray(cached) ? cached : []).map((pr) => {
	              if (pr?.pr_token !== pr_token) return pr;
		              const approvers = (Array.isArray(pr?.approvers) ? pr.approvers : []).map(
		                (a) =>
		                  isCurrentUserApprover(a)
		                    ? {
		                        ...a,
		                        status: nextApproverStatus,
		                        approval_status_code: nextCode,
		                      }
		                    : a,
		              );

	              let pr_approval_status = pr?.pr_approval_status || "Awaiting";
	              if (approvers.length > 0) {
	                const allApproved = approvers.every((a) => a.status === "Approved");
	                const anyRejected = approvers.some(
	                  (a) => a.status === "Rejected" || a.status === "Cancelled",
	                );
	                if (anyRejected) pr_approval_status = "Rejected";
	                else if (allApproved) pr_approval_status = "Approved";
	                else pr_approval_status = "Awaiting";
	              }

	              return { ...pr, approvers, pr_approval_status };
	            });
	            return prRepository.saveToCache(next);
	          })
	          .catch(() => {
	            // ignore cache sync errors
	          });

		        // Backend combined view may lag behind approve_pr updates; avoid immediately overwriting
		        // the optimistic UI state with stale "Pending" data.
		        setTimeout(() => {
		          getAllPurchaseRequest(page);
		        }, 1500);
	      }
		    } catch (error) {
		      console.error("Error approving PR:", error);
		    }
		  };

  const handleSavePRtoRFQ = async (formData) => {
    try {
      formData.append("RFQ Code", generatePRCode());

      const response = await axios.post(API_ENDPOINT.save_quick_rfq, formData, {
        headers: {
          Authorization: `Bearer ${auth_token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      if (response?.status === 200) {
        sendNewRFQToken(response?.data?.rfq_token);
        setSuccessPopUp(true);
        setUserPopupHeroText("PR created successfully");
        setUserPopupdescription(`${selectedPRCode} is now available in RFQ`);
        getAllPurchaseRequest();
        setPage(0);
        setProceedRFQ(false);
      }
    } catch (error) {
      console.error("Error saving RFQ:", error.response?.data || error.message);
    }
  };

  const sendNewRFQToken = async (token) => {
    await axios({
      method: "POST",
      url: `${API_ENDPOINT.rfq_newversion_chatgpt}`,
      data: {
        rfq_token: token,
        org_token,
      },
      headers: {
        Authorization: `Bearer ${auth_token}`,
      },
    })
      .then((res) => {
        console.log(res);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleSwitch = async (item, editpr = false) => {
    const viewSequence = ++prViewSequenceRef.current;
    try {
      const masterDataPromise = Promise.all([
          departmentList.length > 0
            ? Promise.resolve(departmentList)
            : axios
                .post(
                  `${API_ENDPOINT.get_Department}`,
                  { user_token },
                  { headers: { Authorization: `Bearer ${auth_token}` } },
                )
                .then((response) => {
                  const departments = response.data?.data || [];
                  setDepartmentList(departments);
                  return departments;
                }),
          constcenter.length > 0
            ? Promise.resolve(constcenter)
            : costcentreRequest(),
          glcode.length > 0 ? Promise.resolve(glcode) : glcodeRequest(),
          projectcode.length > 0
            ? Promise.resolve(projectcode)
            : projectCodeRequest(),
      ]);

      // Prefer combined PR data because it carries budgetDetails for the budget grid.
      const cachedPRs = await prRepository.getAllFromCache();
      const cachedPR = cachedPRs.find((pr) => pr.pr_token === item.pr_token);
      const hasPendingSync = cachedPR?._pendingSync || cachedPR?._lastUpdated;

      let prData = null;
      let itemList = [];

      if (hasPendingSync && cachedPR) {
        prData = cachedPR;
        itemList = cachedPR.items || [];
      } else if (
        item &&
        (Array.isArray(item?.items) ||
          Array.isArray(item?.budgetDetails) ||
          Array.isArray(item?.budget_details))
      ) {
        prData = item;
        itemList = item.items || [];
      } else if (cachedPR) {
        prData = cachedPR;
        itemList = cachedPR.items || [];
      } else {
        // Fallback to individual PR cache
        prData = await prRepository.getIndividualPRFromCache(item.pr_token);
        itemList = prData?.items || [];
      }

      if (!prData) {
        try {
          const combinedRequestData =
            loginData?.access_type === "Buyer"
              ? { org_id, pr_token: item.pr_token }
              : { user_token, pr_token: item.pr_token };

          const combinedResponse = await axios({
            url: `${API_ENDPOINT.combined_saved_pr_with_items_view}`,
            method: "POST",
            data: combinedRequestData,
            headers: {
              Authorization: `Bearer ${auth_token}`,
            },
          });

          const purchaseRequests =
            combinedResponse?.data?.purchase_requests || [];
          const syncedData = prRepository
            .transformCombinedPRData(purchaseRequests)
            .find((pr) => pr.pr_token === item.pr_token);
          if (syncedData) {
            // Only use synced data if it's newer than our optimistic update
            if (
              !hasPendingSync ||
              (syncedData.updated_date &&
                cachedPR?.updated_date &&
                new Date(syncedData.updated_date) >
                  new Date(cachedPR.updated_date))
            ) {
              prData = syncedData;
              itemList = syncedData?.items || [];
              console.log("✅ Using synced data from API");
            } else {
              console.log("⚠️ Keeping optimistic update - API data is older");
            }
          }
        } catch (error) {
          console.error("Error syncing combined PR:", error);
          // Continue with cached data if API fails
        }
      } else if (hasPendingSync) {
        console.log(
          "📱 Using cached data with pending sync (optimistic update)",
        );
      }

      // If still no data, fallback to direct API call (for backward compatibility)
      if (!prData) {
        const response = await axios({
          method: "POST",
          url: `${API_ENDPOINT.purchase_request_individual_items_view}`,
          data: {
            pr_token: item.pr_token,
          },
          headers: {
            Authorization: `Bearer ${auth_token}`,
          },
        });
        prData = response.data?.response;
        itemList = response.data?.response?.items || [];

        // Cache the response for future use
        if (prData) {
          await prRepository.saveIndividualPRToCache(item.pr_token, prData);
        }
      }

      const [deptList, costCenterList, glCodeList, projectCodeList] = editpr
        ? await masterDataPromise
        : [departmentList, constcenter, glcode, projectcode];
      if (!editpr) {
        void masterDataPromise.catch((error) =>
          console.error("Unable to refresh PR master data:", error),
        );
      }

      setReasonText(prData?.request_reason || "");

      const itemMasterList = Array.isArray(getItemMaster) ? getItemMaster : [];
      const hasMissingMasterItem = itemList.some((prItem) =>
        !itemMasterList.some(
          (masterItem) =>
            String(masterItem?.token || masterItem?.item_token || "") ===
              String(prItem?.item_token || "") ||
            String(masterItem?.item_code || "") ===
              String(prItem?.item_code || ""),
        ),
      );

      const itemMasterLoadPromise =
        hasMissingMasterItem && navigator.onLine ? getAllItems() : null;

      const formatItems = (masterItems) => itemList.map((item) => {
        const masterItem = masterItems.find(
          (master) =>
            String(master?.token || master?.item_token || "") ===
              String(item?.item_token || "") ||
            String(master?.item_code || "") === String(item?.item_code || ""),
        );

        return {
          itemToken: item.item_token || masterItem?.token || "",
          itemName: item.item_name || masterItem?.item_name || "",
          itemCode: item.item_code || masterItem?.item_code || "",
          category: item.category || masterItem?.category || "",
          expenseType:
            item.expense_type || item.expenseType || masterItem?.expense_type || "",
          subCategory: masterItem?.sub_category || "",
          itemType: masterItem?.item_type || "",
          quantity: item.quantity || "",
          unit: item.unit || masterItem?.uom || "",
          hsnCode: item.hsn_code || masterItem?.hsn_code || "",
          unspscCode: item.unspsc_code || masterItem?.unspsc_code || "",
          partnumber:
            item.part_number || masterItem?.manufacturer_part_no || "",
          description: item.description || masterItem?.item_description || "",
          brand: masterItem?.brand || "",
          specifications: masterItem?.specifications || "",
          aliases: masterItem?.aliases || "",
          gstList: Array.isArray(masterItem?.GST_list) ? masterItem.GST_list : [],
          unitPrice: parseFloat(item.unit_price || 0),
          totalPrice: parseFloat(item.total_price || 0),
        };
      });
      const formattedItems = formatItems(itemMasterList);

      const budgetDetailsRaw =
        (Array.isArray(prData?.budgetDetails) && prData.budgetDetails) ||
        (Array.isArray(prData?.budget_details) && prData.budget_details) ||
        null;

      const firstBudgetDetail = Array.isArray(budgetDetailsRaw)
        ? budgetDetailsRaw.find((detail) => detail && typeof detail === "object")
        : null;
      const firstBudgetItem = itemList.find(
        (lineItem) =>
          getBudgetFieldValue(lineItem, ["budget_department", "department"]),
      );
      const departmentNameForBudget =
        getBudgetFieldValue(prData, ["dept_name", "department"]) ||
        getBudgetFieldValue(firstBudgetDetail, [
          "department",
          "budget_department",
          "dept_name",
        ]) ||
        getBudgetFieldValue(firstBudgetItem, [
          "budget_department",
          "department",
        ]);
      const departmentIdForBudget =
        getBudgetFieldValue(prData, [
          "dept_id",
          "department_id",
          "departmentId",
          "deptId",
          "department_token",
          "dept_token",
          "id",
          "token",
        ]) ||
        getBudgetFieldValue(firstBudgetDetail, [
          "dept_id",
          "department_id",
          "departmentId",
          "deptId",
          "department_token",
          "dept_token",
          "id",
          "token",
        ]) ||
        "";

      const normalizedDeptId = String(departmentIdForBudget || "").trim();
      const normalizedDeptName = normalizeName(departmentNameForBudget);

      const selectedDept =
        deptList.find((dep) => {
          if (!dep) return false;
          if (normalizedDeptId) {
            const depId = dep?.id ?? dep?.token ?? dep?.department_id ?? "";
            if (String(depId || "").trim() === normalizedDeptId) return true;
          }
          if (normalizedDeptName) {
            return normalizeName(dep?.name) === normalizedDeptName;
          }
          return false;
        }) ||
        (departmentNameForBudget ? { name: departmentNameForBudget } : null);

      const resolvedBudgetDepartmentName =
        selectedDept?.name || departmentNameForBudget || "";
      setSelectedDepartment(selectedDept);
      setBudgetConfig(null);
      if (resolvedBudgetDepartmentName) {
        void fetchBudgetConfig(resolvedBudgetDepartmentName);
      }

      const budgetFormatted = itemList.map((lineItem) => {
        const rowDepartment =
          getBudgetFieldValue(lineItem, ["budget_department", "department"]) ||
          resolvedBudgetDepartmentName;

        return {
          department: rowDepartment,
          costCentre: buildBudgetOptionFromCode(
            costCenterList,
            getBudgetFieldValue(lineItem, [
              "cost_center",
              "costCenterCode",
              "cost_center_code",
              "costcenter_code",
              "costCentreCode",
            ]),
            "costcenter_code",
            rowDepartment,
          ),
          glCode: buildBudgetOptionFromCode(
            glCodeList,
            getBudgetFieldValue(lineItem, [
              "gl_code",
              "glCode",
              "gl_code_value",
              "glcode",
            ]),
            "gl_code",
            rowDepartment,
          ),
          projectCode: buildBudgetOptionFromCode(
            projectCodeList,
            getBudgetFieldValue(lineItem, [
              "project_code",
              "projectCode",
              "project_code_value",
              "projectcode",
            ]),
            "project_code",
            rowDepartment,
          ),
        };
      });

      if (budgetDetailsRaw) {
        const formattedFromBudgetDetails = budgetDetailsRaw
          .map((b) => {
            const rowDepartment =
              getBudgetFieldValue(b, [
                "department",
                "budget_department",
                "dept_name",
              ]) || resolvedBudgetDepartmentName;
            const costCode = getBudgetFieldValue(b, [
              "costCenterCode",
              "cost_center",
              "cost_center_code",
              "costcenter_code",
              "costCentreCode",
            ]);
            const gl = getBudgetFieldValue(b, [
              "glCode",
              "gl_code",
              "gl_code_value",
              "glcode",
            ]);
            const project = getBudgetFieldValue(b, [
              "projectCode",
              "project_code",
              "project_code_value",
              "projectcode",
            ]);

            return {
              department: rowDepartment,
              costCentre: buildBudgetOptionFromCode(
                costCenterList,
                costCode,
                "costcenter_code",
                rowDepartment,
              ),
              glCode: buildBudgetOptionFromCode(
                glCodeList,
                gl,
                "gl_code",
                rowDepartment,
              ),
              projectCode: buildBudgetOptionFromCode(
                projectCodeList,
                project,
                "project_code",
                rowDepartment,
              ),
            };
          })
          .filter(
            (row) => row.costCentre || row.glCode || row.projectCode,
          );

        const budgetRowsForItems =
          formattedFromBudgetDetails.length > 0
            ? formattedFromBudgetDetails
            : budgetFormatted;
        setBudgetRows(
          budgetRowsForItems.length > formattedItems.length
            ? budgetRowsForItems.slice(0, formattedItems.length)
            : [
                ...budgetRowsForItems,
                ...Array.from(
                  {
                    length: Math.max(
                      formattedItems.length - budgetRowsForItems.length,
                      0,
                    ),
                  },
                  () => createEmptyBudgetRow(),
                ),
              ].slice(0, Math.max(formattedItems.length, 1)),
        );
      } else {
        setBudgetRows(
          budgetFormatted.length > formattedItems.length
            ? budgetFormatted.slice(0, formattedItems.length)
            : [
                ...budgetFormatted,
                ...Array.from(
                  { length: Math.max(formattedItems.length - budgetFormatted.length, 0) },
                  () => createEmptyBudgetRow(),
                ),
              ].slice(0, Math.max(formattedItems.length, 1)),
        );
      }
      setBudgetInputMethod("manual");
      setBudgetUploadFile(null);
      setBudgetUploadError("");
      setBudgetDragging(false);
      resetBudgetUploadInput();
      setItems(formattedItems);
      if (itemMasterLoadPromise) {
        void itemMasterLoadPromise.then((masterItems) => {
          if (viewSequence !== prViewSequenceRef.current) return;
          setItems(formatItems(Array.isArray(masterItems) ? masterItems : []));
        });
      }
      setSelectedPRCode(prData?.pr_code || "");
      setBuyerUserDetails(prData?.buyer_user || {});

      // Set PR date if available - check item first (from list), then prData
      const dateField =
        item?.created_on ||
        prData?.created_on ||
        prData?.request_date ||
        prData?.date ||
        prData?.created_date ||
        prData?.date_of_request;

      if (dateField) {
        setPRDate(dateField);
      } else {
        setPRDate(null);
      }
	      const normalizeApproverStatus = (rawStatus, statusCode) => {
	        const effective = statusCode ?? rawStatus;
	        if (effective == null) return "Pending";
	        const numeric = Number(effective);
	        if (!Number.isNaN(numeric)) {
	          if (numeric === 1) return "Approved";
	          if (numeric === 3) return "Cancelled";
	          return "Pending";
	        }
	        const status = String(effective).trim();
	        const lower = status.toLowerCase();
	        if (!lower) return "Pending";
	        if (lower === "approved") return "Approved";
	        if (lower === "pending") return "Pending";
	        if (lower === "rejected") return "Rejected";
	        if (lower === "cancelled" || lower === "canceled") return "Cancelled";
	        return status;
	      };

	      const approvers = (prData.approvers || []).map((approver) => ({
	        first_name: approver.first_name,
	        last_name: approver.last_name,
	        email: approver.email,
	        designation: approver.designation,
	        phone_number: approver.phone_number,
	        status: normalizeApproverStatus(
	          approver.status,
	          approver.approval_status_code,
	        ),
	      }));

      setSelectedApprovers(approvers);

      setProceedRFQ(true);
      setViewPR(true);
      setViewRaisedPR(true);
      setEditPR(editpr);
    } catch (error) {
      console.log(error);
    }
  };

  const handleBack = () => {
    prViewSequenceRef.current += 1;
    getAllPurchaseRequest();
    getPRforCode();
    setProceedRFQ(false);
    setViewPR(false);
	    setViewRaisedPR(false);
	    // Clear pr_token when going back (in case user creates new PR after)
    setPRToken({ pr_token: "" });
    setEditPR(false);

    setReasonText("");
    setSelectedDepartment(null);
    setBudgetConfig(null);
    setDepartmentError("");
    setFileuploadError("");
    setManualItemErrors({});
    setItems([
      {
        itemToken: "",
        itemName: "",
        itemNameInput: "",
        itemCode: "",
        itemCodeInput: "",
        category: "",
        expenseType: "",
        quantity: "",
        unit: "",
        hsnCode: "",
        partnumber: "",
        description: "",
        unitPrice: "",
        totalPrice: "",
      },
    ]);
    setBudgetRows([createEmptyBudgetRow()]);
    setSelectedPRCode("");
    setBuyerUserDetails({});
    setFileUpload(null);
    setInputMethod("xls");
    setBudgetInputMethod("manual");
    setBudgetUploadFile(null);
    setBudgetUploadError("");
    setBudgetDragging(false);
    resetBudgetUploadInput();
    setSelectedApprovers([]);
    setSuccessPopUp(false);
    setPRDate(null);
  };

  const handleRaisePR = () => {
    // Clear pr_token when creating a new PR (not editing)
    setPRToken({ pr_token: "" });
    setEditPR(false);
    setSelectedDepartment(null);
    setBudgetConfig(null);
    setDepartmentError("");
    setFileuploadError("");
    setManualItemErrors({});
    setPRCode(generatePRCode(getpurchasecode));
    setBudgetRows([createEmptyBudgetRow()]);
    setBudgetInputMethod("manual");
    setBudgetUploadFile(null);
    setBudgetUploadError("");
    setBudgetDragging(false);
    resetBudgetUploadInput();
    setProceedRFQ(true);
    setViewPR(false);
    setEditPR(false);

    if (departmentList.length === 0) {
      void getAllDepartment();
    }

    if (
      (!Array.isArray(getpurchasecode) || getpurchasecode.length === 0) &&
      shouldMakeAPICall(auth_token, user_token)
    ) {
      void getPRforCode().then((latestCodes) => {
        setPRCode(generatePRCode(latestCodes));
      });
    }
  };

  useEffect(() => {
    // If create form is already open and PR codes arrive late, refresh code once.
    if (!proceedRFQ || viewpr || editpr) return;
    const nextCode = generatePRCode();
    if (!prCode || (prCode.startsWith("PR-001/") && prCode !== nextCode)) {
      setPRCode(nextCode);
    }
  }, [
    getpurchasecode,
    getpurchaserequestdata,
    proceedRFQ,
    viewpr,
    editpr,
    prCode,
  ]);

  const handleViewPR = (item) => {
    handleSwitch(item);
    setProceedRFQ(true);
    setViewPR(true);
    setEditPR(false);
  };

  const handleEditPR = (item) => {
    setPRToken((prevToken) => ({ ...prevToken, pr_token: item.pr_token }));
    handleSwitch(item, true);
    setProceedRFQ(true);
    setViewPR(false);
    setEditPR(true);
  };

  const handleRemoveApprover = (index) => {
    const updatedApprovers = [...selectedApprovers];
    updatedApprovers.splice(index, 1);
    setSelectedApprovers(updatedApprovers);
  };

  const showItemSection = proceedRFQ && !viewraisedpr;
  const canEditBudget = !(viewpr && !editpr);
  const budgetRowsToDisplay = canEditBudget
    ? budgetRows
    : budgetRows.filter(hasBudgetRowData);
  const showBudgetRowActions = items.length > 1;
  const canAddBudgetRow = budgetRows.length < items.length;
	
	  const access_type = loginData?.access_type;
	  const userName = String(loginData?.user?.first_name || "").toLowerCase();
	  const userEmail = String(loginData?.user?.email || "").toLowerCase();
	  const userToken = String(user_token || "").trim();
	
	  const isCurrentUserApprover = (approver) => {
	    if (!approver || typeof approver !== "object") return false;
	    const approverToken = String(
	      approver.token || approver.user_token || approver.userToken || "",
	    ).trim();
	    const approverEmail = String(approver.email || "").toLowerCase();
	    const approverName = String(
	      approver.name ||
	        `${approver.first_name || ""} ${approver.last_name || ""}`.trim(),
	    ).toLowerCase();
	
	    if (userToken && approverToken && approverToken === userToken) return true;
	    if (userEmail && approverEmail && approverEmail === userEmail) return true;
	    if (userName && approverName && approverName.includes(userName)) return true;
	    return false;
	  };
	
	  const findCurrentApprover = (pr) =>
	    (Array.isArray(pr?.approvers) ? pr.approvers : []).find((a) =>
	      isCurrentUserApprover(a),
	    );

	  const applyRecentApprovalOverrides = (prs = []) => {
	    const recent = recentApprovalsRef.current;
	    if (!recent || recent.size === 0) return prs;

	    const now = Date.now();
	    // Keep overrides for a short window to mask backend view delay
	    const MAX_AGE_MS = 60_000;

	    // Cleanup old entries
	    for (const [token, entry] of recent.entries()) {
	      if (!entry || now - entry.ts > MAX_AGE_MS) {
	        recent.delete(token);
	      }
	    }
	    if (recent.size === 0) return prs;

	    return (Array.isArray(prs) ? prs : []).map((pr) => {
	      const entry = recent.get(pr?.pr_token);
	      if (!entry) return pr;

	      const approvers = (Array.isArray(pr?.approvers) ? pr.approvers : []).map(
	        (a) => {
	          if (!isCurrentUserApprover(a)) return a;
	          const currentCode = Number(a?.approval_status_code);
	          const incomingCode = Number.isNaN(currentCode) ? null : currentCode;
	          // If API already matches, no need to override
	          if (incomingCode === entry.code) return a;
	          // If API shows "Pending" but we recently approved/rejected, keep local.
	          if (incomingCode === 2 || incomingCode == null) {
	            return {
	              ...a,
	              approval_status_code: entry.code,
	              status: entry.statusText,
	            };
	          }
	          return a;
	        },
	      );

	      let pr_approval_status = pr?.pr_approval_status || "Pending";
	      if (approvers.length > 0) {
	        const allApproved = approvers.every((a) => a.status === "Approved");
	        const anyRejected = approvers.some(
	          (a) => a.status === "Rejected" || a.status === "Cancelled",
	        );
	        if (anyRejected) pr_approval_status = "Rejected";
	        else if (allApproved) pr_approval_status = "Approved";
	        else pr_approval_status = "Pending";
	      }

	      return { ...pr, approvers, pr_approval_status };
	    });
	  };
	
	  const isApprover = getpurchaserequestdata?.some((pr) =>
	    Boolean(findCurrentApprover(pr)),
	  );

  const handleClearSearchTerm = () => {
    setSearchTerm("");
  };

  const handleClearFilters = () => {
    setStatusFilter("all");
  };

  function PaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
      const lastPage = Math.max(0, Math.ceil(count / rowsPerPage) - 1);
      onPageChange(event, lastPage);
    };

    const isBackDisabled = page === 0;
    const isNextDisabled = page >= Math.ceil(count / rowsPerPage) - 1;

    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={isBackDisabled}
          aria-label="first page"
          size="medium"
          sx={{ p: 1.25 }}
        >
          {theme.direction === "rtl" ? (
            <LastPageIcon sx={{ fontSize: 24 }} />
          ) : (
            <FirstPageIcon sx={{ fontSize: 24 }} />
          )}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={isBackDisabled}
          aria-label="previous page"
          size="medium"
          sx={{ p: 1.25 }}
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight sx={{ fontSize: 24 }} />
          ) : (
            <KeyboardArrowLeft sx={{ fontSize: 24 }} />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={isNextDisabled}
          aria-label="next page"
          size="medium"
          sx={{ p: 1.25 }}
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft sx={{ fontSize: 24 }} />
          ) : (
            <KeyboardArrowRight sx={{ fontSize: 24 }} />
          )}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={isNextDisabled}
          aria-label="last page"
          size="medium"
          sx={{ p: 1.25 }}
        >
          {theme.direction === "rtl" ? (
            <FirstPageIcon sx={{ fontSize: 24 }} />
          ) : (
            <LastPageIcon sx={{ fontSize: 24 }} />
          )}
        </IconButton>
      </Box>
    );
  }

  return (
    <div>
      {!proceedRFQ && (
        <div style={{ padding: "15px" }}>
          <div className={classes.spacebetween}>
            <HeaderTitle titleText={"Purchase Requisition"} />

	            {user_access_type === "User" &&
	              !getpurchaserequestdata.some((pr) => Boolean(findCurrentApprover(pr))) && (
	                <Dbutton label={"Raise PR"} onClick={() => handleRaisePR()} />
	              )}
          </div>

          {/* Search and Filter Section */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 3,
              gap: 2,
              flexWrap: "wrap",
            }}
          >
            {/* Search Bar */}
            <Box sx={{ flex: 1, minWidth: "300px" }}>
              <SearchBar
                value={searchTerm}
                onChange={(query) => setSearchTerm(query)}
                onClear={handleClearSearchTerm}
                placeholder="Search Requisition ID, Item Name,..."
                tooltip="Search Requisition ID, Item Name, Item Code, and Raised By"
                clearTooltip="Clear search text"
              />
              
            </Box>

            {/* Status Filter - Available for all users */}
            <Box>
              <FormControl
                size="small"
                sx={{
                  minWidth: 200,
                  fontFamily: "gilroyMedium",
                }}
              >
                <InputLabel
                  sx={{
                    fontSize: "13px",
                    fontFamily: "gilroyMedium",
                  }}
                >
                  Filter by Status
                </InputLabel>

                <Select
                  value={statusFilter}
                  label="Filter by Status"
                  onChange={(e) => setStatusFilter(e.target.value)}
                  sx={{
                    height: 42,
                    fontSize: "13px",
                    borderRadius: "8px",
                    backgroundColor: "#f9fbfd",
                    fontFamily: "gilroyMedium",

                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#d3e0e8",
                    },

                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#1976d2",
                    },

                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#1976d2",
                      borderWidth: "1.5px",
                    },
                  }}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        borderRadius: "8px",
                        mt: 1,
                        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                      },
                    },
                  }}
                >
                  <MenuItem
                    value="all"
                    sx={{ fontSize: "13px", fontFamily: "gilroyMedium" }}
                  >
                    All Status
                  </MenuItem>

                  <MenuItem
                    value="1"
                    sx={{
                      fontSize: "13px",
                      fontFamily: "gilroyMedium",
                      color: "green",
                    }}
                  >
                    Approved
                  </MenuItem>

                  <MenuItem
                    value="2"
                    sx={{
                      fontSize: "13px",
                      fontFamily: "gilroyMedium",
                      color: "#f39c12",
                    }}
                  >
                    Pending
                  </MenuItem>

                  <MenuItem
                    value="3"
                    sx={{
                      fontSize: "13px",
                      fontFamily: "gilroyMedium",
                      color: "red",
                    }}
                  >
                    Rejected
                  </MenuItem>
                </Select>
              </FormControl>
            </Box>

            {/* Clear Filters Button - Shows when search or filter is active */}
            {statusFilter !== "all" && (
              <IconButton
                onClick={handleClearFilters}
                size="small"
                sx={{
                  color: "gray",
                  border: "1px solid #ddd",
                  borderRadius: 1,
                  padding: "8px",
                  "&:hover": {
                    backgroundColor: "#f5f5f5",
                    color: "red",
                  },
                }}
                title="Clear status filter"
              >
                <CancelIcon fontSize="small" />
              </IconButton>
            )}
          </Box>

          <TableContainer
            component={Paper}
            sx={{
              maxHeight: 420,
              borderRadius: 2,
              boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
              overflowX: "auto",
              "&::-webkit-scrollbar": { height: 6 },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#c1c1c1",
                borderRadius: 3,
              },
            }}
          >
            <Table stickyHeader size="small">
              <TableHead>
                <TableRow>
	                  {[
	                    { label: "Requisition ID", key: "pr_code", sortable: false },
	                    { label: "Item Name", key: "item_name", sortable: false },
	                    { label: "Item Code", key: "item_code", sortable: false },
	                    { label: "Quantity", key: "quantity", sortable: false },
	                    { label: "Raised By", key: "buyer_name", sortable: false },
	                    { label: "Created Date", key: "created_on", sortable: true },
	                    { label: "PR Status", key: "pr_status", sortable: false },
	                    { label: "Approval Status", key: "pr_approval_status", sortable: false },
	                    { label: "Action", key: "action", sortable: false },
	                  ].map((col) => (
                    <TableCell
                      key={col.label}
                      sx={{
                        fontWeight: 600,
                        fontSize: "14px",
                        color: "#1a1a1a",
                        textAlign: "left",
                        backgroundColor: "#e8f0f4",
                        borderBottom: "2px solid #d3e0e8",
                        whiteSpace: "nowrap",
                        py: 1,
                        px: 1,
                        fontFamily: "gilroyBold",
                      }}
                    >
                      {col.sortable ? (
                        <TableSortLabel
                          active={prSortConfig?.key === col.key}
                          direction={
                            prSortConfig?.key === col.key
                              ? prSortConfig.direction
                              : "asc"
                          }
                          onClick={() => handlePRSortRequest(col.key)}
                          sx={{
                            "& .MuiTableSortLabel-icon": {
                              color: "#111827 !important",
                            },
                          }}
                        >
                          {col.label}
                        </TableSortLabel>
                      ) : (
                        col.label
                      )}
                    </TableCell>
                  ))}

                  {isApprover && (
                    <TableCell
                      sx={{
                        fontWeight: 600,
                        fontSize: "13px",
                        color: "#1a1a1a",
                        textAlign: "left",
                        backgroundColor: "#e8f0f4",
                        borderBottom: "2px solid #d3e0e8",
                        whiteSpace: "nowrap",
                        py: 1,
                        px: 1,
                      }}
                    >
                      Approve / Reject
                    </TableCell>
                  )}
                </TableRow>
              </TableHead>

              <TableBody>
                {loadingPRs ||
                (offlineLoading && getpurchaserequestdata.length === 0) ? (
                  <TableRow>
                    <TableCell colSpan={9} align="center">
                      <CircularProgress />
                      <Typography
                        variant="body2"
                        sx={{
                          marginTop: 2,
                          fontSize: "14px",
                          color: "#555",
                          fontFamily: "gilroyMedium",
                        }}
                      >
                        Loading Purchase Requisitions...
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : filteredPRs.length === 0 ? (
                  <TableRow>
                    <TableCell
                      colSpan={9}
                      align="center"
                      sx={{ fontFamily: "gilroyMedium", fontSize: "14px" }}
                    >
                      {searchTerm || statusFilter !== "all"
                        ? "No matching PR records found."
                        : "No PR records found."}
                    </TableCell>
                  </TableRow>
                ) : (
	                  paginatedPurchaseRequests.map((pr, index) => {
	                    const currentApprover = findCurrentApprover(pr);
	                    const isApproverForRow = Boolean(currentApprover);
	
	                    return (
                      <TableRow
                        key={index}
                        hover
                        sx={{
                          "&:hover": { backgroundColor: "#f9fbfd" },
                          transition: "0.2s ease",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <TableCell
                          sx={{
                            fontSize: "14px",
                            textAlign: "left",
                            px: 1,
                            fontFamily: "gilroyMedium",
                          }}
                        >
                          {pr.pr_code}
                        </TableCell>
                        <TableCell
                          sx={{
                            fontSize: "14px",
                            textAlign: "left",
                            px: 1,
                            fontFamily: "gilroyMedium",
                          }}
                        >
                          {renderPrMultipleItemsCell(pr, "item_name")}
                        </TableCell>
                        <TableCell
                          sx={{
                            fontSize: "14px",
                            textAlign: "left",
                            px: 1,
                            fontFamily: "gilroyMedium",
                          }}
                        >
                          {renderPrMultipleItemsCell(pr, "item_code")}
                        </TableCell>
                        <TableCell
                          sx={{
                            fontSize: "14px",
                            textAlign: "left",
                            px: 1,
                            fontFamily: "gilroyMedium",
                          }}
                        >
                          {renderPrMultipleItemsCell(pr, "quantity")}
                        </TableCell>
                        <TableCell
                          sx={{
                            fontSize: "14px",
                            textAlign: "left",
                            px: 1,
                            fontFamily: "gilroyMedium",
                          }}
                        >
                          {pr.buyer_name}
                        </TableCell>
                        <TableCell
                          sx={{
                            fontSize: "14px",
                            textAlign: "left",
                            px: 1,
                            fontFamily: "gilroyMedium",
                          }}
                        >
                          {pr.created_on}
                        </TableCell>

                        <TableCell
                          sx={{
                            fontSize: "14px",
                            textAlign: "left",
                            px: 1,
                            fontFamily: "gilroyMedium",
                          }}
                        >
                          {(() => {
                            const prStatus = String(pr.pr_status || "").trim();
                            const normalizedPrStatus =
                              prStatus.toLowerCase();
                            const isInactive =
                              normalizedPrStatus === "closed" ||
                              normalizedPrStatus === "cancelled" ||
                              normalizedPrStatus === "failed";

                            return (
                              <Box
                                component="span"
                                sx={{
                                  color: isInactive ? "#c72b18" : "#2a9a76",
                                  fontSize: "1.2rem",
                                  fontFamily: "gilroySemiBold",
                                  textAlign: "center",
                                  backgroundColor: isInactive
                                    ? "#f9d5d0"
                                    : "#cdffef",
                                  display: "block",
                                  borderRadius: "20px",
                                  padding: "1rem",
                                  height: "30px",
                                  lineHeight: "11px",
                                  textTransform: "capitalize",
                                }}
                              >
                                {prStatus || "Active"}
                              </Box>
                            );
                          })()}
                        </TableCell>

                        <TableCell
                          sx={{
                            fontSize: "12.5px",
                            textAlign: "center",
                            px: 1,
                          }}
                        >
                          <Tooltip
                            title={
                              <Box sx={{ p: 0.5, fontFamily: "gilroyMedium" }}>
                                {pr.approvers && pr.approvers.length > 0 ? (
                                  pr.approvers.map((a, idx) => (
                                    <Typography
                                      key={idx}
                                      variant="body2"
                                      sx={{
                                        fontSize: "13px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                        fontFamily: "gilroyMedium",
                                        color:
                                          a.status === "Approved"
                                            ? "lightgreen"
                                            : a.status === "Cancelled"
                                              ? "red"
                                              : "orange",
                                      }}
                                    >
                                      <strong>{a.name}</strong>: {a.status}
                                    </Typography>
                                  ))
                                ) : (
                                  <Typography
                                    variant="body2"
                                    sx={{ fontSize: "13px" }}
                                  >
                                    No approvers found
                                  </Typography>
                                )}
                              </Box>
                            }
                            placement="top"
                            componentsProps={{
                              tooltip: {
                                sx: {
                                  fontSize: "13px",
                                  backgroundColor: "#333",
                                  color: "#fff",
                                  borderRadius: "6px",
                                  p: "8px 12px",
                                  boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
                                },
                              },
                            }}
                          >
                            <Typography
                              sx={{
                                textAlign: "left",
                                // fontWeight: 600,
                                fontSize: "14px",
                                fontFamily: "gilroyMedium",
                                cursor: "pointer",
                                color:
                                  pr.pr_approval_status === "Approved"
                                    ? "green"
                                    : pr.pr_approval_status === "Cancelled" ||
                                        pr.pr_approval_status === "Rejected"
                                      ? "red"
                                      : "#f39c12",
                                "&:hover": { textDecoration: "underline" },
                              }}
                            >
                              {pr.pr_approval_status}
                            </Typography>
                          </Tooltip>
                        </TableCell>

                        <TableCell
                          sx={{
                            whiteSpace: "nowrap",
                            px: 1,
                            py: 0.3,
                            textAlign: "left",
                          }}
                        >
                          <Tooltip
                            title="View"
                            placement="top"
                            slotProps={{
                              tooltip: {
                                sx: {
                                  fontSize: "12px",
                                },
                              },
                            }}
                          >
                            <IconButton
                              onClick={() => handleViewPR(pr)}
                              size="small"
                              sx={{
                                color: "#1976d2",
                                "&:hover": {
                                  backgroundColor: "rgba(25,118,210,0.1)",
                                },
                              }}
                            >
                              <VisibilityIcon fontSize="large" />
                            </IconButton>
                          </Tooltip>
                          {user_access_type !== "Buyer" &&
                            !isApprover &&
                            (() => {
                              const status = String(pr?.pr_approval_status || "")
                                .trim()
                                .toLowerCase();
                              if (status === "approved") return false;

                              const approvers = Array.isArray(pr?.approvers)
                                ? pr.approvers
                                : [];
                              const allApproversApproved =
                                approvers.length > 0 &&
                                approvers.every(
                                  (a) =>
                                    String(a?.status || "").trim().toLowerCase() ===
                                    "approved",
                                );

                              return !allApproversApproved;
                            })() && (
                            <Tooltip
                              title="Edit"
                              placement="top"
                              slotProps={{
                                tooltip: {
                                  sx: {
                                    fontSize: "12px",
                                  },
                                },
                              }}
                            >
                              <IconButton
                                onClick={() => handleEditPR(pr, true)}
                                size="small"
                                sx={{
                                  color: "#1976d2",
                                  "&:hover": {
                                    backgroundColor: "rgba(25,118,210,0.1)",
                                  },
                                }}
                              >
                                <EditNote fontSize="large" />
                              </IconButton>
                            </Tooltip>
                          )}
                        </TableCell>
	
	                        {isApprover && (
	                          <TableCell
	                            align="left"
	                            sx={{
	                              whiteSpace: "nowrap",
	                              px: 1,
	                              py: 0.3,
	                              textAlign: "center",
	                            }}
	                          >
	                            {!isApproverForRow ? (
	                              <Typography
	                                sx={{
	                                  color: "text.secondary",
	                                  fontSize: "12px",
	                                }}
	                              >
	                                -
	                              </Typography>
	                            ) : pr.pr_approval_status === "Pending" ? (
	                              currentApprover?.status === "Approved" ? (
	                                <Chip
	                                  label="Approved"
	                                  color="success"
	                                  size="small"
	                                  sx={{
                                    fontWeight: 600,
                                    fontSize: "11px",
                                    borderRadius: "5px",
                                    height: 22,
                                  }}
                                />
                              ) : currentApprover?.status === "Cancelled" ? (
                                <Chip
                                  label="Rejected"
                                  color="error"
                                  size="small"
                                  sx={{
                                    fontWeight: 600,
                                    fontSize: "11px",
                                    borderRadius: "5px",
                                    height: 22,
                                  }}
                                />
                              ) : (
                                <Stack
                                  direction="row"
                                  spacing={0.5}
                                  justifyContent="center"
                                  alignItems="center"
                                >
                                  <Chip
                                    label="Approve Request"
                                    color="primary"
                                    variant="outlined"
                                    size="small"
                                    clickable
                                    onClick={() =>
                                      handleApprovePR(pr.pr_token, 1)
                                    }
                                    sx={{
                                      fontWeight: 600,
                                      fontSize: "11px",
                                      borderRadius: "5px",
                                      height: 22,
                                      px: 1,
                                    }}
                                  />
                                  <Chip
                                    label="Reject Request"
                                    variant="outlined"
                                    size="small"
                                    color="error"
                                    clickable
                                    onClick={() =>
                                      handleApprovePR(pr.pr_token, 3)
                                    }
                                    sx={{
                                      fontWeight: 600,
                                      fontSize: "11px",
                                      borderRadius: "5px",
                                      height: 22,
                                      px: 1,
                                    }}
                                  />
                                </Stack>
                              )
                            ) : (
                              <Typography
                                sx={{
                                  color: "text.secondary",
                                  fontSize: "12px",
                                }}
                              >
                                —
	                              </Typography>
	                            )}
	                          </TableCell>
	                        )}
                      </TableRow>
                    );
                  })
                )}
              </TableBody>
            </Table>
          </TableContainer>

          {!loadingPRs && (
              <PaginantionComponent
                pageNumber={page + 1}
                setPageNumber={(value) => {
                  if (value === "") return;
                  const parsed = parseInt(value, 10);
                  if (!Number.isNaN(parsed)) {
                    setPage(parsed - 1);
                  }
                }}
                currentPage={page + 1}
                itemsPerPage={
                  shouldUseServerPagination
                    ? purchaseRequestTotalCount
                    : filteredPRs.length
                }
                totalItems={
                  shouldUseServerPagination
                    ? Math.max(0, purchaseRequestPageCount || 0)
                    : filteredPRs.length > 0
                      ? Math.ceil(filteredPRs.length / Math.max(rowsPerPage, 1))
                      : 0
                }
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={
                  shouldUseServerPagination ? [10] : [5, 10, 25, 50]
                }
                onRowsPerPageChange={handleChangeRowsPerPage}
                previouPageClick={() => {
                  if (page > 0) {
                    setPage((prev) => Math.max(0, prev - 1));
                  }
                }}
                nextPageClick={() => {
                  const maxPage = Math.max(
                    0,
                    shouldUseServerPagination
                      ? purchaseRequestPageCount - 1
                      : Math.ceil(filteredPRs.length / Math.max(rowsPerPage, 1)) - 1,
                  );
                  if (page < maxPage) {
                    setPage((prev) => Math.min(maxPage, prev + 1));
                  }
                }}
                disablePrevious={page <= 0}
                disableNext={
                  page >=
                  Math.max(
                    0,
                    shouldUseServerPagination
                      ? purchaseRequestPageCount - 1
                      : Math.ceil(filteredPRs.length / Math.max(rowsPerPage, 1)) - 1,
                  )
                }
              />
            )}
        </div>
      )}

      {proceedRFQ && (
        <div className={classes.raisePrPage}>
          <div className={`${classes.spacebetween} ${classes.raisePrHeader}`}>
            <HeaderTitle titleText={"Requested Details"} />
            <Dbutton label={"Back"} onClick={() => handleBack()} />
          </div>

          <div
            className={`${classes.infoLabelRow} ${classes.requestDetailsCard}`}
            style={{
              paddingLeft: "2rem",
              paddingRight: "2rem",
              boxSizing: "border-box",
              width: "100%",
            }}
          >
            {infoLabelDetails.map((items, index) => {
              return (
                <Tooltip
                  key={index}
                  title={items.value || "-"}
                  arrow
                  placement="top"
                  slotProps={{
                    tooltip: {
                      sx: { fontSize: "13px", fontFamily: "gilroyMedium" },
                    },
                  }}
                >
                  <div>
                    <InfoLabel
                      label={items.label}
                      value={items.value}
                      size={items.size}
                      customClass={`${classes.prInfoLabel} ${items.className || ""}`}
                    />
                  </div>
                </Tooltip>
              );
            })}
          </div>

          <div className={`${classes.raisePrSection} ${classes.budgetSummarySection}`}>
            <HeaderTitle titleText="Budget Overview" />
            <div className={classes.budgetSummaryGrid}>
              {budgetSummaryDetails.map((item, index) => (
                <InfoLabel
                  key={index}
                  label={item.label}
                  value={item.value}
                  size={item.size}
                  customClass={`${classes.prInfoLabel} ${item.className || ""}`}
                />
              ))}
            </div>
            {budgetConfig && (
              <div className={classes.stageAvailabilityGrid}>
                {[
                  ["PR Balance", "pr_available"],
                  ["PO Balance", "po_available"],
                  ["GRN Balance", "grn_available"],
                ].map(([label, field]) => (
                  <div key={field} className={classes.stageAvailabilityCard}>
                    <span>{label}</span>
                    <strong>{formatBudgetAmount(budgetConfig?.[field])}</strong>
                  </div>
                ))}
              </div>
            )}
            {liveBudgetLimitError && (
              <Typography className={classes.budgetLimitError}>
                {liveBudgetLimitError}
              </Typography>
            )}
          </div>

          <div
            style={{ flex: "1", display: "flex", flexDirection: "column" }}
            className={`${classes.margincls} ${classes.raisePrSection} ${classes.reasonCard}`}
          >
            <label
              style={{
                fontSize: "17px",
                fontWeight: "600",
                fontFamily: "gilroyBold",
              }}
            >
              Purchase Justification
            </label>
            <textarea
              rows={5}
              style={{
                padding: "10px",
                borderRadius: "5px",
                fontFamily: "gilroyMedium",
                fontSize: "14px",
              }}
              value={reasontext}
              onChange={(e) => setReasonText(e.target.value)}
              disabled={viewpr && !editpr}
            />
          </div>

          <div className={classes.raisePrSection}>
            <HeaderTitle titleText={"Item Details"} />
            {showItemSection && (
              <>
                <div className={`${classes.margincls} ${classes.prRfqModeSelector}`}>
                  <RadioGroup
                    row
                    value={inputMethod}
                    onChange={(e) => setInputMethod(e.target.value)}
                  >
                    <FormControlLabel
                      value="xls"
                      control={<Radio />}
                      label="Attach RFQ document"
                      sx={{
                        "& .MuiTypography-root": {
                          fontSize: "14px",
                          fontFamily: "gilroyMedium",
                        },
                      }}
                    />
                    <FormControlLabel
                      value="manual"
                      control={<Radio />}
                      label="Type details of RFQ"
                      sx={{
                        "& .MuiTypography-root": {
                          fontSize: "14px",
                          fontFamily: "gilroyMedium",
                        },
                      }}
                    />
                  </RadioGroup>
                </div>

                {inputMethod === "xls" ? (
                  <div className={classes.itemform} style={{ margin: "10px" }}>
                    <div
                      className={`${classes.fileUploadWrapper} ${
                        dragging ? classes.drag_over : ""
                      }`}
                      onDragOver={handleDragOver}
                      onDragLeave={handleDragLeave}
                      onDrop={handleDrop}
                    >
                      <div className={classes.file_upload}>
                        <label className={classes.DocText}>
                          <span>
                            {fileUpload
                              ? fileUpload.name
                              : "Drag and drop file here"}
                          </span>
                          <input
                            ref={itemFileInputRef}
                            type="file"
                            accept=".csv,.xlsx,.xls"
                            style={{ display: "none" }}
                            onChange={handleFileChange}
                          />
                          <p>(Supported format CSV/Excel)</p>
                        </label>
                        {!fileUpload ? (
                          <button
                            onClick={() =>
                              itemFileInputRef.current?.click()
                            }
                            style={{
                              backgroundColor: "#1976d2",
                              color: "#fff",
                              border: "none",
                              padding: "8px 16px",
                              cursor: "pointer",
                              borderRadius: "4px",
                              fontFamily: "gilroyMedium",
                            }}
                            onMouseOver={(e) =>
                              (e.target.style.backgroundColor = "#1565c0")
                            }
                            onMouseOut={(e) =>
                              (e.target.style.backgroundColor = "#1976d2")
                            }
                          >
                            Browse
                          </button>
                        ) : (
                          <button
                            onClick={clearItemUploadFile}
                            style={{
                              backgroundColor: "#d32f2f",
                              color: "#fff",
                              border: "none",
                              padding: "8px 16px",
                              cursor: "pointer",
                              borderRadius: "4px",
                              fontFamily: "gilroyMedium",
                            }}
                            onMouseOver={(e) =>
                              (e.target.style.backgroundColor = "#b71c1c")
                            }
                            onMouseOut={(e) =>
                              (e.target.style.backgroundColor = "#f53c3c")
                            }
                          >
                            Clear
                          </button>
                        )}
                      </div>
                      {fileuploadError && (
                        <div
                          style={{
                            color: "red",
                            fontSize: "14px",
                            marginTop: "8px",
                            padding: "8px",
                          }}
                        >
                          {fileuploadError}
                        </div>
                      )}
                    </div>
                    <span className={classes.sampleLinkWrap}>
                      <p
                        className={classes.linkBtn}
                        onClick={() => {
                          saveAs(PRSampleItemsList, "Sample Excel.xlsx");
                        }}
                      >
                        Sample Excel
                      </p>
                    </span>
                  </div>
                ) : (
                  <div className={classes.prManualItems}>
                    {fileuploadError && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "14px",
                          marginBottom: "12px",
                          padding: "8px",
                        }}
                      >
                        {fileuploadError}
                      </div>
                    )}
                    {items.map((item, index) => (
                      <Paper
                        key={index}
                        elevation={2}
                        className={`${classes.prItemCard} ${classes.rfqStyleItemCard}`}
                        sx={{
                          p: 3,
                          mb: 3,
                        }}
                      >
                        <Typography className={classes.rfqItemBadge}>
                          Item #{index + 1}
                        </Typography>
                        <Box className={classes.prItemGrid}>
                          <Box className={classes.prItemFieldFull} sx={{ order: 0 }}>
                            <Typography className={classes.prItemSectionHeader}>
                              Enter requisition details - fields marked * are required
                            </Typography>
                          </Box>
                          <Box className={classes.prItemFieldPart} sx={{ order: 12 }}>
                            <Typography
                              fontWeight={600}
                              fontSize="14px"
                              mb={0.5}
                              fontFamily="gilroyBold"
                            >
                              Manufacturer Part Number
                            </Typography>
	                            <Tooltip
                              title={item.partnumber || item.partNumber || "-"}
	                              arrow
	                              placement="top"
	                              slotProps={{ tooltip: { sx: { fontSize: "13px", fontFamily: "gilroyMedium" } } }}
	                            >
	                              <TextField
	                              fullWidth
	                              size="small"
                              value={item.partnumber || item.partNumber || "-"}
	                              InputProps={{ readOnly: true }}
	                              sx={{
	                                "& .MuiInputBase-input": {
	                                  fontSize: "16px",
	                                  fontFamily: "gilroyMedium",
	                                },
                                "& .MuiInputBase-input::placeholder": {
                                  fontSize: "14px",
                                  color: "#999",
                                  fontFamily: "gilroyMedium",
                                },
                              }}
	                              />
	                            </Tooltip>
                          </Box>

                          <Box className={classes.prItemFieldMedium} sx={{ order: 1 }}>
                            <Typography
                              fontWeight={600}
                              fontSize="14px"
                              mb={0.5}
                              fontFamily="gilroyBold"
                            >
                              Item Code
                            </Typography>
                            {
                              (() => {
                                const itemCodeOptions = getFilteredItemOptions(
                                  "item_code",
                                  item.itemCodeInput ?? item.itemCode ?? "",
                                  getItemMaster,
                                );

                                return (
                            <Autocomplete
                              openOnFocus
                              autoHighlight
                                  options={itemCodeOptions}
                              filterOptions={(x) => x}
                              getOptionLabel={(option) =>
                                option.item_code || ""
                              }
                              inputValue={item.itemCodeInput ?? item.itemCode ?? ""}
                              onInputChange={(_e, newInputValue, reason) => {
                                if (reason !== "input" && reason !== "clear") {
                                  return;
                                }
                                const nextItems = [...items];
                                const current = nextItems[index] || {};
                                nextItems[index] = {
                                  ...current,
                                  itemCodeInput: newInputValue,
                                  itemToken: "",
                                  itemCode: "",
                                  itemName: "",
                                  itemNameInput: "",
                                  category: "",
                                  expenseType: "",
                                  subCategory: "",
                                  itemType: "",
                                  unit: "",
                                  hsnCode: "",
                                  unspscCode: "",
                                  brand: "",
                                  manufacturerPartNo: "",
                                  specifications: "",
                                  aliases: "",
                                  gstList: [],
                                  description: "",
                                };
                                setItems(nextItems);
                                setManualItemErrors((prev) =>
                                  applyDuplicateErrorsForIndexOnly(nextItems, prev, index),
                                );
                                scheduleItemSearch(newInputValue);
                              }}
                              value={
                                getItemMaster.find(
                                  (i) =>
                                    (i?.token || i?.item_token) === item.itemToken,
                                ) ||
                                getItemMaster.find(
                                  (i) => i.item_code === item.itemCode,
                                ) ||
                                null
                              }
                              onChange={(e, newValue) =>
                                handleItemSelection(index, newValue)
                              }
                              isOptionEqualToValue={(option, value) => {
                                const optionToken = option?.token || option?.item_token;
                                const valueToken = value?.token || value?.item_token;
                                if (optionToken && valueToken) {
                                  return optionToken === valueToken;
                                }
                                return option?.item_code === value?.item_code;
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  placeholder="Select item code"
                                  error={Boolean(
                                    manualItemErrors?.[index]?.itemCode,
                                  )}
                                  helperText={
                                    manualItemErrors?.[index]?.itemCode || ""
                                  }
                                  sx={{
                                    "& .MuiInputBase-input": {
                                      fontSize: "16px",
                                      fontFamily: "gilroyMedium",
                                    },

                                    "& .MuiInputBase-input::placeholder": {
                                      fontSize: "14px",
                                      color: "#999",
                                      fontFamily: "gilroyMedium",
                                    },
                                    "& .MuiFormHelperText-root": {
                                      fontSize: "14px",
                                      fontFamily: "gilroyMedium",
                                      marginLeft: 0,
                                    },
                                  }}
                                  />
                                )}
                              />
                                );
                              })()
                            }
                          </Box>
                           <Box className={classes.prItemFieldLarge} sx={{ order: 2 }}>
                            <Typography
                              fontWeight={500}
                              fontSize="14px"
                              mb={0.5}
                              fontFamily="gilroyBold"
                            >
                              {renderRequiredLabel("Item Name")}
                            </Typography>
                            {
                              (() => {
                                const itemNameOptions = getFilteredItemOptions(
                                  "item_name",
                                  item.itemNameInput ?? item.itemName ?? "",
                                  getItemMaster,
                                );

                                return (
                            <Autocomplete
                              openOnFocus
                              autoHighlight
                                  options={itemNameOptions}
                              filterOptions={(x) => x}
                              getOptionLabel={(option) => option?.item_name || ""}
                              inputValue={item.itemNameInput ?? item.itemName ?? ""}
                              onInputChange={(_e, newInputValue, reason) => {
                                if (reason !== "input" && reason !== "clear") {
                                  return;
                                }
                                const nextItems = [...items];
                                const current = nextItems[index] || {};
                                nextItems[index] = {
                                  ...current,
                                  itemNameInput: newInputValue,
                                  itemToken: "",
                                  itemCode: "",
                                  itemCodeInput: "",
                                  itemName: "",
                                  category: "",
                                  expenseType: "",
                                  subCategory: "",
                                  itemType: "",
                                  unit: "",
                                  hsnCode: "",
                                  unspscCode: "",
                                  brand: "",
                                  manufacturerPartNo: "",
                                  specifications: "",
                                  aliases: "",
                                  gstList: [],
                                  description: "",
                                };
                                setItems(nextItems);
                                setManualItemErrors((prev) =>
                                  applyDuplicateErrorsForIndexOnly(nextItems, prev, index),
                                );
                                scheduleItemSearch(newInputValue);
                              }}
                              value={
                                getItemMaster.find(
                                  (i) =>
                                    (i?.token || i?.item_token) === item.itemToken,
                                ) ||
                                getItemMaster.find(
                                  (i) => i.item_name === item.itemName,
                                ) ||
                                null
                              }
                              onChange={(e, newValue) =>
                                handleItemSelection(index, newValue)
                              }
                              isOptionEqualToValue={(option, value) => {
                                const optionToken = option?.token || option?.item_token;
                                const valueToken = value?.token || value?.item_token;
                                if (optionToken && valueToken) {
                                  return optionToken === valueToken;
                                }
                                return option?.item_name === value?.item_name;
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  required
                                  size="small"
                                  placeholder="Select item name"
                                  error={Boolean(
                                    manualItemErrors?.[index]?.itemName,
                                  )}
                                  helperText={
                                    manualItemErrors?.[index]?.itemName || ""
                                  }
                                  sx={{
                                    "& .MuiInputBase-input": {
                                      fontSize: "16px",
                                      fontFamily: "gilroyMedium",
                                    },
                                    "& .MuiInputBase-input::placeholder": {
                                      fontSize: "14px",
                                      color: "#999",
                                      fontFamily: "gilroyMedium",
                                    },
                                    "& .MuiFormHelperText-root": {
                                      fontSize: "14px",
                                      fontFamily: "gilroyMedium",
                                      marginLeft: 0,
                                    },
                                  }}
                                  />
                                )}
                              />
                                );
                              })()
                            }
                          </Box>


                          <Box className={classes.prItemFieldCompact} sx={{ order: 7 }}>
                            <Typography
                              fontWeight={600}
                              fontSize="14px"
                              mb={0.5}
                              fontFamily="gilroyBold"
                            >
                              Category
                            </Typography>
                            <TextField
                              fullWidth
                              size="small"
                              placeholder="Category"
                              value={item.category || ""}
                              InputProps={{ readOnly: true }}
                              sx={{
                                "& .MuiInputBase-input": {
                                  fontSize: "16px",
                                  fontFamily: "gilroyMedium",
                                },
                                "& .MuiInputBase-input::placeholder": {
                                  fontSize: "14px",
                                  color: "#999",
                                  fontFamily: "gilroyMedium",
                                },
                              }}
                            />
                          </Box>
                         

                          <Box className={classes.prItemFieldMedium} sx={{ order: 3 }}>
                            <Typography
                              fontWeight={600}
                              fontSize="14px"
                              mb={0.5}
                              fontFamily="gilroyBold"
                            >
                              Expense Type
                            </Typography>
                            <TextField
                              fullWidth
                              size="small"
                              placeholder="Expense type"
                              value={item.expenseType || ""}
                              InputProps={{ readOnly: true }}
                              sx={{
                                "& .MuiInputBase-input": {
                                  fontSize: "16px",
                                  fontFamily: "gilroyMedium",
                                },
                                "& .MuiInputBase-input::placeholder": {
                                  fontSize: "14px",
                                  color: "#999",
                                  fontFamily: "gilroyMedium",
                                },
                              }}
                            />
                          </Box>
                          <Box className={classes.prItemFieldFull} sx={{ order: 10 }}>
                            <Typography className={classes.prItemSectionHeader}>
                              Item master details
                            </Typography>
                          </Box>
                          {[
                            ["HSN Code", item.hsnCode],
                            ["UNSPSC Code", item.unspscCode],
                            ["Sub-Category", item.subCategory],
                            ["Item Type", item.itemType],
                            ["Brand", item.brand],
                            [
                              "Tax",
                              (item.gstList || [])
                                .map((tax) =>
                                  tax?.country && tax?.gst
                                    ? `${tax.country} - ${tax.gst}%`
                                    : "",
                                )
                                .filter(Boolean)
                                .join(", "),
                            ],
                            ["Specifications", item.specifications],
                            ["Aliases / Keywords", item.aliases],
                          ].map(([label, value], detailIndex) => (
                            <Box
                              key={label}
                              className={classes.prItemFieldCompact}
                              sx={{ order: 11 + detailIndex }}
                            >
                              <Typography
                                fontWeight={600}
                                fontSize="14px"
                                mb={0.5}
                                fontFamily="gilroyBold"
                              >
                                {label}
                              </Typography>
                              <Tooltip
                                title={value || "-"}
                                arrow
                                placement="top"
                                slotProps={{
                                  tooltip: {
                                    sx: {
                                      fontSize: "13px",
                                      fontFamily: "gilroyMedium",
                                    },
                                  },
                                }}
                              >
                                <TextField
                                  fullWidth
                                  size="small"
                                  value={value || "-"}
                                  InputProps={{ readOnly: true }}
                                  sx={{
                                    backgroundColor: "#f4f8ff",
                                    borderRadius: 1,
                                    "& .MuiInputBase-input": {
                                      fontSize: "16px",
                                      fontFamily: "gilroyMedium",
                                    },
                                  }}
                                />
                              </Tooltip>
                            </Box>
                          ))}
                          <Box className={classes.prItemFieldCompact} sx={{ order: 4 }}>
                            <Typography
                              fontWeight={600}
                              fontSize="14px"
                              mb={0.5}
                              fontFamily="gilroyBold"
                            >
                              {renderRequiredLabel("Quantity")}
                            </Typography>
                              <TextField
                              fullWidth
                              required
                              size="small"
                              type="number"
                              placeholder="Quantity"
                              value={item.quantity}
                              error={Boolean(
                                manualItemErrors?.[index]?.quantity,
                              )}
                              helperText={
                                manualItemErrors?.[index]?.quantity || ""
                              }
                              onChange={(e) =>
                                updateTotalPrice(
                                  index,
                                  "quantity",
                                  e.target.value.slice(0, 10),
                                )
                              }
                              onWheel={preventNumberWheel}
                              inputProps={{
                                min: 0,
                                step: 1,
                                maxLength: 10,
                                inputMode: "numeric",
                                pattern: "[0-9]*",
                              }}
                              sx={{
                                "& .MuiInputBase-input": {
                                  fontSize: "16px",
                                  fontFamily: "gilroyMedium",
                                },
                                "& .MuiInputBase-input::placeholder": {
                                  fontSize: "14px",
                                  color: "#999",
                                  fontFamily: "gilroyMedium",
                                },
                                "& .MuiFormHelperText-root": {
                                  fontSize: "14px",
                                  fontFamily: "gilroyMedium",
                                  marginLeft: 0,
                                },
                              }}
                              onKeyDown={(e) => {
                                if (["-", "+", ".", "e", "E"].includes(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                            />
                          </Box>

                          <Box className={classes.prItemFieldCompact} sx={{ order: 5 }}>
                            <Typography
                              fontWeight={600}
                              fontSize="14px"
                              mb={0.5}
                              fontFamily="gilroyBold"
                            >
                              {renderRequiredLabel("Unit Measure")}
                            </Typography>
                            <Autocomplete
                              disablePortal
                              options={unitsOptions}
                              value={item.unit || ""}
                              disabled={Boolean(item.itemToken && item.unit)}
                              onChange={(e, newValue) => {
                                const updated = [...items];
                                updated[index].unit = newValue;
                                setItems(updated);

                                if (fileuploadError === MANUAL_REQUIRED_ERROR_MSG) {
                                  setFileuploadError("");
                                }

                                if (manualItemErrors?.[index]?.unit) {
                                  setManualItemErrors((prev) => {
                                    const next = { ...(prev || {}) };
                                    if (!next[index]) return prev;
                                    next[index] = { ...next[index], unit: "" };
                                    if (
                                      !next[index].itemName &&
                                      !next[index].quantity &&
                                      !next[index].unit &&
                                      !next[index].description &&
                                      !next[index].unitPrice
                                    ) {
                                      delete next[index];
                                    }
                                    return next;
                                  });
                                }
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  required
                                  size="small"
                                  placeholder="Select unit"
                                  error={Boolean(
                                    manualItemErrors?.[index]?.unit,
                                  )}
                                  helperText={
                                    manualItemErrors?.[index]?.unit || ""
                                  }
                                  sx={{
                                    "& .MuiInputBase-input": {
                                      fontSize: "16px",
                                      fontFamily: "gilroyMedium",
                                    },
                                    "& .MuiInputBase-input::placeholder": {
                                      fontSize: "14px",
                                      color: "#999",
                                      fontFamily: "gilroyMedium",
                                    },
                                    "& .MuiFormHelperText-root": {
                                      fontSize: "14px",
                                      fontFamily: "gilroyMedium",
                                      marginLeft: 0,
                                    },
                                  }}
                                />
                              )}
                            />
                          </Box>
                          <Box className={classes.prItemFieldCompact} sx={{ order: 8 }}>
                            <Typography
                              fontWeight={600}
                              fontSize="14px"
                              mb={0.5}
                              fontFamily="gilroyBold"
                            >
                              {renderRequiredLabel("Unit Price")}
                            </Typography>
                            <TextField
                              fullWidth
                              required
                              size="small"
                              type="text"
                              inputMode="decimal"
                              placeholder="Unit price"
                              value={
                                editingUnitPrice[index]
                                  ? item.unitPrice
                                  : item.unitPrice === ""
                                  ? ""
                                  : Number(item.unitPrice).toLocaleString("en-IN", {
                                      maximumFractionDigits: 2,
                                    })
                              }
                              error={Boolean(
                                manualItemErrors?.[index]?.unitPrice || isOverBudget,
                              )}
                              helperText={
                                manualItemErrors?.[index]?.unitPrice ||
                                (isOverBudget
                                  ? "Total exceeds the available budget balance"
                                  : "")
                              }
                              onFocus={() =>
                                setEditingUnitPrice((prev) => ({ ...prev, [index]: true }))
                              }
                              onBlur={() =>
                                setEditingUnitPrice((prev) => ({ ...prev, [index]: false }))
                              }
                              onChange={(e) => {
                                const value = e.target.value.replace(/,/g, "");
                                if (/^\d*\.?\d*$/.test(value)) {
                                  updateTotalPrice(index, "unitPrice", value);
                                }
                              }}
                              onWheel={preventNumberWheel}
                              inputProps={{ inputMode: "decimal" }}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">₹</InputAdornment>
                                ),
                              }}
                              sx={{
                                "& .MuiInputBase-input": {
                                  fontSize: "16px",
                                  fontFamily: "gilroyMedium",
                                },
                                "& .MuiInputBase-input::placeholder": {
                                  fontSize: "14px",
                                  color: "#999",
                                  fontFamily: "gilroyMedium",
                                },
                                "& .MuiFormHelperText-root": {
                                  fontSize: "14px",
                                  fontFamily: "gilroyMedium",
                                  marginLeft: 0,
                                },
                              }}
                            />
                          </Box>

                          <Box className={classes.prItemFieldMedium} sx={{ order: 9 }}>
                            <Typography
                              fontWeight={600}
                              fontSize="14px"
                              mb={0.5}
                              fontFamily="gilroyBold"
                            >
                              Total Price
                            </Typography>
                            <TextField
                              fullWidth
                              size="small"
                              value={
                                item.totalPrice === ""
                                  ? ""
                                  : Number(item.totalPrice || 0).toLocaleString("en-IN", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })
                              }
                              InputProps={{
                                readOnly: true,
                                startAdornment: (
                                  <InputAdornment position="start">₹</InputAdornment>
                                ),
                              }}
                              sx={{
                                backgroundColor: "#f4f8ff",
                                borderRadius: 1,
                                "& .MuiInputBase-input": {
                                  fontSize: "16px",
                                  fontFamily: "gilroyMedium",
                                },
                                "& .MuiInputBase-input::placeholder": {
                                  fontSize: "14px",
                                  color: "#999",
                                  fontFamily: "gilroyMedium",
                                },
                              }}
                            />
                          </Box>

                          <Box className={classes.prItemFieldFull} sx={{ order: 8, mb: 2 }}>
                            <Typography
                              fontWeight={600}
                              fontSize="14px"
                              mb={0.5}
                              fontFamily="gilroyBold"
                            >
                              {renderRequiredLabel("Item Description")}
                            </Typography>
                            <TextField
                              fullWidth
                              required
                              multiline
                              rows={3}
                              placeholder="Item description"
                              value={item.description}
                              error={Boolean(
                                manualItemErrors?.[index]?.description,
                              )}
                              helperText={
                                manualItemErrors?.[index]?.description || ""
                              }
                              onChange={(e) =>
                                updateTotalPrice(
                                  index,
                                  "description",
                                  e.target.value,
                                )
                              }
                              sx={{
                                "& .MuiInputBase-input": {
                                  fontSize: "16px",
                                  fontFamily: "gilroyMedium",
                                },
                                "& .MuiInputBase-input::placeholder": {
                                  fontSize: "14px",
                                  color: "#999",
                                  fontFamily: "gilroyMedium",
                                },
                                "& .MuiFormHelperText-root": {
                                  fontSize: "14px",
                                  fontFamily: "gilroyMedium",
                                  marginLeft: 0,
                                },
                              }}
                            />
                          </Box>
                        </Box>

                        {index > 0 && (
                          <Box sx={{ textAlign: "right", mt: 2 }}>
                            <Button
                
                              onClick={() => handleRemoveItem(index)}
                              style={{
                                backgroundColor: "#d32f2f",
                                color: "#fff",
                                fontFamily:"gilroyMedium",
                                fontSize:"13px"
                              }}
                            > Remove 

                            </Button>
                          </Box>
                        )}
                      </Paper>
                    ))}

                    {!viewpr && (
                      <div
                        style={{}}
                        className={`${classes.spacebetween} ${classes.stickyFooter}`}
                      >
                        <InfoLabel
                          label={"Total Price"}
                          value={`₹ ${grandTotal.toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}`}
                        />
                        <Dbutton label={"Add Items"} onClick={handleAddItem} />
                      </div>
                    )}
                  </div>
                )}
              </>
            )}

            {viewraisedpr && (
              <div className={classes.margincls}>
                <Box className={classes.prViewItems}>
                  {items.map((item, index) => {
                    const taxValue = (item.gstList || [])
                      .map((tax) =>
                        tax?.country && tax?.gst
                          ? `${tax.country} - ${tax.gst}%`
                          : "",
                      )
                      .filter(Boolean)
                      .join(", ");

                    return (
                      <Paper key={index} className={classes.prViewItemCard}>
                        <Box className={classes.prViewItemHeader}>
                          <Typography className={classes.rfqItemBadge}>
                            Item #{index + 1}
                          </Typography>
                          <Box>
                            <Typography className={classes.prViewItemName}>
                              {item.itemName || "-"}
                            </Typography>
                            <Typography className={classes.prViewItemCode}>
                              {item.itemCode || "-"}
                            </Typography>
                          </Box>
                        </Box>

                        <Typography className={classes.prViewSectionTitle}>
                          Requisition details
                        </Typography>
                        <Box className={classes.prViewDetailGrid}>
                          {[
                            ["Category", item.category],
                            ["Expense Type", item.expenseType],
                            ["Quantity", item.quantity],
                            ["Unit", item.unit],
                            ["Unit Price", `₹ ${Number(item.unitPrice || 0).toLocaleString("en-IN")}`],
                            ["Total Price", `₹ ${Number(item.totalPrice || 0).toLocaleString("en-IN")}`],
                          ].map(([label, value]) => (
                            <Box key={label} className={classes.prViewDetail}>
                              <span>{label}</span>
                              <strong>{value || "-"}</strong>
                            </Box>
                          ))}
                        </Box>

                        <Typography className={classes.prViewSectionTitle}>
                          Item master details
                        </Typography>
                        <Box className={classes.prViewDetailGrid}>
                          {[
                            ["HSN Code", item.hsnCode],
                            ["UNSPSC Code", item.unspscCode],
                            ["Sub-Category", item.subCategory],
                            ["Item Type", item.itemType],
                            ["Manufacturer Part Number", item.partnumber],
                            ["Brand", item.brand],
                            ["Tax", taxValue],
                            ["Specifications", item.specifications],
                            ["Aliases", item.aliases],
                          ].map(([label, value]) => (
                            <Tooltip
                              key={label}
                              title={value || "-"}
                              arrow
                              placement="top"
                              slotProps={{ tooltip: { sx: { fontSize: "13px", fontFamily: "gilroyMedium" } } }}
                            >
                              <Box className={classes.prViewDetail}>
                                <span>{label}</span>
                                <strong>{value || "-"}</strong>
                              </Box>
                            </Tooltip>
                          ))}
                        </Box>

                        <Box className={classes.prViewDescription}>
                          <span>Description</span>
                          {editpr ? (
                            <TextField
                              fullWidth
                              multiline
                              minRows={3}
                              value={item.description || ""}
                              placeholder="Item description"
                              onChange={(e) =>
                                updateTotalPrice(
                                  index,
                                  "description",
                                  e.target.value,
                                )
                              }
                              inputProps={{
                                "aria-label": `Item ${index + 1} description`,
                              }}
                              sx={{
                                mt: 0.5,
                                "& .MuiInputBase-input": {
                                  fontSize: "14px",
                                  fontFamily: "gilroyMedium",
                                },
                              }}
                            />
                          ) : (
                            <p>{item.description || "-"}</p>
                          )}
                        </Box>
                      </Paper>
                    );
                  })}
                </Box>

                <TableContainer component={Paper} sx={{ display: "none" }}>
                  <Table stickyHeader size="small">
                    <TableHead>
                      <TableRow>
                        {[
                          "Item Code",
                          "Item Name",
                          "Category",
                          "Expense Type",
                          "Item Master Details",
                          "Quantity",
                          "Unit",
                          "Description",
                          "Unit Price",
                          "Total Price",
                        ].map((header) => (
                          <TableCell
                            key={header}
                            sx={{
                              fontWeight: 600,
                              fontSize: "14px",
                              color: "#1a1a1a",
                              textAlign: "left",
                              backgroundColor: "#e8f0f4",
                              borderBottom: "2px solid #d3e0e8",
                              whiteSpace: "nowrap",
                              py: 1,
                              px: 1,
                              fontFamily: "gilroyBold",
                              spacebetween: 3,
                            }}
                          >
                            {header}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {items.map((item, index) => (
                        <TableRow
                          key={index}
                          hover
                          sx={{
                            "&:hover": { backgroundColor: "#f9fbfd" },
                            transition: "0.2s ease",
                          }}
                        >
                          <TableCell
                            sx={{
                              fontSize: "14px",
                              px: 1,
                              fontFamily: "gilroyMedium",
                            }}
                          >
                            {item.itemCode}
                          </TableCell>

                          <TableCell
                            sx={{
                              fontSize: "14px",
                              px: 1,
                              fontFamily: "gilroyMedium",
                            }}
                          >
                            {item.itemName}
                          </TableCell>

                          <TableCell
                            sx={{
                              fontSize: "14px",
                              px: 1,
                              fontFamily: "gilroyMedium",
                            }}
                          >
                            {item.category || "-"}
                          </TableCell>

                          <TableCell
                            sx={{
                              fontSize: "14px",
                              px: 1,
                              fontFamily: "gilroyMedium",
                            }}
                          >
                            {item.expenseType || item.expense_type || "-"}
                          </TableCell>

                          <TableCell
                            sx={{
                              fontSize: "13px",
                              px: 1,
                              fontFamily: "gilroyMedium",
                              minWidth: "280px",
                            }}
                          >
                            {[
                              ["HSN", item.hsnCode],
                              ["UNSPSC", item.unspscCode],
                              ["Sub-category", item.subCategory],
                              ["Item type", item.itemType],
                              ["Manufacturer part no.", item.partnumber],
                              ["Brand", item.brand],
                              [
                                "Tax",
                                (item.gstList || [])
                                  .map((tax) =>
                                    tax?.country && tax?.gst
                                      ? `${tax.country} - ${tax.gst}%`
                                      : "",
                                  )
                                  .filter(Boolean)
                                  .join(", "),
                              ],
                              ["Specifications", item.specifications],
                              ["Aliases", item.aliases],
                            ].map(([label, value]) => (
                              <Tooltip
                                key={label}
                                title={value || "-"}
                                arrow
                                placement="top"
                                slotProps={{
                                  tooltip: {
                                    sx: {
                                      fontSize: "13px",
                                      fontFamily: "gilroyMedium",
                                    },
                                  },
                                }}
                              >
                                <Box sx={{ display: "flex", gap: 0.5, mb: 0.35 }}>
                                  <Typography
                                    component="span"
                                    sx={{ fontSize: "13px", fontFamily: "gilroyBold" }}
                                  >
                                    {label}:
                                  </Typography>
                                  <Typography
                                    component="span"
                                    sx={{
                                      fontSize: "13px",
                                      fontFamily: "gilroyMedium",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    {value || "-"}
                                  </Typography>
                                </Box>
                              </Tooltip>
                            ))}
                          </TableCell>

                          <TableCell
                            sx={{
                              fontSize: "14px",
                              px: 1,
                              fontFamily: "gilroyMedium",
                            }}
                          >
                            {item.quantity}
                          </TableCell>

                          <TableCell
                            sx={{
                              fontSize: "14px",
                              px: 1,
                              fontFamily: "gilroyMedium",
                            }}
                          >
                            {item.unit}
                          </TableCell>
                          <TableCell
                            sx={{
                              fontSize: "14px",
                              px: 1,
                              fontFamily: "gilroyMedium",
                              maxWidth: "200px",
                            }}
                          >
                            <div
                              style={{
                                display: "-webkit-box",
                                WebkitLineClamp:
                                  expandedRow === index ? "unset" : 2,
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                              }}
                            >
                              {item.description}
                            </div>

                            {item.description?.length > 100 && (
                              <span
                                onClick={() => handleToggle(index)}
                                style={{
                                  color: "#1976d2",
                                  cursor: "pointer",
                                  fontSize: "12.5px",
                                  fontWeight: 500,
                                }}
                              >
                                {expandedRow === index
                                  ? "View Less"
                                  : "View More"}
                              </span>
                            )}
                          </TableCell>

                          <TableCell
                            sx={{
                              fontSize: "14px",
                              px: 1,
                              fontFamily: "gilroyMedium",
                              whiteSpace: "nowrap",
                            }}
                          >
                            ₹{" "}
                            {Number(item.unitPrice).toLocaleString("en-IN", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </TableCell>

                          <TableCell
                            sx={{
                              fontSize: "14px",
                              px: 1,
                              fontFamily: "gilroyMedium",
                              whiteSpace: "nowrap",
                            }}
                          >
                            ₹{" "}
                            {Number(item.totalPrice).toLocaleString("en-IN", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            )}
          </div>

          {(user_access_type !== "Buyer" || (viewpr && !editpr)) &&
            (canEditBudget || budgetRowsToDisplay.length > 0) && (
            <div className={classes.raisePrSection}>
              <HeaderTitle titleText={"Budget"} />

              {canEditBudget && (
                <div className={classes.margincls}>
                  <RadioGroup
                    row
                    value={budgetInputMethod}
                    onChange={(e) => {
                      const nextBudgetMethod = e.target.value;
                      setBudgetInputMethod(nextBudgetMethod);
                      setBudgetUploadError("");
                    }}
                  >
                    <FormControlLabel
                      value="bulk"
                      control={<Radio />}
                      label="Bulk Upload"
                      sx={{ "& .MuiTypography-root": { fontSize: "14px" } }}
                    />
                    <FormControlLabel
                      value="manual"
                      control={<Radio />}
                      label="Enter Details Manually"
                      sx={{ "& .MuiTypography-root": { fontSize: "14px" } }}
                    />
                     
                  </RadioGroup>
                </div>
              )}

              {canEditBudget && budgetInputMethod === "bulk" ? (
                <div className={classes.itemform} style={{ margin: "10px" }}>
                  <div
                    className={`${classes.fileUploadWrapper} ${
                      budgetDragging ? classes.drag_over : ""
                    }`}
                    onDragOver={handleBudgetDragOver}
                    onDragLeave={handleBudgetDragLeave}
                    onDrop={handleBudgetDrop}
                  >
                    <div className={classes.file_upload}>
                      <label className={classes.DocText}>
                        <span>
                          {budgetUploadFile
                            ? budgetUploadFile.name
                            : "Drag and drop budget file here"}
                        </span>
                        <input
                          ref={budgetFileInputRef}
                          type="file"
                          accept={BUDGET_UPLOAD_ACCEPT}
                          style={{ display: "none" }}
                          onChange={handleBudgetFileChange}
                        />
                        <p>(Supported format CSV/Excel)</p>
                      </label>
                      {!budgetUploadFile ? (
                        <button
                          onClick={() => budgetFileInputRef.current?.click()}
                          style={{
                            backgroundColor: "#1976d2",
                            color: "#fff",
                            border: "none",
                            padding: "8px 16px",
                            cursor: "pointer",
                            borderRadius: "4px",
                            fontFamily: "gilroyMedium",
                          }}
                          onMouseOver={(e) =>
                            (e.target.style.backgroundColor = "#1565c0")
                          }
                          onMouseOut={(e) =>
                            (e.target.style.backgroundColor = "#1976d2")
                          }
                        >
                          Browse
                        </button>
                      ) : (
                        <button
                          onClick={clearBudgetUploadFile}
                          style={{
                            backgroundColor: "#d32f2f",
                            color: "#fff",
                            border: "none",
                            padding: "8px 16px",
                            cursor: "pointer",
                            borderRadius: "4px",
                            fontFamily: "gilroyMedium",
                          }}
                          onMouseOver={(e) =>
                            (e.target.style.backgroundColor = "#b71c1c")
                          }
                          onMouseOut={(e) =>
                            (e.target.style.backgroundColor = "#f53c3c")
                          }
                        >
                          Clear
                        </button>
                      )}
                    </div>
                    {budgetUploadError && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "14px",
                          marginTop: "8px",
                          padding: "8px",
                        }}
                      >
                        {budgetUploadError}
                      </div>
                    )}
                  </div>
                  <span className={classes.sampleLinkWrap}>
                    <p
                      className={classes.linkBtn}
                      onClick={handleDownloadBudgetSample}
                    >
                      Sample Excel
                    </p>
                  </span>

                  {budgetUploadFile && budgetRows.length > 0 && (
                    <div style={{ marginTop: "16px" }}>
                      <Typography
                        sx={{
                          fontWeight: 700,
                          color: "#000",
                          fontSize: "14px",
                          fontFamily: "gilroyBold",
                          marginBottom: "8px",
                        }}
                      >
                        Preview ({budgetRows.length} rows)
                      </Typography>

                      <TableContainer component={Paper}>
                        <Table stickyHeader size="small">
                          <TableHead>
                            <TableRow>
                              <TableCell
                                sx={{
                                  fontWeight: 600,
                                  fontSize: "14px",
                                  color: "#1a1a1a",
                                  textAlign: "left",
                                  backgroundColor: "#e8f0f4",
                                  borderBottom: "2px solid #d3e0e8",
                                  whiteSpace: "nowrap",
                                  py: 1,
                                  px: 1,
                                  fontFamily: "gilroyBold",
                                }}
                              >
                                Department
                              </TableCell>
                              <TableCell
                                sx={{
                                  fontWeight: 600,
                                  fontSize: "14px",
                                  color: "#1a1a1a",
                                  textAlign: "left",
                                  backgroundColor: "#e8f0f4",
                                  borderBottom: "2px solid #d3e0e8",
                                  whiteSpace: "nowrap",
                                  py: 1,
                                  px: 1,
                                  fontFamily: "gilroyBold",
                                }}
                              >
                                Cost Center Code
                              </TableCell>
                              <TableCell
                                sx={{
                                  fontWeight: 600,
                                  fontSize: "14px",
                                  color: "#1a1a1a",
                                  textAlign: "left",
                                  backgroundColor: "#e8f0f4",
                                  borderBottom: "2px solid #d3e0e8",
                                  whiteSpace: "nowrap",
                                  py: 1,
                                  px: 1,
                                  fontFamily: "gilroyBold",
                                }}
                              >
                                GL Code
                              </TableCell>
                              <TableCell
                                sx={{
                                  fontWeight: 600,
                                  fontSize: "14px",
                                  color: "#1a1a1a",
                                  textAlign: "left",
                                  backgroundColor: "#e8f0f4",
                                  borderBottom: "2px solid #d3e0e8",
                                  whiteSpace: "nowrap",
                                  py: 1,
                                  px: 1,
                                  fontFamily: "gilroyBold",
                                }}
                              >
                                Project Code
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {budgetRows.map((row, index) => (
                              <TableRow key={index}>
                                <TableCell
                                  sx={{
                                    fontSize: "14px",
                                    px: 1,
                                    fontFamily: "gilroyMedium",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {row?.department || "-"}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    fontSize: "14px",
                                    px: 1,
                                    fontFamily: "gilroyMedium",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {row?.costCentre?.costcenter_code ||
                                    row?.costCentre?.cost_center_code ||
                                    row?.costCentre?.cc_code ||
                                    row?.costCentre?.code ||
                                    row?.costCentre ||
                                    "-"}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    fontSize: "14px",
                                    px: 1,
                                    fontFamily: "gilroyMedium",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {row?.glCode?.gl_code ||
                                    row?.glCode?.glCode ||
                                    row?.glCode?.code ||
                                    row?.glCode ||
                                    "-"}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    fontSize: "14px",
                                    px: 1,
                                    fontFamily: "gilroyMedium",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {row?.projectCode?.project_code ||
                                    row?.projectCode?.projectCode ||
                                    row?.projectCode?.code ||
                                    row?.projectCode ||
                                    "-"}
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                  )}
                </div>
              ) : (
              <div style={{ padding: "10px" }}>
                <TableContainer className={classes.budgetTableWrap}>
                  <Table
                    sx={{
                      width: "auto",
                      tableLayout: "auto",
                      "& .MuiTableBody-root .MuiTableCell-root": {
                        borderBottom: "none",
                      },
                      "& .MuiTableCell-root": {
                        px: 1.5,
                      },
                      "& .MuiTableHead-root .MuiTableCell-root": {
                        backgroundColor: "#e8f0f4",
                        color: "#1a1a1a",
                        fontFamily: "gilroyBold !important",
                        fontWeight: 700,
                        fontSize: "14px",
                        borderBottom: "2px solid #d3e0e8",
                        py: 1.2,
                      },
                      "& .MuiTableBody-root .MuiTableCell-root": {
                        borderBottom: "1px solid #edf2f7",
                        py: 1.1,
                      },
                      "& .MuiTableBody-root .MuiTypography-root": {
                        color: "#1f2937 !important",
                        fontFamily: "gilroyMedium !important",
                        fontWeight: "500 !important",
                        fontSize: "14px !important",
                      },
                    }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{
                            fontSize: "14px",
                            fontWeight: 600,
                            fontFamily: "gilroyBold",
                          }}
                        >
                          <strong>Cost Center Code</strong>
                        </TableCell>
                        <TableCell
                          sx={{
                            fontSize: "14px",
                            fontWeight: 600,
                            fontFamily: "gilroyBold",
                          }}
                        >
                          <strong>GL Code</strong>
                        </TableCell>
                        <TableCell
                          sx={{
                            fontSize: "14px",
                            fontWeight: 600,
                            fontFamily: "gilroyBold",
                          }}
                        >
                          <strong>Project Code</strong>
                        </TableCell>
                        {canEditBudget && showBudgetRowActions && <TableCell />}
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {budgetRowsToDisplay.map((row, index) => {
                        const shouldShowDepartmentTooltip =
                          !selectedDepartmentNameNormalized &&
                          !(viewpr && !editpr);
                        const budgetFieldDisabled =
                          (viewpr && !editpr) ||
                          !selectedDepartmentNameNormalized;
                        const tooltipSx = {
                          fontSize: "14px",
                          fontFamily: "gilroyMedium",
                        };

                        return (
                          <TableRow key={index}>
                            <TableCell>
                              {viewpr && !editpr ? (
                                <Typography
                                  sx={{
                                    fontWeight: 700,
                                    color: "#000",
                                    fontSize: "14px",
                                    fontFamily: "gilroyBold",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {row?.costCentre?.costcenter_code ||
                                    row?.costCentre?.cost_center_code ||
                                    row?.costCentre?.cc_code ||
                                    row?.costCentre?.code ||
                                    row?.costCentre ||
                                    "-"}
                                </Typography>
                              ) : (
                                <Tooltip
                                  title={
                                    shouldShowDepartmentTooltip
                                      ? "Choose the department"
                                      : ""
                                  }
                                  placement="top"
                                  arrow
                                  disableHoverListener={
                                    !shouldShowDepartmentTooltip
                                  }
                                  disableFocusListener={
                                    !shouldShowDepartmentTooltip
                                  }
                                  disableTouchListener={
                                    !shouldShowDepartmentTooltip
                                  }
                                  slotProps={{ tooltip: { sx: tooltipSx } }}
                                >
                                  <span
                                    className={classes.budgetField}
                                    style={{ display: "block" }}
                                  >
                                    <Autocomplete
                                      options={filteredCostCenters}
                                      getOptionLabel={(option) =>
                                        option?.costcenter_code ||
                                        option?.cost_center_code ||
                                        option?.cc_code ||
                                        option?.code ||
                                        ""
                                      }
                                      value={row.costCentre || null}
                                      disableClearable={!row?.costCentre}
                                      onChange={(e, value) =>
                                        handleChange(index, "costCentre", value)
                                      }
                                      isOptionEqualToValue={(option, value) => {
                                        if (option?.id && value?.id) {
                                          return option.id === value.id;
                                        }
                                        const optCode =
                                          option?.costcenter_code ||
                                          option?.cost_center_code ||
                                          option?.cc_code ||
                                          option?.code ||
                                          "";
                                        const valCode =
                                          value?.costcenter_code ||
                                          value?.cost_center_code ||
                                          value?.cc_code ||
                                          value?.code ||
                                          "";
                                        return (
                                          String(optCode) === String(valCode)
                                        );
                                      }}
                                      disabled={budgetFieldDisabled}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          placeholder="Select Cost Centre"
                                          size="small"
                                          sx={{
                                            "& .MuiInputBase-root": {
                                              fontSize: "14px",
                                            },
                                            "& .MuiInputLabel-root": {
                                              fontSize: "14px",
                                            },
                                            "& .MuiAutocomplete-input": {
                                              fontSize: "14px",
                                            },
                                          }}
                                        />
                                      )}
                                    />
                                  </span>
                                </Tooltip>
                              )}
                            </TableCell>
                            <TableCell>
                              {viewpr && !editpr ? (
                                <Typography
                                  sx={{
                                    fontWeight: 700,
                                    color: "#000",
                                    fontSize: "14px",
                                    fontFamily: "gilroyBold",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {row?.glCode?.gl_code ||
                                    row?.glCode?.gl_code_value ||
                                    row?.glCode?.code ||
                                    row?.glCode ||
                                    "-"}
                                </Typography>
                              ) : (
                                <Tooltip
                                  title={
                                    shouldShowDepartmentTooltip
                                      ? "Choose the department"
                                      : ""
                                  }
                                  placement="top"
                                  arrow
                                  disableHoverListener={
                                    !shouldShowDepartmentTooltip
                                  }
                                  disableFocusListener={
                                    !shouldShowDepartmentTooltip
                                  }
                                  disableTouchListener={
                                    !shouldShowDepartmentTooltip
                                  }
                                  slotProps={{ tooltip: { sx: tooltipSx } }}
                                >
                                  <span
                                    className={classes.budgetField}
                                    style={{ display: "block" }}
                                  >
                                    <Autocomplete
                                      options={filteredGLCodes}
                                      getOptionLabel={(option) =>
                                        option?.gl_code ||
                                        option?.gl_code_value ||
                                        option?.glCode ||
                                        option?.code ||
                                        ""
                                      }
                                      value={row.glCode || null}
                                      disableClearable={!row?.glCode}
                                      onChange={(e, value) =>
                                        handleChange(index, "glCode", value)
                                      }
                                      isOptionEqualToValue={(option, value) => {
                                        if (option?.id && value?.id) {
                                          return option.id === value.id;
                                        }
                                        const optCode =
                                          option?.gl_code ||
                                          option?.gl_code_value ||
                                          option?.glCode ||
                                          option?.code ||
                                          "";
                                        const valCode =
                                          value?.gl_code ||
                                          value?.gl_code_value ||
                                          value?.glCode ||
                                          value?.code ||
                                          "";
                                        return String(optCode) === String(valCode);
                                      }}
                                      disabled={budgetFieldDisabled}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          placeholder="Select GL Code"
                                          size="small"
                                          sx={{
                                            "& .MuiInputBase-root": {
                                              fontSize: "14px",
                                            },
                                            "& .MuiInputLabel-root": {
                                              fontSize: "14px",
                                            },
                                            "& .MuiAutocomplete-input": {
                                              fontSize: "14px",
                                            },
                                          }}
                                        />
                                      )}
                                    />
                                  </span>
                                </Tooltip>
                              )}
                            </TableCell>
                            <TableCell>
                              {viewpr && !editpr ? (
                                <Typography
                                  sx={{
                                    fontWeight: 700,
                                    color: "#000",
                                    fontSize: "14px",
                                    fontFamily: "gilroyBold",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {row?.projectCode?.project_code ||
                                    row?.projectCode?.project_code_value ||
                                    row?.projectCode?.code ||
                                    row?.projectCode ||
                                    "-"}
                                </Typography>
                              ) : (
                                <Tooltip
                                  title={
                                    shouldShowDepartmentTooltip
                                      ? "Choose the department"
                                      : ""
                                  }
                                  placement="top"
                                  arrow
                                  disableHoverListener={
                                    !shouldShowDepartmentTooltip
                                  }
                                  disableFocusListener={
                                    !shouldShowDepartmentTooltip
                                  }
                                  disableTouchListener={
                                    !shouldShowDepartmentTooltip
                                  }
                                  slotProps={{ tooltip: { sx: tooltipSx } }}
                                >
                                  <span
                                    className={classes.budgetField}
                                    style={{ display: "block" }}
                                  >
                                    <Autocomplete
                                      options={filteredProjectCodes}
                                      getOptionLabel={(option) =>
                                        option?.project_code ||
                                        option?.project_code_value ||
                                        option?.projectCode ||
                                        option?.code ||
                                        ""
                                      }
                                      value={row.projectCode || null}
                                      disableClearable={!row?.projectCode}
                                      onChange={(e, value) =>
                                        handleChange(index, "projectCode", value)
                                      }
                                      isOptionEqualToValue={(option, value) => {
                                        if (option?.id && value?.id) {
                                          return option.id === value.id;
                                        }
                                        const optCode =
                                          option?.project_code ||
                                          option?.project_code_value ||
                                          option?.projectCode ||
                                          option?.code ||
                                          "";
                                        const valCode =
                                          value?.project_code ||
                                          value?.project_code_value ||
                                          value?.projectCode ||
                                          value?.code ||
                                          "";
                                        return (
                                          String(optCode) === String(valCode)
                                        );
                                      }}
                                      disabled={budgetFieldDisabled}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          placeholder="Select Project Code"
                                          size="small"
                                          sx={{
                                            "& .MuiInputBase-root": {
                                              fontSize: "14px",
                                            },
                                            "& .MuiInputLabel-root": {
                                              fontSize: "14px",
                                            },
                                            "& .MuiAutocomplete-input": {
                                              fontSize: "14px",
                                            },
                                          }}
                                        />
                                      )}
                                    />
                                  </span>
                                </Tooltip>
                              )}
                            </TableCell>

                            {canEditBudget && showBudgetRowActions && (
                              <TableCell>
                                {budgetRows.length > 1 && index > 0 && (
                                  <IconButton
                                    onClick={() => removeBudgetRow(index)}
                                    sx={{
                                      color: "#d32f2f",
                                      "&:hover": { backgroundColor: "rgba(211,47,47,0.08)" },
                                    }}
                                  >
                                    <DeleteIcon sx={{ fontSize: 22 }} />
                                  </IconButton>
                                )}
                                {index === budgetRows.length - 1 &&
                                  canAddBudgetRow && (
                                  <IconButton
                                    onClick={addBudgetRow}
                                    sx={{
                                      color: "#1976d2",
                                      "&:hover": { backgroundColor: "rgba(25,118,210,0.08)" },
                                    }}
                                  >
                                    <AddIcon sx={{ fontSize: 22 }} />
                                  </IconButton>
                                )}
                              </TableCell>
                            )}
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
              )}
            </div>
          )}

          {
            <div>
              {viewraisedpr && <HeaderTitle titleText={"Approvers"} />}

	              <div>
	                <div className={classes.margincls}>
	                  {selectedApprovers.length > 0 && (
	                    <TableContainer
	                      component={Paper}
	                      sx={{ marginTop: "20px" }}
	                    >
                      <Table stickyHeader size="small">
                        <TableHead>
                          <TableRow>
                            {[
                              "First Name",
                              "Last Name",
                              "Email",
                              "Designation",
                              "Phone Number",
                              ...(!proceedRFQ ? ["Status"] : []),
                            ].map((header) => (
                              <TableCell
                                key={header}
                                sx={{
                                  fontWeight: 600,
                                  fontSize: "14px",
                                  color: "#1a1a1a",
                                  textAlign: "left",
                                  backgroundColor: "#e8f0f4",
                                  borderBottom: "2px solid #d3e0e8",
                                  whiteSpace: "nowrap",
                                  py: 1,
                                  px: 1,
                                  fontFamily: "gilroyBold",
                                }}
                              >
                                {header}
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {selectedApprovers.map((approver, index) => (
                            <TableRow
                              key={index}
                              hover
                              sx={{
                                "&:hover": { backgroundColor: "#f9fbfd" },
                                transition: "0.2s ease",
                              }}
                            >
                              <TableCell
                                sx={{
                                  fontSize: "14px",
                                  px: 1,
                                  fontFamily: "gilroyMedium",
                                }}
                              >
                                {approver.first_name}
                              </TableCell>

                              <TableCell
                                sx={{
                                  fontSize: "14px",
                                  px: 1,
                                  fontFamily: "gilroyMedium",
                                }}
                              >
                                {approver.last_name || "-"}
                              </TableCell>

                              <TableCell
                                sx={{
                                  fontSize: "14px",
                                  px: 1,
                                  fontFamily: "gilroyMedium",
                                }}
                              >
                                {approver.email || "-"}
                              </TableCell>

                              <TableCell
                                sx={{
                                  fontSize: "14px",
                                  px: 1,
                                  fontFamily: "gilroyMedium",
                                }}
                              >
                                {approver.designation || "-"}
                              </TableCell>

                              <TableCell
                                sx={{
                                  fontSize: "14px",
                                  px: 1,
                                  fontFamily: "gilroyMedium",
                                }}
                              >
                                {approver.phone_number || "-"}
                              </TableCell>

                              {!proceedRFQ && (
                                <TableCell
                                  sx={{
                                    fontSize: "14px",
                                    px: 1,
                                    fontFamily: "gilroyMedium",
                                  }}
                                >
                                  {approver.status || "Pending"}
                                </TableCell>
                              )}
                            </TableRow>
                          ))}
	                        </TableBody>
	                      </Table>
	                    </TableContainer>
	                  )}

	                  {viewraisedpr &&
	                    selectedDepartmentNameNormalized &&
	                    selectedApprovers.length === 0 && (
		                      <Typography
		                        sx={{
		                          marginTop: "20px",
		                          fontSize: "16px",
		                          fontFamily: "gilroyMedium",
		                          color: "#d32f2f",
		                        }}
		                      >
	                        No Approver mapped for this department
	                      </Typography>
	                    )}
	                </div>
	              </div>
            </div>
          }

          {user_access_type === "User" && proceedRFQ && (editpr || !viewpr) && (
            <div>
              <Dbutton
                label={
                  loadingPR
                    ? editpr
                      ? "Updating..."
                      : "Creating..."
                    : editpr
                      ? "Update PR"
                      : "Create PR"
                }
                onClick={handleSavePurchaseRequest}
                disabled={loadingPR}
              />

              {loadingPR && (
                <CircularProgress size={20} style={{ marginLeft: "10px" }} />
              )}
            </div>
          )}
        </div>
      )}

      <Modal open={successpopup}>
        <Fade in={successpopup}>
          <Box>
            <SuccessPopupDashboard
              popupImage={successPopupImg}
              popupHeroText={getuserpopupherotext}
              popupDescription={getuserpopupdescription}
              popBtn={true}
              vendorBtn={true}
              btnText={"Okay"}
              btnClick={handleBack}
            />
          </Box>
        </Fade>
      </Modal>
    </div>
  );
};
